import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
  _Any: any;
  _FieldSet: any;
};

export type AcceptConnectionInviteInput = {
  id: Scalars['ID'];
  targetOrganizationId: Scalars['ID'];
};

export type Activity = {
  internal?: Maybe<Array<Maybe<ListingActivity>>>;
  receivingOrganization?: Maybe<Organization>;
  sharedBy?: Maybe<Array<Maybe<ListingActivity>>>;
  sharedWith?: Maybe<Array<Maybe<ListingActivity>>>;
  sharingOrganization?: Maybe<Organization>;
};

export enum ActivityChannel {
  Listing = 'Listing'
}

export type ActivityChannelStatus = {
  userBecameActive?: Maybe<UserChannelActivity>;
  userBecameInactive?: Maybe<UserChannelActivity>;
  users?: Maybe<Array<UserChannelActivity>>;
};

export type AddDeductOption = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AddDeviceTokenInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  os?: InputMaybe<Os>;
  token: Scalars['String'];
};

export type Answer = {
  code?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  extra?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type AnswerInput = {
  code?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  extra?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Appraisal = {
  amount?: Maybe<Scalars['Int']>;
  crGrade?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listingId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  previousValue?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AssignTradeToVehicleInput = {
  /** The trade to be assigned to the vehicle, if not provided, the current trade will be reassigned */
  trade?: InputMaybe<Trades>;
  vehicleId: Scalars['String'];
  vendorId?: InputMaybe<Scalars['String']>;
};

export type BaseDecode = {
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  styles?: Maybe<Array<Maybe<Style>>>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type BaseUser = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type BooleanFilter = {
  field: Scalars['String'];
  nestedField?: InputMaybe<Scalars['String']>;
  operator: BooleanOperators;
};

export type BooleanOperators = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

export enum BulkActionType {
  ShareListing = 'SHARE_LISTING',
  ToggleSaveListing = 'TOGGLE_SAVE_LISTING',
  UpdateListingCurrentStatus = 'UPDATE_LISTING_CURRENT_STATUS',
  UpdateListingTags = 'UPDATE_LISTING_TAGS'
}

export type BulkProcess = {
  actionType: BulkActionType;
  actor?: Maybe<User>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  status: BulkProcessStatus;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BulkProcessStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type BulkShareListingsInput = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  query?: InputMaybe<Scalars['String']>;
  receivingOrganizationId?: InputMaybe<Scalars['String']>;
  receivingUserEmail?: InputMaybe<Scalars['String']>;
  sharingOrganizationId?: InputMaybe<Scalars['String']>;
};

export type BulkToggleSaveListingsInput = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  query?: InputMaybe<Scalars['String']>;
  save: Scalars['Boolean'];
};

export type BulkUpdateListingsCurrentStatusInput = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  organizationListingStatusId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateListingsTagsInput = {
  excludedTags: Array<InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  includedTags: Array<InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type Buyer = {
  address: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type BuyerConnection = {
  nodes?: Maybe<Array<Maybe<Buyer>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CompleteReconInput = {
  vehicleId: Scalars['String'];
};

export type CompleteReconTradeInput = {
  repairPrice?: InputMaybe<Scalars['Float']>;
  vehicleId: Scalars['String'];
};

export type ConfigureIntegrationAttributeInput = {
  integrationAttributeId: Scalars['ID'];
  value: Scalars['String'];
};

export type ConfigureIntegrationInput = {
  attributes?: InputMaybe<Array<InputMaybe<ConfigureIntegrationAttributeInput>>>;
  integrationId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type Connection = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  invite?: Maybe<ConnectionInvite>;
  inviteId?: Maybe<Scalars['ID']>;
  originOrganization?: Maybe<Organization>;
  originOrganizationId: Scalars['ID'];
  originUser?: Maybe<User>;
  originUserId: Scalars['ID'];
  targetOrganization?: Maybe<Organization>;
  targetOrganizationId: Scalars['ID'];
  targetUser?: Maybe<User>;
  targetUserId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type ConnectionInvite = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  originOrganization?: Maybe<Organization>;
  originOrganizationId: Scalars['ID'];
  originUser?: Maybe<User>;
  originUserId: Scalars['ID'];
  resolvedAt?: Maybe<Scalars['Date']>;
  status: ConnectionInviteStatus;
  targetEmail: Scalars['String'];
  targetOrganization?: Maybe<Organization>;
  targetOrganizationId?: Maybe<Scalars['ID']>;
  targetUser?: Maybe<User>;
  updatedAt: Scalars['Date'];
};

export type ConnectionInviteConnection = {
  nodes?: Maybe<Array<Maybe<ConnectionInvite>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ConnectionInviteStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Deleted = 'deleted',
  Pending = 'pending'
}

export type ConnectionModelConnection = {
  nodes?: Maybe<Array<Maybe<Connection>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CreateAppraisalInput = {
  amount: Scalars['Int'];
  crGrade: Scalars['Float'];
  listingId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateBulkVehicles = {
  errors?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  totalCount: Scalars['Int'];
  totalCreated: Scalars['Int'];
};

export type CreateBuyerInput = {
  address: Scalars['String'];
  listingId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type CreateConnectionInviteInput = {
  originOrganizationId: Scalars['Int'];
  targetEmail: Scalars['String'];
};

export type CreateDocumentInput = {
  listingId: Scalars['String'];
  name: Scalars['String'];
  type: DocumentType;
  url: Scalars['String'];
};

export type CreateExpenseInput = {
  amount: Scalars['Float'];
  description: Scalars['String'];
  documentName?: InputMaybe<Scalars['String']>;
  expenseDate: Scalars['Date'];
  listingId: Scalars['String'];
  type: ExpenseType;
  url?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CreateListingImportInput = {
  delimiter?: InputMaybe<Scalars['String']>;
  mapping: ListingImportColumnMappingsInput;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  s3FileUri: Scalars['String'];
};

export type CreateListingInternalValuationInput = {
  amount: Scalars['Int'];
  crGrade: Scalars['Float'];
  listingId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateListingOfferInput = {
  amount: Scalars['Int'];
  listingId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateListingValuationInput = {
  amount: Scalars['Float'];
  extra?: InputMaybe<Scalars['JSON']>;
  listingId: Scalars['String'];
  type: Scalars['String'];
};

export type CreateNoteInput = {
  listingId: Scalars['String'];
  note: Scalars['String'];
  tag?: InputMaybe<NoteTag>;
  userOnly?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dealerships?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationStatusInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateOrganizationTagInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreatePurchaseSourceInput = {
  listingId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateRoomMessageInput = {
  listingId?: InputMaybe<Scalars['ID']>;
  /** receiverEmail is used in case the receiver is not a registered user */
  receiverEmail?: InputMaybe<Scalars['String']>;
  /** receiverId is used in case no roomId is specified and the room type is InOrgDirect or for specifying the receiver Organization in a OrgInviteRoom */
  receiverId?: InputMaybe<Scalars['ID']>;
  roomId?: InputMaybe<Scalars['ID']>;
  roomType?: InputMaybe<RoomType>;
  /** senderOrganizationId represents the organization from where the message is sent */
  senderOrganizationId?: InputMaybe<Scalars['String']>;
  sentAt: Scalars['Date'];
  /** Message Text */
  text: Scalars['String'];
  /** vehicleId is used in case no roomId is specified and the room type is one of InternalVehicle, VinCar or OrgInvite */
  vehicleId?: InputMaybe<Scalars['ID']>;
};

export type CreateUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
};

export type CreateVehicleInput = {
  auctionLane?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  auctionRunNumber?: InputMaybe<Scalars['String']>;
  csvUnmappedData?: InputMaybe<Scalars['JSON']>;
  displayName?: InputMaybe<Scalars['String']>;
  drivetrain?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['Date']>;
  engine?: InputMaybe<Scalars['String']>;
  exteriorColor?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['Float']>;
  interiorColor?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['ID']>;
  make?: InputMaybe<Scalars['String']>;
  mmr?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['Int']>;
  odometerUnit?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Array<VehiclePictureInput>>;
  provider?: InputMaybe<Scalars['String']>;
  providerInternalVehicleID?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  reconData?: InputMaybe<ReconDataInput>;
  sellPrice?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['Date']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  submitterId?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
  year?: InputMaybe<Scalars['Int']>;
};

export type CreateVendorInput = {
  listingId: Scalars['String'];
  name: Scalars['String'];
};

export type DateFilter = {
  field: Scalars['String'];
  operator: DateOperators;
};

export type DateOperators = {
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type DateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type Decode = {
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  styleId?: Maybe<Scalars['String']>;
  styleName?: Maybe<Scalars['String']>;
  /** Base valuation for the car */
  valuations?: Maybe<VehicleConditionValuation>;
  /** Valuations based on mileage ranges and condition */
  valuationsByMileage?: Maybe<Array<Maybe<MileageValuation>>>;
  vehiclePhoto?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type DecodeInput = {
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  styleId?: InputMaybe<Scalars['String']>;
  styleName?: InputMaybe<Scalars['String']>;
  valuations?: InputMaybe<VehicleConditionValuationInput>;
  valuationsByMileage?: InputMaybe<Array<InputMaybe<MileageValuationInput>>>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type DeviceToken = {
  appVersion?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  os?: Maybe<Os>;
  token: Scalars['String'];
};

export type Document = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: DocumentType;
  updatedAt: Scalars['Date'];
  uploadedAt: Scalars['Date'];
  url: Scalars['String'];
};

export enum DocumentSortField {
  Name = 'Name',
  Type = 'Type',
  UploadedAt = 'UploadedAt'
}

export type DocumentSortFieldInput = {
  ascending: Scalars['Boolean'];
  field: DocumentSortField;
};

export enum DocumentType {
  Bol = 'BOL',
  Bos = 'BOS',
  GatePass = 'GATE_PASS',
  Other = 'OTHER',
  Title = 'TITLE',
  WindowSticker = 'WINDOW_STICKER'
}

export type Expense = {
  amount: Scalars['Float'];
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  documentName?: Maybe<Scalars['String']>;
  expenseDate: Scalars['Date'];
  id: Scalars['ID'];
  type: ExpenseType;
  updatedAt: Scalars['Date'];
  uploadedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
};

export enum ExpenseSortField {
  Amount = 'Amount',
  Description = 'Description',
  DocumentName = 'DocumentName',
  ExpenseDate = 'ExpenseDate',
  Type = 'Type',
  Vendor = 'Vendor'
}

export type ExpenseSortFieldInput = {
  ascending: Scalars['Boolean'];
  field: ExpenseSortField;
};

export enum ExpenseType {
  Admin = 'Admin',
  Other = 'Other',
  Recon = 'Recon',
  Transportation = 'Transportation'
}

export type FilterElement = {
  count: Scalars['Int'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Image = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ImageInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type InspectVehicleInput = {
  auctionLane?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  auctionRunNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  drivetrain?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['Date']>;
  engine?: InputMaybe<Scalars['String']>;
  exteriorColor?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  interiorColor?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  mmr?: InputMaybe<Scalars['Int']>;
  model: Scalars['String'];
  odometer?: InputMaybe<Scalars['Int']>;
  odometerUnit?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Array<VehiclePictureInput>>;
  reconData?: InputMaybe<ReconDataInput>;
  startTime?: InputMaybe<Scalars['Date']>;
  submissionId?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim: Scalars['String'];
  year: Scalars['Int'];
};

export type Integration = {
  attributes?: Maybe<Array<Maybe<IntegrationAttribute>>>;
  configuration?: Maybe<IntegrationConfiguration>;
  configurationUser?: Maybe<IntegrationConfigurationUser>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  provider?: Maybe<IntegrationProvider>;
  type?: Maybe<IntegrationType>;
};

export type IntegrationAttribute = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IntegrationConfiguration = {
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['String']>;
};

export type IntegrationConfigurationUser = {
  attributes?: Maybe<Array<Maybe<IntegrationConfigurationUserAttribute>>>;
  id: Scalars['ID'];
  integrationId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IntegrationConfigurationUserAttribute = {
  attribute?: Maybe<IntegrationAttribute>;
  id: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
};

export type IntegrationConnection = {
  nodes?: Maybe<Array<Maybe<Integration>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type IntegrationProvider = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type IntegrationType = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type IntegrationsInput = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type InternalValuation = {
  amount: Scalars['Int'];
  crGrade: Scalars['Float'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId: Scalars['String'];
  id: Scalars['ID'];
  listingId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type Invite = {
  acceptedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  createdByUserId: Scalars['ID'];
  declinedAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  inviter?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  owner: Scalars['Boolean'];
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
};

export type InviteInput = {
  email: Scalars['String'];
  organizationId: Scalars['ID'];
  /** Whether the invited user should become an owner of the organization. Default is false. */
  owner?: InputMaybe<Scalars['Boolean']>;
};

export type Lead = {
  addDeductCodes?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  leadConsumer?: Maybe<LeadConsumer>;
  licensePlate?: Maybe<Scalars['String']>;
  licensePlateState?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  odometer: Scalars['Int'];
  range: Range;
  trim: Scalars['String'];
  updatedAt: Scalars['Date'];
  uvc: Scalars['String'];
  valuationZip: Scalars['String'];
  verified: Scalars['Boolean'];
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type LeadConsumer = {
  createdAt: Scalars['Date'];
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  phoneVerified: Scalars['Boolean'];
  registrationOrganizationId: Scalars['ID'];
  updatedAt: Scalars['Date'];
  userId?: Maybe<Scalars['ID']>;
};

export type LicensePlateInput = {
  licensePlate: Scalars['String'];
  state: Scalars['String'];
};

export type Listing = {
  activity?: Maybe<Activity>;
  appraisals?: Maybe<Array<Maybe<Appraisal>>>;
  currentInternalValuation?: Maybe<InternalValuation>;
  currentOffer?: Maybe<Offer>;
  currentStatus?: Maybe<WorkflowStatus>;
  documents?: Maybe<Array<Maybe<Document>>>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  expensesCosts: Scalars['Float'];
  id: Scalars['ID'];
  internalValuationHistory?: Maybe<Array<Maybe<InternalValuation>>>;
  lead?: Maybe<Lead>;
  listingType: ListingType;
  offerHistory?: Maybe<Array<Maybe<Offer>>>;
  parentListing?: Maybe<Listing>;
  purchaseInformation?: Maybe<PurchaseInformation>;
  receivingOrganization?: Maybe<Organization>;
  receivingOrganizationId?: Maybe<Scalars['String']>;
  receivingUser?: Maybe<User>;
  receivingUserEmail?: Maybe<Scalars['String']>;
  receivingUserId?: Maybe<Scalars['String']>;
  saleInformation?: Maybe<SaleInformation>;
  saved?: Maybe<Scalars['Boolean']>;
  shared?: Maybe<Scalars['Boolean']>;
  sharingOrganization?: Maybe<Organization>;
  sharingOrganizationId?: Maybe<Scalars['String']>;
  sharingUser?: Maybe<User>;
  sharingUserId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<WorkflowStatus>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  totalCosts: Scalars['Float'];
  totalProfit: Scalars['Float'];
  valuations?: Maybe<Array<Maybe<ListingValuation>>>;
  vehicle?: Maybe<Vehicle>;
};


export type ListingDocumentsArgs = {
  sort?: InputMaybe<DocumentSortFieldInput>;
};


export type ListingExpensesArgs = {
  sort?: InputMaybe<ExpenseSortFieldInput>;
};

export type ListingActivity = {
  organization?: Maybe<Organization>;
  parentListingId?: Maybe<Scalars['ID']>;
  receivingUserEmail?: Maybe<Scalars['String']>;
  /** This type may seem redundant, but in te future we may want to add more fields to the activity. */
  room?: Maybe<Room>;
  user?: Maybe<User>;
};

export type ListingConnection = {
  nodes?: Maybe<Array<Maybe<Listing>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ListingHistory = {
  changeLog?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUser?: Maybe<User>;
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  listingId?: Maybe<Scalars['String']>;
  messageHtml?: Maybe<Scalars['String']>;
  messageText?: Maybe<Scalars['String']>;
  messages?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ListingHistoryConnection = {
  nodes?: Maybe<Array<Maybe<ListingHistory>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ListingImport = {
  createdAt?: Maybe<Scalars['Date']>;
  createdByUserId?: Maybe<Scalars['String']>;
  delimiter?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mapping: ListingImportColumnMappings;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  processingResult?: Maybe<Scalars['String']>;
  processingStatus: ListingImportProcessingStatus;
  s3FileUri: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ListingImportColumnMappings = {
  auctionLane?: Maybe<Scalars['Int']>;
  auctionName?: Maybe<Scalars['Int']>;
  auctionRunNumber?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['Int']>;
  drivetrain?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['Int']>;
  exteriorColor?: Maybe<Scalars['Int']>;
  grade?: Maybe<Scalars['Int']>;
  interiorColor?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['Int']>;
  mmr?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['Int']>;
  odometer?: Maybe<Scalars['Int']>;
  odometerUnit?: Maybe<Scalars['Int']>;
  pictures?: Maybe<Scalars['Int']>;
  providerInternalVehicleID?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  transmission?: Maybe<Scalars['Int']>;
  trim?: Maybe<Scalars['Int']>;
  vehicleType?: Maybe<Scalars['Int']>;
  vin: Scalars['Int'];
  year?: Maybe<Scalars['Int']>;
};

export type ListingImportColumnMappingsInput = {
  auctionLane?: InputMaybe<Scalars['Int']>;
  auctionName?: InputMaybe<Scalars['Int']>;
  auctionRunNumber?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['Int']>;
  drivetrain?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Int']>;
  engine?: InputMaybe<Scalars['Int']>;
  exteriorColor?: InputMaybe<Scalars['Int']>;
  grade?: InputMaybe<Scalars['Int']>;
  interiorColor?: InputMaybe<Scalars['Int']>;
  make?: InputMaybe<Scalars['Int']>;
  mmr?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['Int']>;
  odometer?: InputMaybe<Scalars['Int']>;
  odometerUnit?: InputMaybe<Scalars['Int']>;
  pictures?: InputMaybe<Scalars['Int']>;
  providerInternalVehicleID?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  transmission?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Int']>;
  vehicleType?: InputMaybe<Scalars['Int']>;
  vin: Scalars['Int'];
  year?: InputMaybe<Scalars['Int']>;
};

export type ListingImportConnection = {
  nodes?: Maybe<Array<Maybe<ListingImport>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ListingImportProcessingStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Processing = 'Processing'
}

export enum ListingStatus {
  Archived = 'archived',
  InTransit = 'inTransit',
  Opportunity = 'opportunity',
  Owned = 'owned',
  Sold = 'sold',
  Void = 'void'
}

export enum ListingType {
  Consumer = 'Consumer',
  Inception = 'Inception',
  Shared = 'Shared'
}

export type ListingValuation = {
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUser?: Maybe<User>;
  extra?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  listingId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type LiveActivityUser = {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Location = {
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type MakeDrilldown = {
  makeValue: Scalars['String'];
  modelDrilldown: Array<ModelDrilldown>;
};

export type MakeModelCombination = {
  make: Scalars['String'];
  model: Array<Scalars['String']>;
};

export type MakeModelFilter = {
  combinations: Array<MakeModelCombination>;
};

export type MarkRoomAsReadInput = {
  roomId: Scalars['ID'];
};

export enum MemberRole {
  Member = 'Member',
  Owner = 'Owner'
}

export type Message = {
  html?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type MessageConnection = {
  nodes?: Maybe<Array<Maybe<RoomMessage>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Messages = {
  en?: Maybe<Message>;
  es?: Maybe<Message>;
};

export type MileageValuation = {
  conditionValues?: Maybe<VehicleConditionValuation>;
  rangeBegin?: Maybe<Scalars['Int']>;
  rangeEnd?: Maybe<Scalars['Int']>;
};

export type MileageValuationInput = {
  conditionValues?: InputMaybe<VehicleConditionValuationInput>;
  rangeBegin?: InputMaybe<Scalars['Int']>;
  rangeEnd?: InputMaybe<Scalars['Int']>;
};

export type ModelDrilldown = {
  modelValue: Scalars['String'];
  trimDrilldown: Array<TrimDrilldown>;
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']>;
  /** Accepts a Connection Invite */
  acceptConnectionInvite?: Maybe<ConnectionInvite>;
  /** Accepts an invite with the passed id */
  acceptInvite?: Maybe<Invite>;
  addDeviceToken?: Maybe<DeviceToken>;
  /** Assigns a trade to a vehicle or reassigns the current one */
  assignTradeToVehicle?: Maybe<Vehicle>;
  /** Shares listings in bulk with a user and/or an organization. */
  bulkShareListings: BulkProcess;
  /** Save/unsaved listings in bulk for the user */
  bulkToggleSaveListings: BulkProcess;
  /** Updates the status of listings in bulk */
  bulkUpdateListingsCurrentStatus: BulkProcess;
  /** Updates listings tags in bulk. */
  bulkUpdateListingsTags: BulkProcess;
  /** Associates an unclaimed valuation to the calling consumer */
  claimWidgetValuation?: Maybe<Scalars['Boolean']>;
  clickNotification?: Maybe<Scalars['Boolean']>;
  /** Marks the Recon process as Completed */
  completeRecon?: Maybe<Scalars['Boolean']>;
  /** Marks the Current Vehicle Trade as Completed */
  completeReconTrade?: Maybe<Scalars['Boolean']>;
  /** Configure an integration for a particular organization with the current user */
  configureIntegration?: Maybe<Scalars['Boolean']>;
  /** Creates an Appraisal */
  createAppraisal?: Maybe<Appraisal>;
  /** Creates Vehicles for a bulk input */
  createBulkVehicles?: Maybe<CreateBulkVehicles>;
  /** Creates a buyer for a listing organization, if there is no receiving organization, it will be created for the listing */
  createBuyer?: Maybe<Buyer>;
  /** Creates a new Connection Invite */
  createConnectionInvite?: Maybe<ConnectionInvite>;
  /** Creates a document for a listing */
  createDocument?: Maybe<Document>;
  /** Creates an expense for a listing */
  createExpense?: Maybe<Expense>;
  /** Creates an invite with the passed params and the authenticated user as the inviter */
  createInvite?: Maybe<Invite>;
  /** Creates a Listing Import */
  createListingImport?: Maybe<ListingImport>;
  /** Creates a Listing Internal Valuation */
  createListingInternalValuation?: Maybe<InternalValuation>;
  /** Creates a Listing Offer */
  createListingOffer?: Maybe<Offer>;
  /** Creates a Listing Valuation */
  createListingValuation?: Maybe<ListingValuation>;
  createMessage?: Maybe<RoomMessage>;
  /** Creates a Listing Note */
  createNote?: Maybe<Note>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /**
   * Creates a listing status for the given organization.
   * Admins can add statuses to any organization; owners can only add to organizations they own.
   */
  createOrganizationStatus: OrganizationListingStatus;
  /**
   * Creates a tag for the given organization.
   * Admins can add tags to any organization; owners can only add to organizations they own.
   * The organization must have dynamicStatusesEnabled.
   */
  createOrganizationTag: Tag;
  /** Creates a purchaseSource for a listing organization, if there is no receiving organization, it will be created for the listing */
  createPurchaseSource?: Maybe<PurchaseSource>;
  /** Creates an user with with the information sent from global */
  createUser?: Maybe<User>;
  /** Creates a Vehicle requiring a basic dataset */
  createVehicle?: Maybe<Vehicle>;
  /** Creates a vendor for a listing organization, if there is no receiving organization, it will be created for the listing */
  createVendor?: Maybe<Vendor>;
  /** Declines a Connection Invite */
  declineConnectionInvite?: Maybe<ConnectionInvite>;
  /** Declines an invite with the id */
  declineInvite?: Maybe<Invite>;
  /** Deletes a document by id */
  deleteDocument?: Maybe<Scalars['Boolean']>;
  /** Deletes an expense by id */
  deleteExpense?: Maybe<Scalars['Boolean']>;
  /** Deletes an invite with the id */
  deleteInvite?: Maybe<Invite>;
  editSubmission?: Maybe<SubmitOutput>;
  /** Inspects the Vehicle data, requiring all the Vehicle mandatory data */
  inspectVehicle?: Maybe<Vehicle>;
  markRoomAsRead?: Maybe<Scalars['Boolean']>;
  readNotifications?: Maybe<Scalars['Boolean']>;
  /** Mutation to delete a connection */
  removeConnection?: Maybe<Scalars['Boolean']>;
  removeDeviceToken?: Maybe<Scalars['Boolean']>;
  /** Removes the member with *userId* from the organization with *id* */
  removeMember?: Maybe<Scalars['Boolean']>;
  /** Resends an invite with the passed id */
  resendInvite?: Maybe<Invite>;
  /** Updates the listing to saved for the user */
  saveListing?: Maybe<Scalars['Boolean']>;
  /** Share a listing with a user and/or organization */
  shareListing?: Maybe<Listing>;
  /**
   * Share a vehicle with a user and/or organization
   * @deprecated Use shareListing instead
   */
  shareVehicle?: Maybe<Vehicle>;
  submit?: Maybe<SubmitOutput>;
  /** Update listings by query */
  systemAssignNewUserToListingsByEmail?: Maybe<Scalars['Boolean']>;
  /** Update rooms and messages after creating a new user. Only works with system token. */
  systemAssignNewUserToRoomsAndMessagesByEmail?: Maybe<Scalars['Boolean']>;
  /** Updates listingImport status to completed */
  systemCompleteListingsImport?: Maybe<ListingImport>;
  /** Creates vehicles for a bulk input. Only for internal use. */
  systemCreateBulkVehicles?: Maybe<CreateBulkVehicles>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates an User with User Admin permissions */
  systemCreateUser?: Maybe<User>;
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates sale information by id. Only for internal use. */
  systemUpdateSaleInformation?: Maybe<SaleInformation>;
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  systemUpsertSubmission?: Maybe<SubmitOutput>;
  /** Updates the listing to not saved for the user */
  unsaveListing?: Maybe<Scalars['Boolean']>;
  /** Updates an Appraisal */
  updateAppraisal?: Maybe<Appraisal>;
  /** Updates a document by id */
  updateDocument?: Maybe<Document>;
  /** Updates an expense by id */
  updateExpense?: Maybe<Expense>;
  /** Updates a Listing Status */
  updateListingCurrentStatus?: Maybe<Scalars['String']>;
  /** Updates a Listing Set of Tags */
  updateListingTags?: Maybe<Listing>;
  /** Updates a Listing Valuation */
  updateListingValuation?: Maybe<ListingValuation>;
  updateMe?: Maybe<User>;
  /** Updates the member role for *userId* from the organization with *id* */
  updateMemberRole?: Maybe<UserRole>;
  /** Updates a Listing Note */
  updateNote?: Maybe<Note>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /**
   * Updates a listing status for the given organization.
   * Admins can update statuses in any organization; owners can only update statuses of organizations they own.
   */
  updateOrganizationStatus: OrganizationListingStatus;
  /**
   * Updates a tag for the given organization.
   * Admins can update tags in any organization; owners can only update tags of organizations they own.
   */
  updateOrganizationTag: Tag;
  /** Updates a Vehicle */
  updateVehicle?: Maybe<Vehicle>;
  /** Updates a Vehicle Status */
  updateVehicleCurrentStatus?: Maybe<Scalars['String']>;
  /** Upserts a purchaseInformation for a listing. */
  upsertPurchaseInformation?: Maybe<PurchaseInformation>;
  /** Upserts a saleInformation for a listing. */
  upsertSaleInformation?: Maybe<SaleInformation>;
  /**
   * Returns the vehicle valuation info for the given input.
   * Creates a lead with the vehicle info.
   */
  widgetGetValuation: WidgetGetValuationOutput;
  /** Returns url with the encoded info for the given input. */
  widgetSubmitPersonalDetails: WidgetSubmitPersonalDetailsOutput;
};


export type MutationAcceptConnectionInviteArgs = {
  input: AcceptConnectionInviteInput;
};


export type MutationAcceptInviteArgs = {
  id: Scalars['ID'];
};


export type MutationAddDeviceTokenArgs = {
  input?: InputMaybe<AddDeviceTokenInput>;
};


export type MutationAssignTradeToVehicleArgs = {
  input: AssignTradeToVehicleInput;
};


export type MutationBulkShareListingsArgs = {
  input: BulkShareListingsInput;
};


export type MutationBulkToggleSaveListingsArgs = {
  input: BulkToggleSaveListingsInput;
};


export type MutationBulkUpdateListingsCurrentStatusArgs = {
  input: BulkUpdateListingsCurrentStatusInput;
};


export type MutationBulkUpdateListingsTagsArgs = {
  input: BulkUpdateListingsTagsInput;
};


export type MutationClaimWidgetValuationArgs = {
  id: Scalars['ID'];
};


export type MutationClickNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationCompleteReconArgs = {
  input: CompleteReconInput;
};


export type MutationCompleteReconTradeArgs = {
  input: CompleteReconTradeInput;
};


export type MutationConfigureIntegrationArgs = {
  input?: InputMaybe<ConfigureIntegrationInput>;
};


export type MutationCreateAppraisalArgs = {
  input: CreateAppraisalInput;
};


export type MutationCreateBulkVehiclesArgs = {
  input?: InputMaybe<Array<CreateVehicleInput>>;
};


export type MutationCreateBuyerArgs = {
  input: CreateBuyerInput;
};


export type MutationCreateConnectionInviteArgs = {
  input: CreateConnectionInviteInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};


export type MutationCreateInviteArgs = {
  inviteParams?: InputMaybe<InviteInput>;
};


export type MutationCreateListingImportArgs = {
  input: CreateListingImportInput;
};


export type MutationCreateListingInternalValuationArgs = {
  input: CreateListingInternalValuationInput;
  isOffer?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateListingOfferArgs = {
  input: CreateListingOfferInput;
};


export type MutationCreateListingValuationArgs = {
  input: CreateListingValuationInput;
};


export type MutationCreateMessageArgs = {
  input?: InputMaybe<CreateRoomMessageInput>;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreateOrganizationStatusArgs = {
  input: CreateOrganizationStatusInput;
};


export type MutationCreateOrganizationTagArgs = {
  input: CreateOrganizationTagInput;
};


export type MutationCreatePurchaseSourceArgs = {
  input: CreatePurchaseSourceInput;
};


export type MutationCreateUserArgs = {
  user?: InputMaybe<CreateUserInput>;
};


export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationDeclineConnectionInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDeclineInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInviteArgs = {
  id: Scalars['ID'];
};


export type MutationEditSubmissionArgs = {
  externalId: Scalars['String'];
  structure: StructureInput;
};


export type MutationInspectVehicleArgs = {
  input: InspectVehicleInput;
};


export type MutationMarkRoomAsReadArgs = {
  input?: InputMaybe<MarkRoomAsReadInput>;
};


export type MutationRemoveConnectionArgs = {
  connectionId: Scalars['ID'];
};


export type MutationRemoveDeviceTokenArgs = {
  input?: InputMaybe<RemoveDeviceTokenInput>;
};


export type MutationRemoveMemberArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationResendInviteArgs = {
  id: Scalars['ID'];
};


export type MutationSaveListingArgs = {
  listingId: Scalars['String'];
};


export type MutationShareListingArgs = {
  input: ShareListingInput;
};


export type MutationShareVehicleArgs = {
  input: ShareVehicleInput;
};


export type MutationSubmitArgs = {
  structure: StructureInput;
};


export type MutationSystemAssignNewUserToListingsByEmailArgs = {
  input?: InputMaybe<SystemAssignNewUserToListingsByEmailInput>;
};


export type MutationSystemAssignNewUserToRoomsAndMessagesByEmailArgs = {
  input?: InputMaybe<SystemAssignNewUserToRoomsAndMessagesByEmailInput>;
};


export type MutationSystemCompleteListingsImportArgs = {
  input: SystemCompleteListingsImportInput;
};


export type MutationSystemCreateBulkVehiclesArgs = {
  input: SystemCreateBulkVehiclesInput;
};


export type MutationSystemCreateOrganizationArgs = {
  organization?: InputMaybe<SystemOrganizationInput>;
  userId: Scalars['ID'];
};


export type MutationSystemCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdateSaleInformationArgs = {
  input: SystemUpdateSaleInformationInput;
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationSystemUpsertSubmissionArgs = {
  plainSubmission: Scalars['JSON'];
  structureType: Scalars['String'];
};


export type MutationUnsaveListingArgs = {
  listingId: Scalars['String'];
};


export type MutationUpdateAppraisalArgs = {
  input: UpdateAppraisalInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateListingCurrentStatusArgs = {
  input: UpdateListingCurrentStatusInput;
};


export type MutationUpdateListingTagsArgs = {
  input?: InputMaybe<UpdateListingTagsInput>;
};


export type MutationUpdateListingValuationArgs = {
  input: UpdateListingValuationInput;
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateMemberRoleArgs = {
  id: Scalars['ID'];
  role: MemberRole;
  userId: Scalars['ID'];
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdateOrganizationStatusArgs = {
  input: UpdateOrganizationStatusInput;
};


export type MutationUpdateOrganizationTagArgs = {
  input: UpdateOrganizationTagInput;
};


export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput;
};


export type MutationUpdateVehicleCurrentStatusArgs = {
  input: UpdateVehicleCurrentStatusInput;
};


export type MutationUpsertPurchaseInformationArgs = {
  input: UpsertPurchaseInformationInput;
};


export type MutationUpsertSaleInformationArgs = {
  input: UpsertSaleInformationInput;
};


export type MutationWidgetGetValuationArgs = {
  input: WidgetGetValuationInput;
};


export type MutationWidgetSubmitPersonalDetailsArgs = {
  input: WidgetSubmitPersonalDetailsInput;
};

export type Note = {
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  listingId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  previousValue?: Maybe<Scalars['JSON']>;
  submitter?: Maybe<User>;
  tag?: Maybe<NoteTag>;
  updatedAt?: Maybe<Scalars['Date']>;
  userOnly?: Maybe<Scalars['Boolean']>;
};

export type NoteConnection = {
  nodes?: Maybe<Array<Maybe<Note>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum NoteTag {
  Acquisition = 'Acquisition',
  Arbitration = 'Arbitration',
  Disposition = 'Disposition',
  General = 'General',
  Void = 'Void'
}

export type Notification = {
  action?: Maybe<Scalars['String']>;
  clicked: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Date']>;
  entityId: Scalars['String'];
  entityName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Messages>;
  messageHtml: Scalars['String'];
  messageText: Scalars['String'];
  organizationImageUrl?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
};

export type NotificationConnection = {
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  nodes?: Maybe<Array<Maybe<Notification>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  unreadNotifications: Scalars['Int'];
};

export type NotificationEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Notification>;
};

export type NumberFilter = {
  field: Scalars['String'];
  operator: NumberOperators;
};

export type NumberOperators = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type NumberRange = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export enum Os {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type OdometerFilter = {
  field: Scalars['String'];
  operator: NumberOperators;
  unit: OdometerUnit;
};

export enum OdometerUnit {
  Km = 'KM',
  Mi = 'MI'
}

export type Offer = {
  amount: Scalars['Int'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId: Scalars['String'];
  id: Scalars['ID'];
  listingId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type Option = {
  code: Scalars['String'];
  default: Scalars['Boolean'];
  extra?: Maybe<Array<Maybe<Scalars['String']>>>;
  value: Scalars['String'];
};

export type OptionInput = {
  code?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  extra?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value: Scalars['String'];
};

export type Organization = {
  access?: Maybe<OrganizationAccess>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  dealerships?: Maybe<Array<Maybe<Scalars['String']>>>;
  dynamicStatusesEnabled?: Maybe<Scalars['Boolean']>;
  dynamicTagsEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isVendor?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owned?: Maybe<Scalars['Boolean']>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statuses: Array<OrganizationListingStatus>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  zip?: Maybe<Scalars['String']>;
};

export enum OrganizationAccess {
  Full = 'Full',
  Restricted = 'Restricted'
}

export type OrganizationConnection = {
  nodes?: Maybe<Array<Maybe<Organization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Organization>;
};

export type OrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dealerships?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A listing status configured for an organization (organization_statuses). */
export type OrganizationListingStatus = {
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  listingCounts: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedByUser?: Maybe<User>;
};

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PurchaseInformation = {
  id: Scalars['ID'];
  purchaseDate: Scalars['Date'];
  purchasePrice: Scalars['Float'];
  purchaseSource?: Maybe<PurchaseSource>;
  sourceType?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  titleReceiptDate?: Maybe<Scalars['Date']>;
  titleReceived?: Maybe<Scalars['Boolean']>;
  titleState?: Maybe<Scalars['String']>;
};

export type PurchaseSource = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type PurchaseSourceConnection = {
  nodes?: Maybe<Array<Maybe<PurchaseSource>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Query = {
  _?: Maybe<Scalars['Boolean']>;
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  /** Returns an appraisal */
  appraisal?: Maybe<Appraisal>;
  /** Returns a bulk process by id */
  bulkProcess?: Maybe<BulkProcess>;
  /**
   * Returns the buyers associated with the receiving organization of a listing. In case
   * no receiving organization is present on the listing we will use the ones from the listing.
   * You can search buyers by name.
   */
  buyers?: Maybe<BuyerConnection>;
  /** Query to return a connection by its id */
  connection?: Maybe<Connection>;
  /** Query to return a connection invite by its id */
  connectionInvite?: Maybe<ConnectionInvite>;
  /**
   * Query to return the paginated connection invites
   * Accepts an organizationIds filter that returns all connection invites for the given organizations
   * If no organization are given, returns all connections visibile to the user.
   * Also, accepts a statuses filter that returns all connection invites for a given statuses
   * If no statuses filter is given, returns all connection invitations pending to the user.
   */
  connectionInvites?: Maybe<ConnectionInviteConnection>;
  /**
   * Query to return the paginated connections
   * Accepts an organizationId filter that returns all connections for a given organization
   * If no organization is given, returns all connections visibile to the user.
   */
  connections?: Maybe<ConnectionModelConnection>;
  decode?: Maybe<BaseDecode>;
  /** Return a document by id. */
  document?: Maybe<Document>;
  /** Returns an expense by id. */
  expense?: Maybe<Expense>;
  /** Returns the counts for a specific vehicle make filter */
  filterCountModels?: Maybe<Array<Maybe<FilterElement>>>;
  /** Returns the counts for the listings organization */
  filterCountOrganizations?: Maybe<Array<Maybe<FilterElement>>>;
  /** Returns the counts for the listing statuses */
  filterCountStatuses?: Maybe<Array<Maybe<FilterElement>>>;
  /** Returns the counts for the listings tags */
  filterCountTags?: Maybe<Array<Maybe<FilterElement>>>;
  /** Returns the counts for a specific property filter */
  filterCounts?: Maybe<Array<Maybe<FilterElement>>>;
  findAllByUserId?: Maybe<Array<Maybe<Submission>>>;
  findByExternalId?: Maybe<Submission>;
  findById?: Maybe<Submission>;
  /** Returns the listing that was automatically created on vehicle creation */
  inceptionListingByVehicleId?: Maybe<Listing>;
  /** Returns non-shared listings by vin */
  inceptionListingsByVin?: Maybe<Array<Maybe<Listing>>>;
  /** Get all possible integrations */
  integrations?: Maybe<IntegrationConnection>;
  /** Returns an internal valuation */
  internalValuation?: Maybe<InternalValuation>;
  /** Get invite information. */
  invite?: Maybe<Invite>;
  /** Returns a listing */
  listing?: Maybe<Listing>;
  /** Returns a list of paginated listing history events */
  listingHistory?: Maybe<ListingHistoryConnection>;
  /** Returns a listingHistory by id */
  listingHistoryById?: Maybe<ListingHistory>;
  /**
   * Returns a list of paginated listings Imports
   * Accepts organizationId as filter, if no organizationId is given
   * then returns all the listingImports visibile to the user
   */
  listingImports?: Maybe<ListingImportConnection>;
  /** Returns a list of paginated listings */
  listings?: Maybe<ListingConnection>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Current authenticated user organizations */
  meOrganizations?: Maybe<Array<Maybe<Organization>>>;
  /** Returns a list of mentionable users for a RoomType and listingId. */
  mentionableUsers?: Maybe<Array<Maybe<UserShort>>>;
  /** Returns a list of paginated messages for a specific room. */
  messages?: Maybe<MessageConnection>;
  /** Returns a note by id */
  note?: Maybe<Note>;
  /**
   * Returns a list of paginated notes for a listing
   * Accepts a tag filter to return only notes with that specific tag, by default it returns all notes
   */
  notes?: Maybe<NoteConnection>;
  /** Returns a notification. */
  notification?: Maybe<Notification>;
  /** Returns a list of paginated notifications for a specific user. */
  notifications?: Maybe<NotificationConnection>;
  /** Returns an offer */
  offer?: Maybe<Offer>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /**
   * Returns organization-defined listing statuses configured for the organization (*organizationId*).
   * The current user must belong to that organization (unless admin).
   */
  organizationListingStatuses: Array<OrganizationListingStatus>;
  /** List all the organizations visible to the user with pagination. */
  organizations?: Maybe<OrganizationConnection>;
  /**
   * Returns the purchaseSources associated with the receiving organization of a listing. In case
   * no receiving organization is present on the listing we will use the ones from the listing.
   * You can search purchaseSources by name.
   */
  purchaseSources?: Maybe<PurchaseSourceConnection>;
  /** Returns a RoomMessage by id. */
  roomMessage?: Maybe<RoomMessage>;
  /** Returns a list of paginated rooms that user belongs to. */
  rooms?: Maybe<RoomConnection>;
  /** Returns a list of rooms for a specific vehicle. */
  roomsForVehicle?: Maybe<VehicleRoom>;
  structure?: Maybe<Structure>;
  submissions?: Maybe<Array<Maybe<Submission>>>;
  /**
   * Returns connections for the given organizationIds.
   * Works only with a system read token
   * If no organizationIds are provided, returns all connections in the system.
   */
  systemConnections: Array<Maybe<Connection>>;
  /** Get invite information. Only works with API tokens with the system:read scope. */
  systemInvite?: Maybe<Invite>;
  /** Returns a system listing */
  systemListing?: Maybe<Listing>;
  /** Get organization information. Only works with API tokens with the system:read scope. */
  systemOrganization?: Maybe<Organization>;
  /** Searches for an organization based on the passed feed parameters */
  systemOrganizationByFeedInfo?: Maybe<Organization>;
  /** Searches for an organization based on the passed widget parameters */
  systemOrganizationByWidgetInfo?: Maybe<Organization>;
  /**
   * Returns the list of emails of the members of the organization with *organizationId*
   * Only works with API tokens with the system:read scope.
   */
  systemOrganizationMemberEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Get all organizations. Only works with API tokens with the system:read scope. */
  systemOrganizations?: Maybe<Array<Maybe<Organization>>>;
  systemUsedVehicles: SystemUsedVehiclesOutput;
  /** Get user information. Only works with API tokens with the system:read scope. */
  systemUser?: Maybe<User>;
  /** Given an email address, returns user information. Only works with API tokens with the system:read scope. */
  systemUserByEmail?: Maybe<User>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /**
   * List all the users in the system. Only works with API tokens with the system:read scope.
   * You can filter users by id
   */
  systemUsers?: Maybe<UserConnection>;
  /** Returns a system vehicle */
  systemVehicle?: Maybe<Vehicle>;
  /** Returns all the exisiting tags */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Returns a valuation */
  valuation?: Maybe<ListingValuation>;
  /** Returns a vehicle */
  vehicle?: Maybe<Vehicle>;
  /** Returns vehicle id by VIN */
  vehicleIdByVin?: Maybe<Scalars['ID']>;
  /** Returns a list of paginated grouped rooms grouped by vehicle of an Org */
  vehicleRooms?: Maybe<VehicleRoomConnection>;
  vehicleValuation: VehicleValuationOutput;
  /** Returns a list of paginated vehicles */
  vehicles?: Maybe<VehicleConnection>;
  vehiclesAutocomplete: Array<UsedVehicleOutput>;
  vehiclesByLicensePlate: Array<UsedVehicleOutput>;
  vehiclesDrilldownInformation: Array<MakeDrilldown>;
  /** Returns a list of paginated vehicles assigned to a vendor */
  vendorVehicles?: Maybe<VehicleConnection>;
  /**
   * Returns the vendors associated with the receiving organization of a listing. In case
   * no receiving organization is present on the listing we will use the ones from the listing.
   * You can search vendors by name.
   */
  vendors?: Maybe<VendorConnection>;
  /**
   * Returns the vehicle blackbook decoded info (with the list of trims and options)
   * for the given input.
   */
  widgetDecode?: Maybe<WidgetDecodeOutput>;
};


export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>;
};


export type QueryAppraisalArgs = {
  id: Scalars['ID'];
};


export type QueryBulkProcessArgs = {
  id: Scalars['ID'];
};


export type QueryBuyersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  listingId: Scalars['String'];
  searchName?: InputMaybe<Scalars['String']>;
};


export type QueryConnectionArgs = {
  id: Scalars['ID'];
};


export type QueryConnectionInviteArgs = {
  id: Scalars['ID'];
};


export type QueryConnectionInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<ConnectionInviteStatus>>>;
};


export type QueryConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDecodeArgs = {
  vin: Scalars['String'];
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryFilterCountModelsArgs = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  makeName?: InputMaybe<Scalars['String']>;
};


export type QueryFilterCountOrganizationsArgs = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
};


export type QueryFilterCountStatusesArgs = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
};


export type QueryFilterCountTagsArgs = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
};


export type QueryFilterCountsArgs = {
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  propertyName?: InputMaybe<Scalars['String']>;
};


export type QueryFindAllByUserIdArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryFindByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryFindByIdArgs = {
  id: Scalars['String'];
};


export type QueryInceptionListingByVehicleIdArgs = {
  id: Scalars['ID'];
};


export type QueryInceptionListingsByVinArgs = {
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryIntegrationsArgs = {
  input?: InputMaybe<IntegrationsInput>;
};


export type QueryInternalValuationArgs = {
  id: Scalars['ID'];
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
};


export type QueryListingArgs = {
  id: Scalars['ID'];
};


export type QueryListingHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  listingId: Scalars['String'];
};


export type QueryListingHistoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryListingImportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryListingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMentionableUsersArgs = {
  listingId: Scalars['String'];
  roomType: RoomType;
};


export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['ID'];
};


export type QueryNoteArgs = {
  id: Scalars['ID'];
};


export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  listingId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<NoteTag>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryOfferArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationListingStatusesArgs = {
  organizationId: Scalars['ID'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPurchaseSourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  listingId: Scalars['String'];
  searchName?: InputMaybe<Scalars['String']>;
};


export type QueryRoomMessageArgs = {
  messageId: Scalars['ID'];
};


export type QueryRoomsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryRoomsForVehicleArgs = {
  vehicleId: Scalars['ID'];
};


export type QueryStructureArgs = {
  preloadedAnswers?: InputMaybe<Array<InputMaybe<PreloadedAnswersInput>>>;
  style?: InputMaybe<StyleInput>;
  type?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type QuerySubmissionsArgs = {
  externalId: Scalars['String'];
};


export type QuerySystemConnectionsArgs = {
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QuerySystemInviteArgs = {
  id: Scalars['ID'];
};


export type QuerySystemListingArgs = {
  id: Scalars['String'];
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemOrganizationByFeedInfoArgs = {
  dealerId: Scalars['String'];
  provider: Scalars['String'];
};


export type QuerySystemOrganizationByWidgetInfoArgs = {
  apiKey: Scalars['String'];
  origin: Scalars['String'];
};


export type QuerySystemOrganizationMemberEmailsArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemOrganizationsArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySystemUsedVehiclesArgs = {
  input: SystemUsedVehiclesInput;
};


export type QuerySystemUserArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserByEmailArgs = {
  email: Scalars['String'];
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySystemVehicleArgs = {
  id: Scalars['ID'];
};


export type QueryTagsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryValuationArgs = {
  id: Scalars['ID'];
};


export type QueryVehicleArgs = {
  id: Scalars['ID'];
};


export type QueryVehicleIdByVinArgs = {
  vin: Scalars['String'];
};


export type QueryVehicleRoomsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryVehicleValuationArgs = {
  input: VehicleValuationInput;
};


export type QueryVehiclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVehiclesAutocompleteArgs = {
  searchText: Scalars['String'];
};


export type QueryVehiclesByLicensePlateArgs = {
  input: LicensePlateInput;
};


export type QueryVehiclesDrilldownInformationArgs = {
  input: VehicleDrilldownInput;
};


export type QueryVendorVehiclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVendorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  listingId: Scalars['String'];
  searchName?: InputMaybe<Scalars['String']>;
};


export type QueryWidgetDecodeArgs = {
  input: WidgetDecodeInput;
};

export type Question = {
  answer?: Maybe<Array<Maybe<Answer>>>;
  /** Function that will be triggered when answering the question */
  answerFunction?: Maybe<Scalars['String']>;
  /** Title of the question when answered */
  answerTitle?: Maybe<Scalars['String']>;
  /** Displays extra information about the question */
  coachNote?: Maybe<Scalars['String']>;
  displayRule?: Maybe<Scalars['String']>;
  imagesPlaceholders?: Maybe<Array<Maybe<Image>>>;
  imagesPlaceholdersForCamera?: Maybe<Array<Maybe<Image>>>;
  key: Scalars['String'];
  options?: Maybe<Array<Maybe<Option>>>;
  requiresAnswer: Scalars['Boolean'];
  title: Scalars['String'];
  type: QuestionType;
  validationRule?: Maybe<Scalars['String']>;
};

export type QuestionGroup = {
  /** Category to group a set of question groups */
  category?: Maybe<Scalars['String']>;
  displayRule?: Maybe<Scalars['String']>;
  editable: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Question>>>;
  /** Continue or cancel current vehicle creation process */
  requiresConfirmation?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type QuestionGroups = {
  category?: InputMaybe<Scalars['String']>;
  displayRule?: InputMaybe<Scalars['String']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  requiresConfirmation?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QuestionInput = {
  answer?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  answerFunction?: InputMaybe<Scalars['String']>;
  answerTitle?: InputMaybe<Scalars['String']>;
  coachNote?: InputMaybe<Scalars['String']>;
  displayRule?: InputMaybe<Scalars['String']>;
  imagesPlaceholders?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  imagesPlaceholdersForCamera?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  key?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  requiresAnswer: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<QuestionType>;
  validationRule?: InputMaybe<Scalars['String']>;
};

export enum QuestionType {
  Address = 'address',
  Currency = 'currency',
  Date = 'date',
  Gallery = 'gallery',
  Media = 'media',
  Medianote = 'medianote',
  Multiselect = 'multiselect',
  Note = 'note',
  Singlemultiselect = 'singlemultiselect',
  Singleselect = 'singleselect',
  Units = 'units'
}

export type Range = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type ReconData = {
  estimatedReconPrice?: Maybe<Scalars['Int']>;
  needsParts?: Maybe<Scalars['Boolean']>;
  reconTrades?: Maybe<Array<Maybe<ReconTrade>>>;
};

export type ReconDataInput = {
  estimatedReconPrice?: InputMaybe<Scalars['Int']>;
  needsParts?: InputMaybe<Scalars['Boolean']>;
  reconTrades?: InputMaybe<Array<InputMaybe<ReconTradeInput>>>;
};

export type ReconTrade = {
  estimatedDays?: Maybe<Scalars['Int']>;
  ownerCompleted?: Maybe<Scalars['Boolean']>;
  ownerCompletedAt?: Maybe<Scalars['Date']>;
  repairPrice?: Maybe<Scalars['Float']>;
  started?: Maybe<Scalars['Boolean']>;
  startedAt?: Maybe<Scalars['Date']>;
  trade?: Maybe<Trades>;
  tradeCount?: Maybe<Scalars['Int']>;
  vendor?: Maybe<Organization>;
  vendorCompleted?: Maybe<Scalars['Boolean']>;
  vendorCompletedAt?: Maybe<Scalars['Date']>;
};

export type ReconTradeInput = {
  estimatedDays?: InputMaybe<Scalars['Int']>;
  trade?: InputMaybe<Trades>;
};

export type RemoveDeviceTokenInput = {
  token: Scalars['String'];
};

export type Room = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  invitedOrganization?: Maybe<Organization>;
  lastMessageAt?: Maybe<Scalars['Date']>;
  lastMessageText?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  ownerOrganization?: Maybe<Organization>;
  type?: Maybe<RoomType>;
  unreadMessagesCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  users?: Maybe<Array<Maybe<User>>>;
  vehicle?: Maybe<Vehicle>;
};

export type RoomConnection = {
  nodes?: Maybe<Array<Maybe<Room>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RoomMessage = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  receiverId?: Maybe<Scalars['String']>;
  receiverType?: Maybe<Scalars['String']>;
  room?: Maybe<Room>;
  sender: User;
  senderOrganizationId?: Maybe<Scalars['String']>;
  sentAt: Scalars['Date'];
  text: Scalars['String'];
};

export enum RoomType {
  InOrgDirectRoom = 'InOrgDirectRoom',
  InOrgGeneralRoom = 'InOrgGeneralRoom',
  InOrgGroupRoom = 'InOrgGroupRoom',
  ListingInternalRoom = 'ListingInternalRoom',
  OrgInviteRoom = 'OrgInviteRoom',
  ShareRoom = 'ShareRoom',
  VinCarRoom = 'VinCarRoom'
}

export type SaleInformation = {
  address?: Maybe<Scalars['String']>;
  bosUrl?: Maybe<Scalars['String']>;
  buyer?: Maybe<Buyer>;
  generateBos?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  salePrice: Scalars['Float'];
  saleType?: Maybe<Scalars['String']>;
  soldDate: Scalars['Date'];
};

export enum Scope {
  Admin = 'Admin'
}

export type ShareListingInput = {
  listingId: Scalars['ID'];
  receivingOrganizationId?: InputMaybe<Scalars['String']>;
  receivingUserEmail?: InputMaybe<Scalars['String']>;
  sharingOrganizationId: Scalars['String'];
};

export type ShareVehicleInput = {
  receivingOrganizationId?: InputMaybe<Scalars['String']>;
  receivingUserEmail?: InputMaybe<Scalars['String']>;
  receivingUserId?: InputMaybe<Scalars['String']>;
  sharingOrganizationId: Scalars['String'];
  vehicleId: Scalars['String'];
};

export type StringFilter = {
  field: Scalars['String'];
  operator: StringOperators;
};

export type StringOperators = {
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notEq?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Structure = {
  decode?: Maybe<Decode>;
  questionGroups?: Maybe<Array<Maybe<QuestionGroup>>>;
  type?: Maybe<Scalars['String']>;
};

export type StructureInput = {
  decode?: InputMaybe<DecodeInput>;
  questionGroups?: InputMaybe<Array<InputMaybe<QuestionGroups>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type Style = {
  provider?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['String']>;
  styleId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StyleDrilldown = {
  styleValue: Scalars['String'];
  uvc: Scalars['String'];
};

export type StyleInput = {
  provider?: InputMaybe<Scalars['String']>;
  styleId?: InputMaybe<Scalars['String']>;
};

export type Submission = {
  decode?: Maybe<Decode>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  questionGroups?: Maybe<Array<Maybe<QuestionGroup>>>;
  type?: Maybe<Scalars['String']>;
};

export type SubmitOutput = {
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Subscription = {
  /** Returns the bulk process after it it has been updated */
  bulkProcessUpdated?: Maybe<BulkProcess>;
  connectionCreated?: Maybe<Connection>;
  connectionInviteCreated?: Maybe<ConnectionInvite>;
  connectionInviteUpdated?: Maybe<ConnectionInvite>;
  connectionRemoved?: Maybe<Connection>;
  listingAppraisal?: Maybe<Appraisal>;
  listingCreated?: Maybe<Listing>;
  /** Returns the listing current status after it has been updated */
  listingCurrentStatus?: Maybe<WorkflowStatus>;
  listingDocument?: Maybe<Document>;
  listingDocumentRemoved?: Maybe<Document>;
  listingExpense?: Maybe<Expense>;
  listingExpenseRemoved?: Maybe<Expense>;
  listingHistoryCreated?: Maybe<ListingHistory>;
  listingInternalValuation?: Maybe<InternalValuation>;
  listingNote?: Maybe<Note>;
  listingOffer?: Maybe<Offer>;
  listingPurchaseInformation?: Maybe<PurchaseInformation>;
  listingSaleInformation?: Maybe<SaleInformation>;
  /** Returns an updated activity for a listing every time it has been shared */
  listingSharedActivity?: Maybe<Activity>;
  listingTags: Array<Tag>;
  listingUpdated?: Maybe<Listing>;
  listingValuation?: Maybe<ListingValuation>;
  liveActivity: ActivityChannelStatus;
  messageCreated?: Maybe<RoomMessage>;
  notificationCreated?: Maybe<Notification>;
  vehicleUpdated?: Maybe<Vehicle>;
};


export type SubscriptionListingAppraisalArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingCurrentStatusArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingDocumentArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingDocumentRemovedArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingExpenseArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingExpenseRemovedArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingHistoryCreatedArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingInternalValuationArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingNoteArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingOfferArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingPurchaseInformationArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingSaleInformationArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingSharedActivityArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingTagsArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionListingValuationArgs = {
  listingId: Scalars['ID'];
};


export type SubscriptionLiveActivityArgs = {
  activityChannel: ActivityChannel;
  entityId: Scalars['ID'];
  isObserver?: InputMaybe<Scalars['Boolean']>;
};

export type SystemAssignNewUserToListingsByEmailInput = {
  email: Scalars['String'];
  userId: Scalars['String'];
};

export type SystemAssignNewUserToRoomsAndMessagesByEmailInput = {
  email: Scalars['String'];
  userId: Scalars['String'];
};

export type SystemCompleteListingsImportInput = {
  listingImportId: Scalars['String'];
  processingResult?: InputMaybe<Scalars['String']>;
  processingStatus: ListingImportProcessingStatus;
};

export type SystemCreateBulkVehiclesInput = {
  organizationId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  vehicles: Array<SystemCreateVehicleInput>;
};

export type SystemCreateVehicleInput = {
  auctionLane?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  auctionRunNumber?: InputMaybe<Scalars['String']>;
  csvUnmappedData?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  drivetrain?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<Scalars['String']>;
  exteriorColor?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  interiorColor?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mmr?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  odometerUnit?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Scalars['String']>;
  preSaleNotes?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerInternalVehicleID?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['String']>;
  reconData?: InputMaybe<Scalars['String']>;
  sellPrice?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  submitterId?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};

export type SystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SystemUsedVehiclesInput = {
  addDeductCodes?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  plate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  uvc?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type SystemUsedVehiclesOutput = {
  make: Scalars['String'];
  model: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  trims: Array<Trim>;
  valuations: Valuations;
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type Tag = {
  id?: Maybe<Scalars['String']>;
  listingCounts: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedByUser?: Maybe<User>;
};

export enum Trades {
  Cosmetic = 'COSMETIC',
  Detail = 'DETAIL',
  Mechanic = 'MECHANIC',
  Paint = 'PAINT',
  Pdr = 'PDR',
  Tires = 'TIRES',
  TouchUp = 'TOUCH_UP',
  Upholstery = 'UPHOLSTERY'
}

export type Trim = {
  addDeductOptions?: Maybe<Array<AddDeductOption>>;
  photo?: Maybe<Scalars['String']>;
  style: Scalars['String'];
  trim: Scalars['String'];
  uvc: Scalars['String'];
};

export type TrimDrilldown = {
  styleDrilldown: Array<StyleDrilldown>;
  trimValue: Scalars['String'];
};

export type UpdateAppraisalInput = {
  amount?: InputMaybe<Scalars['Int']>;
  crGrade?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateDocumentInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DocumentType>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateExpenseInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  documentName?: InputMaybe<Scalars['String']>;
  expenseDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  type?: InputMaybe<ExpenseType>;
  url?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type UpdateListingCurrentStatusInput = {
  id: Scalars['String'];
  organizationListingStatusId: Scalars['ID'];
};

export type UpdateListingTagsInput = {
  listingId: Scalars['String'];
  tags: Array<InputMaybe<Scalars['String']>>;
};

export type UpdateListingValuationInput = {
  amount: Scalars['Float'];
  extra: Scalars['JSON'];
  id: Scalars['Int'];
  listingId: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateNoteInput = {
  id: Scalars['Int'];
  note: Scalars['String'];
  tag?: InputMaybe<NoteTag>;
  userOnly?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dealerships?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationStatusInput = {
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationTagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dynamicStatusesEnabled?: InputMaybe<Scalars['Boolean']>;
  dynamicTagsEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<InputMaybe<Scope>>>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateVehicleCurrentStatusInput = {
  id: Scalars['String'];
  status: VehicleStatus;
};

export type UpdateVehicleInput = {
  auctionInspection?: InputMaybe<Scalars['Boolean']>;
  auctionLane?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  auctionRunNumber?: InputMaybe<Scalars['String']>;
  csvUnmappedData?: InputMaybe<Scalars['JSON']>;
  displayName?: InputMaybe<Scalars['String']>;
  drivetrain?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['Date']>;
  engine?: InputMaybe<Scalars['String']>;
  estimatedSellPrice?: InputMaybe<Scalars['Float']>;
  exteriorColor?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['Float']>;
  hammerPrice?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  interiorColor?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mmr?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['Int']>;
  odometerUnit?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Array<VehiclePictureInput>>;
  preSaleNotes?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerInternalVehicleID?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  sellPrice?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['Date']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type UpsertPurchaseInformationInput = {
  listingId: Scalars['String'];
  purchaseDate?: InputMaybe<Scalars['Date']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  purchaseSourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
  titleNumber?: InputMaybe<Scalars['String']>;
  titleReceiptDate?: InputMaybe<Scalars['Date']>;
  titleReceived?: InputMaybe<Scalars['Boolean']>;
  titleState?: InputMaybe<Scalars['String']>;
};

export type UpsertSaleInformationInput = {
  address?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['Int']>;
  generateBos?: InputMaybe<Scalars['Boolean']>;
  listingId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  saleType?: InputMaybe<Scalars['String']>;
  soldDate?: InputMaybe<Scalars['Date']>;
};

export type UsedVehicleOutput = {
  make: Scalars['String'];
  model: Scalars['String'];
  style: Scalars['String'];
  trim: Scalars['String'];
  uvc: Scalars['String'];
  year: Scalars['Int'];
};

export type User = {
  disableOrgs?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  invites?: Maybe<Array<Maybe<Invite>>>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  phone?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Maybe<Scope>>>;
};

export type UserChannelActivity = {
  isConnected: Scalars['Boolean'];
  lastActiveAt?: Maybe<Scalars['Date']>;
  user: LiveActivityUser;
  userId: Scalars['ID'];
};

export type UserConnection = {
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['String'];
  node?: Maybe<User>;
};

export type UserOrganization = {
  id: Scalars['ID'];
  invite?: Maybe<Invite>;
  organization?: Maybe<Organization>;
  owner: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type UserRole = {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserShort = BaseUser & {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Valuation = {
  adjusted?: Maybe<Scalars['Float']>;
  adjusted_history?: Maybe<Scalars['Float']>;
  base?: Maybe<Scalars['Float']>;
  history?: Maybe<Scalars['Float']>;
  mileage?: Maybe<Scalars['Float']>;
  options?: Maybe<Scalars['Float']>;
};

export type ValuationCategory = {
  avg?: Maybe<Valuation>;
  cln?: Maybe<Valuation>;
  rgh?: Maybe<Valuation>;
  xcln?: Maybe<Valuation>;
};

export type Valuations = {
  retail?: Maybe<ValuationCategory>;
  tradeIn?: Maybe<ValuationCategory>;
  wholesale?: Maybe<ValuationCategory>;
};

export type Vehicle = {
  auctionInspection?: Maybe<Scalars['Boolean']>;
  auctionLane?: Maybe<Scalars['String']>;
  auctionName?: Maybe<Scalars['String']>;
  auctionRunNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  csvUnmappedData?: Maybe<Scalars['JSON']>;
  currentReconStatus?: Maybe<WorkflowStatus>;
  currentVehicleStatus?: Maybe<WorkflowStatus>;
  displayName?: Maybe<Scalars['String']>;
  drivetrain?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['Date']>;
  engine?: Maybe<Scalars['String']>;
  estimatedSellPrice?: Maybe<Scalars['Float']>;
  exteriorColor?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['Float']>;
  hammerPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  inspector?: Maybe<User>;
  interiorColor?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mmr?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['Int']>;
  odometerUnit?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  pictures?: Maybe<Array<Maybe<VehiclePicture>>>;
  /** Transition notes from PreSale to Inspect */
  preSaleNotes?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerInternalVehicleID?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  reconData?: Maybe<ReconData>;
  reconStatuses?: Maybe<Array<Maybe<WorkflowStatus>>>;
  sellPrice?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Date']>;
  stockNumber?: Maybe<Scalars['String']>;
  submissionId?: Maybe<Scalars['String']>;
  submitter?: Maybe<User>;
  transmission?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** @deprecated Use Listing valuations instead */
  valuations?: Maybe<Array<Maybe<ListingValuation>>>;
  vehicleStatuses?: Maybe<Array<Maybe<WorkflowStatus>>>;
  vehicleType?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleConditionValuation = {
  avg?: Maybe<Scalars['Float']>;
  clean?: Maybe<Scalars['Float']>;
  rough?: Maybe<Scalars['Float']>;
  xclean?: Maybe<Scalars['Float']>;
};

export type VehicleConditionValuationInput = {
  avg?: InputMaybe<Scalars['Float']>;
  clean?: InputMaybe<Scalars['Float']>;
  rough?: InputMaybe<Scalars['Float']>;
  xclean?: InputMaybe<Scalars['Float']>;
};

export type VehicleConnection = {
  nodes?: Maybe<Array<Maybe<Vehicle>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VehicleDrilldownInput = {
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type VehicleFilters = {
  booleanFilter?: InputMaybe<BooleanFilter>;
  dateFilter?: InputMaybe<DateFilter>;
  makeModelFilter?: InputMaybe<MakeModelFilter>;
  numberFilter?: InputMaybe<NumberFilter>;
  odometerFilter?: InputMaybe<OdometerFilter>;
  stringFilter?: InputMaybe<StringFilter>;
};

export type VehiclePicture = {
  description?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type VehiclePictureInput = {
  description?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type VehicleRoom = {
  rooms?: Maybe<Array<Maybe<Room>>>;
  vehicle?: Maybe<Vehicle>;
};

export type VehicleRoomConnection = {
  nodes?: Maybe<Array<Maybe<VehicleRoom>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum VehicleStatus {
  Opportunity = 'opportunity',
  Owned = 'owned',
  Sold = 'sold',
  Void = 'void'
}

export type VehicleValuationInput = {
  addDeductCodes?: InputMaybe<Scalars['String']>;
  integrationId?: InputMaybe<Scalars['Int']>;
  mileage?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  uvc?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type VehicleValuationOutput = {
  addDeductOptions: Array<Maybe<AddDeductOption>>;
  valuations: Valuations;
};

export type Vendor = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type VendorConnection = {
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type WidgetDecodeInput = {
  plate?: InputMaybe<Scalars['String']>;
  plateState?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type WidgetDecodeOutput = {
  make: Scalars['String'];
  model: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  trims: Array<Trim>;
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type WidgetGetValuationInput = {
  addDeductCodes?: InputMaybe<Scalars['String']>;
  mileage: Scalars['Int'];
  plate?: InputMaybe<Scalars['String']>;
  plateState?: InputMaybe<Scalars['String']>;
  uvc: Scalars['String'];
  valuationZip: Scalars['String'];
  vin: Scalars['String'];
};

export type WidgetGetValuationOutput = {
  id: Scalars['ID'];
  range: Range;
};

export type WidgetSubmitPersonalDetailsInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type WidgetSubmitPersonalDetailsOutput = {
  url: Scalars['String'];
};

export type WorkflowStatus = {
  createdAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  organizationStatusId?: Maybe<Scalars['String']>;
  transitionUserId?: Maybe<Scalars['String']>;
  /** The user who transitioned the listing to this status */
  transitionedBy?: Maybe<User>;
};

export type _Entity = Connection | ConnectionInvite | Integration | Invite | Notification | Organization | Room | User | UserOrganization | UserRole | UserShort | Vehicle;

export type _Service = {
  sdl?: Maybe<Scalars['String']>;
};

/** Allows to pre-load answers for specific questions */
export type PreloadedAnswersInput = {
  /** Answer for specific question */
  answer?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  /** Question key to be answered */
  questionKey: Scalars['String'];
};

export type SystemUpdateSaleInformationInput = {
  address?: InputMaybe<Scalars['String']>;
  bosUrl?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['Int']>;
  generateBos?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  saleType?: InputMaybe<Scalars['String']>;
  soldDate?: InputMaybe<Scalars['Date']>;
};

export type BulkShareListingsMutationVariables = Exact<{
  input: BulkShareListingsInput;
}>;


export type BulkShareListingsMutation = { bulkShareListings: { id?: string | null, status: BulkProcessStatus, actionType: BulkActionType, createdAt?: any | null } };

export type BulkUpdateListingsTagsMutationVariables = Exact<{
  input: BulkUpdateListingsTagsInput;
}>;


export type BulkUpdateListingsTagsMutation = { bulkUpdateListingsTags: { id?: string | null, actionType: BulkActionType, status: BulkProcessStatus, createdAt?: any | null } };

export type BulkToggleSaveListingsMutationVariables = Exact<{
  input: BulkToggleSaveListingsInput;
}>;


export type BulkToggleSaveListingsMutation = { bulkToggleSaveListings: { id?: string | null, status: BulkProcessStatus, actionType: BulkActionType } };

export type BulkUpdateListingsCurrentStatusMutationVariables = Exact<{
  input: BulkUpdateListingsCurrentStatusInput;
}>;


export type BulkUpdateListingsCurrentStatusMutation = { bulkUpdateListingsCurrentStatus: { id?: string | null, status: BulkProcessStatus, actionType: BulkActionType, createdAt?: any | null } };

export type OrganizationCoreFragment = { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> };

export type UserCoreFragment = { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null };

export type PaginationCoreFragment = { hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null };

export type OrganizationListingStatusCoreFragment = { id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any };

export type TagCoreFragment = { id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null };

export type UserWithScopesCoreFragment = { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null };

export type ConnectionsCoreFragment = { createdAt: any, id: string, inviteId?: string | null, originOrganizationId: string, originUserId: string, targetOrganizationId: string, targetUserId: string, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null };

export type ConnectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ConnectionsQuery = { connections?: { totalCount: number, nodes?: Array<{ createdAt: any, id: string, inviteId?: string | null, originOrganizationId: string, originUserId: string, targetOrganizationId: string, targetUserId: string, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null } } | null };

export type ConnectionsInviteCoreFragment = { createdAt: any, id: string, originOrganizationId: string, originUserId: string, resolvedAt?: any | null, status: ConnectionInviteStatus, targetEmail: string, targetOrganizationId?: string | null, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null };

export type ConnectionInvitesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  statuses?: InputMaybe<Array<InputMaybe<ConnectionInviteStatus>> | InputMaybe<ConnectionInviteStatus>>;
}>;


export type ConnectionInvitesQuery = { connectionInvites?: { totalCount: number, nodes?: Array<{ createdAt: any, id: string, originOrganizationId: string, originUserId: string, resolvedAt?: any | null, status: ConnectionInviteStatus, targetEmail: string, targetOrganizationId?: string | null, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null } } | null };

export type AcceptConnectionInviteMutationVariables = Exact<{
  input: AcceptConnectionInviteInput;
}>;


export type AcceptConnectionInviteMutation = { acceptConnectionInvite?: { createdAt: any, id: string, originOrganizationId: string, originUserId: string, resolvedAt?: any | null, status: ConnectionInviteStatus, targetEmail: string, targetOrganizationId?: string | null, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type DeclineConnectionInviteMutationVariables = Exact<{
  declineConnectionInviteId: Scalars['ID'];
}>;


export type DeclineConnectionInviteMutation = { declineConnectionInvite?: { createdAt: any, id: string, originOrganizationId: string, originUserId: string, resolvedAt?: any | null, status: ConnectionInviteStatus, targetEmail: string, targetOrganizationId?: string | null, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type RemoveConnectionMutationVariables = Exact<{
  connectionId: Scalars['ID'];
}>;


export type RemoveConnectionMutation = { removeConnection?: boolean | null };

export type ClaimWidgetValuationMutationVariables = Exact<{
  claimWidgetValuationId: Scalars['ID'];
}>;


export type ClaimWidgetValuationMutation = { claimWidgetValuation?: boolean | null };

export type CreateListingImportMutationVariables = Exact<{
  input: CreateListingImportInput;
}>;


export type CreateListingImportMutation = { createListingImport?: { processingResult?: string | null, id: string, processingStatus: ListingImportProcessingStatus } | null };

export type CreateConnectionInviteMutationVariables = Exact<{
  input: CreateConnectionInviteInput;
}>;


export type CreateConnectionInviteMutation = { createConnectionInvite?: { createdAt: any, id: string, originOrganizationId: string, originUserId: string, resolvedAt?: any | null, status: ConnectionInviteStatus, targetEmail: string, targetOrganizationId?: string | null, updatedAt: any, originOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, originUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, targetOrganization?: { name?: string | null, id: string, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, targetUser?: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  organization?: InputMaybe<OrganizationInput>;
}>;


export type CreateOrganizationMutation = { createOrganization?: { id: string } | null };

export type DocumentCoreFragment = { id: string, name: string, type: DocumentType, url: string, uploadedAt: any, createdAt: any, updatedAt: any };

export type DeleteDocumentMutationVariables = Exact<{
  deleteDocumentId: Scalars['ID'];
}>;


export type DeleteDocumentMutation = { deleteDocument?: boolean | null };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { createDocument?: { id: string, name: string, type: DocumentType, url: string, uploadedAt: any, createdAt: any, updatedAt: any } | null };

export type ListingDocumentsQueryVariables = Exact<{
  listingId: Scalars['ID'];
  sort?: InputMaybe<DocumentSortFieldInput>;
}>;


export type ListingDocumentsQuery = { listing?: { documents?: Array<{ id: string, name: string, type: DocumentType, url: string, uploadedAt: any, createdAt: any, updatedAt: any } | null> | null } | null };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { updateDocument?: { id: string, name: string, type: DocumentType, url: string, uploadedAt: any, createdAt: any, updatedAt: any } | null };

export type ExpenseCoreFragment = { id: string, updatedAt: any, createdAt: any, expenseDate: any, uploadedAt?: any | null, url?: string | null, type: ExpenseType, description: string, amount: number, documentName?: string | null, vendor?: { id: string, name: string, createdAt: any, updatedAt: any } | null };

export type ListingExpensesQueryVariables = Exact<{
  listingId: Scalars['ID'];
  sort?: InputMaybe<ExpenseSortFieldInput>;
}>;


export type ListingExpensesQuery = { listing?: { expenses?: Array<{ id: string, updatedAt: any, createdAt: any, expenseDate: any, uploadedAt?: any | null, url?: string | null, type: ExpenseType, description: string, amount: number, documentName?: string | null, vendor?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null> | null } | null };

export type CreateExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;


export type CreateExpenseMutation = { createExpense?: { id: string, updatedAt: any, createdAt: any, expenseDate: any, uploadedAt?: any | null, url?: string | null, type: ExpenseType, description: string, amount: number, documentName?: string | null, vendor?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null };

export type CreateVendorMutationVariables = Exact<{
  input: CreateVendorInput;
}>;


export type CreateVendorMutation = { createVendor?: { id: string, name: string, createdAt: any, updatedAt: any } | null };

export type VendorsQueryVariables = Exact<{
  listingId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
}>;


export type VendorsQuery = { vendors?: { nodes?: Array<{ id: string, name: string, createdAt: any, updatedAt: any } | null> | null } | null };

export type DeleteExpenseMutationVariables = Exact<{
  deleteExpenseId: Scalars['ID'];
}>;


export type DeleteExpenseMutation = { deleteExpense?: boolean | null };

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { updateExpense?: { id: string, updatedAt: any, createdAt: any, expenseDate: any, uploadedAt?: any | null, url?: string | null, type: ExpenseType, description: string, amount: number, documentName?: string | null, vendor?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null };

export type FilterCountModelsQueryVariables = Exact<{
  filters?: InputMaybe<Array<VehicleFilters> | VehicleFilters>;
  makeName?: InputMaybe<Scalars['String']>;
}>;


export type FilterCountModelsQuery = { filterCountModels?: Array<{ count: number, key: string } | null> | null };

export type FilterCountCoreFragment = { __typename: 'FilterElement', key: string, count: number };

export type FilterCountsQueryVariables = Exact<{
  filters?: InputMaybe<Array<VehicleFilters> | VehicleFilters>;
}>;


export type FilterCountsQuery = { make?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null, trim?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null, drivetrain?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null, engine?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null, transmission?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null, receivingOrganization?: Array<{ __typename: 'FilterElement', key: string, count: number } | null> | null };

export type FilterCountStatusesQueryVariables = Exact<{
  filters?: InputMaybe<Array<VehicleFilters> | VehicleFilters>;
}>;


export type FilterCountStatusesQuery = { filterCountStatuses?: Array<{ count: number, key: string, value?: string | null } | null> | null };

export type FilterCountOrganizationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<VehicleFilters> | VehicleFilters>;
}>;


export type FilterCountOrganizationsQuery = { filterCountOrganizations?: Array<{ count: number, key: string, value?: string | null } | null> | null };

export type FilterCountTagsQueryVariables = Exact<{
  filters?: InputMaybe<Array<VehicleFilters> | VehicleFilters>;
}>;


export type FilterCountTagsQuery = { filterCountTags?: Array<{ count: number, key: string, value?: string | null } | null> | null };

export type ValuationFieldsFragment = { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null };

export type ValuationCategoryFieldsFragment = { avg?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, cln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, rgh?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, xcln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null };

export type IntegrationsQueryVariables = Exact<{
  input?: InputMaybe<IntegrationsInput>;
}>;


export type IntegrationsQuery = { integrations?: { totalCount: number, nodes?: Array<{ id: string, link?: string | null, name: string, attributes?: Array<{ id: string, name?: string | null, type?: string | null } | null> | null, configuration?: { enabled?: boolean | null, id: string, organizationId?: string | null } | null, configurationUser?: { id: string, integrationId?: string | null, organizationId?: string | null, userId?: string | null, attributes?: Array<{ id: string, value?: string | null, attribute?: { id: string, name?: string | null, type?: string | null } | null } | null> | null } | null, provider?: { id: string, name?: string | null } | null, type?: { id: string, name?: string | null } | null } | null> | null, pageInfo?: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type VehicleValuationQueryVariables = Exact<{
  input: VehicleValuationInput;
}>;


export type VehicleValuationQuery = { vehicleValuation: { valuations: { retail?: { avg?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, cln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, rgh?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, xcln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null } | null, tradeIn?: { avg?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, cln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, rgh?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, xcln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null } | null, wholesale?: { avg?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, cln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, rgh?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null, xcln?: { adjusted?: number | null, adjusted_history?: number | null, base?: number | null, history?: number | null, mileage?: number | null, options?: number | null } | null } | null }, addDeductOptions: Array<{ id: string, name: string } | null> } };

export type ConfigureIntegrationMutationVariables = Exact<{
  input?: InputMaybe<ConfigureIntegrationInput>;
}>;


export type ConfigureIntegrationMutation = { configureIntegration?: boolean | null };

export type AppraisalFieldsFragment = { amount?: number | null, crGrade?: number | null, createdAt?: any | null, id: string, listingId: string, notes?: string | null, previousValue?: any | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null };

export type OfferFieldsFragment = { amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null };

export type CreateAppraisalMutationVariables = Exact<{
  input: CreateAppraisalInput;
}>;


export type CreateAppraisalMutation = { createAppraisal?: { amount?: number | null, crGrade?: number | null, createdAt?: any | null, id: string, listingId: string, notes?: string | null, previousValue?: any | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type UpdateAppraisalMutationVariables = Exact<{
  input: UpdateAppraisalInput;
}>;


export type UpdateAppraisalMutation = { updateAppraisal?: { amount?: number | null, crGrade?: number | null, createdAt?: any | null, id: string, listingId: string, notes?: string | null, previousValue?: any | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type InternalValuationFieldsFragment = { id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type CreateListingInternalValuationMutationVariables = Exact<{
  input: CreateListingInternalValuationInput;
  isOffer?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateListingInternalValuationMutation = { createListingInternalValuation?: { id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type CreateListingOfferMutationVariables = Exact<{
  input: CreateListingOfferInput;
}>;


export type CreateListingOfferMutation = { createListingOffer?: { amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type InviteAttributesFragment = { id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { firstName?: string | null, email?: string | null, lastName?: string | null } | null, organization?: { name?: string | null } | null };

export type SendInviteMutationVariables = Exact<{
  inviteParams?: InputMaybe<InviteInput>;
}>;


export type SendInviteMutation = { createInvite?: { id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { firstName?: string | null, email?: string | null, lastName?: string | null } | null, organization?: { name?: string | null } | null } | null };

export type ResendInviteMutationVariables = Exact<{
  resendInviteId: Scalars['ID'];
}>;


export type ResendInviteMutation = { resendInvite?: { id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { firstName?: string | null, email?: string | null, lastName?: string | null } | null, organization?: { name?: string | null } | null } | null };

export type DeclineInviteMutationVariables = Exact<{
  declineInviteId: Scalars['ID'];
}>;


export type DeclineInviteMutation = { declineInvite?: { status: string, organizationId: string } | null };

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteId: Scalars['ID'];
}>;


export type AcceptInviteMutation = { acceptInvite?: { organizationId: string, status: string } | null };

export type ListingHistoryQueryVariables = Exact<{
  listingId: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type ListingHistoryQuery = { listingHistory?: { totalCount: number, nodes?: Array<{ createdAt?: any | null, messageHtml?: string | null, createdByUser?: { firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ValuationsCoreFragment = { amount?: number | null, createdAt?: any | null, extra?: any | null, id?: number | null, listingId?: string | null, type?: string | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, lastName?: string | null, id: string } | null };

export type ListingVehicleCoreFragment = { createdAt?: any | null, displayName?: string | null, id: string, odometer?: number | null, odometerUnit?: string | null, vin?: string | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null };

export type ListingVehicleFullFragment = { auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, createdAt?: any | null, csvUnmappedData?: any | null, displayName?: string | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, id: string, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, odometer?: number | null, odometerUnit?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, vin?: string | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null };

export type ListingActivityCoreFragment = { organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null };

export type ListingCoreFragment = { id: string, saved?: boolean | null, shared?: boolean | null, receivingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, receivingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, parentListing?: { id: string } | null, statuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, currentStatus?: { createdAt?: any | null, name?: string | null } | null, tags?: Array<{ id?: string | null, name?: string | null } | null> | null, vehicle?: { createdAt?: any | null, displayName?: string | null, id: string, odometer?: number | null, odometerUnit?: string | null, vin?: string | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null } | null };

export type PurchaseInformationCoreFragment = { id: string, purchaseDate: any, purchasePrice: number, sourceType?: string | null, titleNumber?: string | null, titleReceiptDate?: any | null, titleReceived?: boolean | null, titleState?: string | null, purchaseSource?: { id: string, name: string, createdAt: any, updatedAt: any } | null };

export type SaleInformationCoreFragment = { id: string, soldDate: any, salePrice: number, saleType?: string | null, bosUrl?: string | null, generateBos?: boolean | null, address?: string | null, phone?: string | null, buyer?: { id: string, name: string, createdAt: any, updatedAt: any, address: string, phone: string } | null };

export type ListingFullFragment = { id: string, shared?: boolean | null, totalCosts: number, totalProfit: number, activity?: { internal?: Array<{ organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null, sharedBy?: Array<{ parentListingId?: string | null, organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null, sharedWith?: Array<{ receivingUserEmail?: string | null, organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null } | null, receivingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, receivingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, sharingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, parentListing?: { id: string } | null, valuations?: Array<{ amount?: number | null, createdAt?: any | null, extra?: any | null, id?: number | null, listingId?: string | null, type?: string | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null> | null, statuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, currentStatus?: { createdAt?: any | null, name?: string | null } | null, tags?: Array<{ id?: string | null, name?: string | null } | null> | null, vehicle?: { auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, createdAt?: any | null, csvUnmappedData?: any | null, displayName?: string | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, id: string, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, odometer?: number | null, odometerUnit?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, vin?: string | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null, appraisals?: Array<{ amount?: number | null, crGrade?: number | null, createdAt?: any | null, id: string, listingId: string, notes?: string | null, previousValue?: any | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, currentOffer?: { amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null, currentInternalValuation?: { id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null, internalValuationHistory?: Array<{ id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null, offerHistory?: Array<{ amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, purchaseInformation?: { id: string, purchaseDate: any, purchasePrice: number, sourceType?: string | null, titleNumber?: string | null, titleReceiptDate?: any | null, titleReceived?: boolean | null, titleState?: string | null, purchaseSource?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null, saleInformation?: { id: string, soldDate: any, salePrice: number, saleType?: string | null, bosUrl?: string | null, generateBos?: boolean | null, address?: string | null, phone?: string | null, buyer?: { id: string, name: string, createdAt: any, updatedAt: any, address: string, phone: string } | null } | null };

export type ListingLeadCoreFragment = { lead?: { valuationZip: string, leadConsumer?: { firstName: string, lastName: string, email: string, phone: string } | null, range: { to: number, from: number } } | null };

export type ListingsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>> | InputMaybe<VehicleFilters>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ListingsQuery = { listings?: { totalCount: number, nodes?: Array<{ id: string, saved?: boolean | null, shared?: boolean | null, receivingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, receivingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, parentListing?: { id: string } | null, statuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, currentStatus?: { createdAt?: any | null, name?: string | null } | null, tags?: Array<{ id?: string | null, name?: string | null } | null> | null, vehicle?: { createdAt?: any | null, displayName?: string | null, id: string, odometer?: number | null, odometerUnit?: string | null, vin?: string | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null } | null, lead?: { valuationZip: string, leadConsumer?: { firstName: string, lastName: string, email: string, phone: string } | null, range: { to: number, from: number } } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ListingQueryVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type ListingQuery = { listing?: { id: string, saved?: boolean | null, shared?: boolean | null, totalCosts: number, totalProfit: number, receivingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, receivingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, parentListing?: { id: string } | null, statuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, currentStatus?: { createdAt?: any | null, name?: string | null } | null, tags?: Array<{ id?: string | null, name?: string | null } | null> | null, vehicle?: { createdAt?: any | null, displayName?: string | null, id: string, odometer?: number | null, odometerUnit?: string | null, vin?: string | null, auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, csvUnmappedData?: any | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null, activity?: { internal?: Array<{ organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null, sharedBy?: Array<{ parentListingId?: string | null, organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null, sharedWith?: Array<{ receivingUserEmail?: string | null, organization?: { id: string, name?: string | null, imageUrl?: string | null, userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, room?: { id: string, name?: string | null, type?: RoomType | null, unreadMessagesCount?: number | null, updatedAt: any, listingId?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, createdAt: any } | null, user?: { id: string, lastName?: string | null, firstName?: string | null, imageUrl?: string | null, email?: string | null } | null } | null> | null } | null, sharingUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null, valuations?: Array<{ amount?: number | null, createdAt?: any | null, extra?: any | null, id?: number | null, listingId?: string | null, type?: string | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null> | null, appraisals?: Array<{ amount?: number | null, crGrade?: number | null, createdAt?: any | null, id: string, listingId: string, notes?: string | null, previousValue?: any | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, currentOffer?: { amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null, currentInternalValuation?: { id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null, internalValuationHistory?: Array<{ id: string, amount: number, crGrade: number, createdByUserId: string, listingId: string, notes?: string | null, createdAt: any, updatedAt: any, createdByUser?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null, offerHistory?: Array<{ amount: number, createdAt: any, id: string, notes?: string | null, updatedAt: any, createdByUserId: string, listingId: string, createdByUser?: { firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, purchaseInformation?: { id: string, purchaseDate: any, purchasePrice: number, sourceType?: string | null, titleNumber?: string | null, titleReceiptDate?: any | null, titleReceived?: boolean | null, titleState?: string | null, purchaseSource?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null, saleInformation?: { id: string, soldDate: any, salePrice: number, saleType?: string | null, bosUrl?: string | null, generateBos?: boolean | null, address?: string | null, phone?: string | null, buyer?: { id: string, name: string, createdAt: any, updatedAt: any, address: string, phone: string } | null } | null, lead?: { valuationZip: string, leadConsumer?: { firstName: string, lastName: string, email: string, phone: string } | null, range: { to: number, from: number } } | null } | null };

export type InceptionListingByVehicleIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InceptionListingByVehicleIdQuery = { inceptionListingByVehicleId?: { id: string } | null };

export type InceptionListingsByVinQueryVariables = Exact<{
  vin?: InputMaybe<Scalars['String']>;
}>;


export type InceptionListingsByVinQuery = { inceptionListingsByVin?: Array<{ id: string, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null } | null> | null };

export type CreateListingValuationMutationVariables = Exact<{
  input: CreateListingValuationInput;
}>;


export type CreateListingValuationMutation = { createListingValuation?: { amount?: number | null, createdAt?: any | null, extra?: any | null, id?: number | null, listingId?: string | null, type?: string | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null };

export type UpdateListingValuationMutationVariables = Exact<{
  input: UpdateListingValuationInput;
}>;


export type UpdateListingValuationMutation = { updateListingValuation?: { amount?: number | null, createdAt?: any | null, extra?: any | null, id?: number | null, listingId?: string | null, type?: string | null, updatedAt?: any | null, createdByUser?: { firstName?: string | null, lastName?: string | null, id: string } | null } | null };

export type UpdateListingCurrentStatusMutationVariables = Exact<{
  input: UpdateListingCurrentStatusInput;
}>;


export type UpdateListingCurrentStatusMutation = { updateListingCurrentStatus?: string | null };

export type ShareListingMutationVariables = Exact<{
  input: ShareListingInput;
}>;


export type ShareListingMutation = { shareListing?: { id: string, sharingOrganization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null } | null };

export type SaveListingMutationVariables = Exact<{
  listingId: Scalars['String'];
}>;


export type SaveListingMutation = { saveListing?: boolean | null };

export type UnsaveListingMutationVariables = Exact<{
  listingId: Scalars['String'];
}>;


export type UnsaveListingMutation = { unsaveListing?: boolean | null };

export type MessagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['ID'];
}>;


export type MessagesQuery = { messages?: { totalCount: number, nodes?: Array<{ createdAt: any, id: string, receiverId?: string | null, receiverType?: string | null, sentAt: any, text: string, senderOrganizationId?: string | null, room?: { id: string, listingId?: string | null, type?: RoomType | null } | null, sender: { id: string, firstName?: string | null, email?: string | null, lastName?: string | null, imageUrl?: string | null } } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreateMessageMutationVariables = Exact<{
  input?: InputMaybe<CreateRoomMessageInput>;
}>;


export type CreateMessageMutation = { createMessage?: { createdAt: any, id: string, receiverId?: string | null, receiverType?: string | null, sentAt: any, text: string, senderOrganizationId?: string | null, room?: { id: string, listingId?: string | null, type?: RoomType | null } | null, sender: { email?: string | null, firstName?: string | null, id: string, lastName?: string | null, imageUrl?: string | null, organizations?: Array<{ id: string, name?: string | null } | null> | null } } | null };

export type RoomsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type RoomsQuery = { rooms?: { totalCount: number, nodes?: Array<{ id: string, imageUrl?: string | null, lastMessageText?: string | null, name?: string | null, unreadMessagesCount?: number | null, type?: RoomType | null, updatedAt: any, ownerOrganization?: { id: string, name?: string | null } | null, users?: Array<{ id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null> | null, vehicle?: { id: string, displayName?: string | null, pictures?: Array<{ url?: string | null } | null> | null, currentVehicleStatus?: { name?: string | null } | null } | null } | null> | null, pageInfo: { startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null } } | null };

export type VehicleRoomsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type VehicleRoomsQuery = { vehicleRooms?: { totalCount: number, nodes?: Array<{ rooms?: Array<{ updatedAt: any, type?: RoomType | null, name?: string | null, lastMessageText?: string | null, lastMessageAt?: any | null, imageUrl?: string | null, id: string, unreadMessagesCount?: number | null, vehicle?: { id: string, reconData?: { reconTrades?: Array<{ vendor?: { id: string, name?: string | null, imageUrl?: string | null } | null } | null> | null } | null } | null, ownerOrganization?: { id: string, userRoles?: Array<{ user?: { lastName?: string | null, firstName?: string | null, imageUrl?: string | null, id: string } | null } | null> | null } | null, invitedOrganization?: { id: string, isVendor?: boolean | null } | null, users?: Array<{ imageUrl?: string | null, id: string, firstName?: string | null, lastName?: string | null } | null> | null } | null> | null, vehicle?: { id: string, make?: string | null, model?: string | null, displayName?: string | null, year?: number | null, currentVehicleStatus?: { name?: string | null } | null, pictures?: Array<{ url?: string | null } | null> | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, reconData?: { reconTrades?: Array<{ vendor?: { id: string, name?: string | null, imageUrl?: string | null } | null } | null> | null } | null } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type MarkRoomAsReadMutationVariables = Exact<{
  input?: InputMaybe<MarkRoomAsReadInput>;
}>;


export type MarkRoomAsReadMutation = { markRoomAsRead?: boolean | null };

export type RoomsForVehicleQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;


export type RoomsForVehicleQuery = { roomsForVehicle?: { rooms?: Array<{ createdAt: any, id: string, imageUrl?: string | null, lastMessageAt?: any | null, lastMessageText?: string | null, name?: string | null, unreadMessagesCount?: number | null, type?: RoomType | null, updatedAt: any, ownerOrganization?: { id: string, name?: string | null, userRoles?: Array<{ user?: { imageUrl?: string | null, lastName?: string | null, firstName?: string | null, id: string } | null } | null> | null } | null, users?: Array<{ id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null> | null, vehicle?: { id: string, displayName?: string | null, pictures?: Array<{ url?: string | null } | null> | null, currentVehicleStatus?: { name?: string | null } | null } | null } | null> | null } | null };

export type MentionableUsersQueryVariables = Exact<{
  roomType: RoomType;
  listingId: Scalars['String'];
}>;


export type MentionableUsersQuery = { mentionableUsers?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, imageUrl?: string | null } | null> | null };

export type NoteCoreFragment = { userOnly?: boolean | null, updatedAt?: any | null, note?: string | null, tag?: NoteTag | null, listingId?: string | null, id?: number | null, createdAt?: any | null, previousValue?: any | null, submitter?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null };

export type NotesQueryVariables = Exact<{
  listingId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<NoteTag>;
}>;


export type NotesQuery = { notes?: { totalCount: number, nodes?: Array<{ userOnly?: boolean | null, updatedAt?: any | null, note?: string | null, tag?: NoteTag | null, listingId?: string | null, id?: number | null, createdAt?: any | null, previousValue?: any | null, submitter?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { createNote?: { userOnly?: boolean | null, updatedAt?: any | null, note?: string | null, tag?: NoteTag | null, listingId?: string | null, id?: number | null, createdAt?: any | null, previousValue?: any | null, submitter?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { updateNote?: { userOnly?: boolean | null, updatedAt?: any | null, note?: string | null, tag?: NoteTag | null, listingId?: string | null, id?: number | null, createdAt?: any | null, previousValue?: any | null, submitter?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null };

export type NotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationsQuery = { notifications?: { totalCount: number, unreadNotifications: number, nodes?: Array<{ read: boolean, messageHtml: string, imageUrl?: string | null, id: string, createdAt?: any | null, action?: string | null, entityId: string, clicked: boolean } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ClickNotificationMutationVariables = Exact<{
  clickNotificationId: Scalars['ID'];
}>;


export type ClickNotificationMutation = { clickNotification?: boolean | null };

export type ReadNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadNotificationsMutation = { readNotifications?: boolean | null };

export type OrganizationCoreAttributesFragment = { id: string, name?: string | null, imageUrl?: string | null, addressLine1?: string | null, country?: string | null, city?: string | null, owned?: boolean | null, state?: string | null, phone?: string | null, createdAt?: any | null, zip?: string | null, dynamicStatusesEnabled?: boolean | null, dynamicTagsEnabled?: boolean | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null }>, tags?: Array<{ id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } | null> | null };

export type OrganizationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type OrganizationsQuery = { organizations?: { totalCount: number, nodes?: Array<{ id: string, name?: string | null, imageUrl?: string | null, addressLine1?: string | null, country?: string | null, city?: string | null, owned?: boolean | null, state?: string | null, phone?: string | null, createdAt?: any | null, zip?: string | null, dynamicStatusesEnabled?: boolean | null, dynamicTagsEnabled?: boolean | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null }>, tags?: Array<{ id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } | null> | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationQuery = { organization?: { imageUrl?: string | null, createdAt?: any | null, id: string, name?: string | null, addressLine1?: string | null, country?: string | null, city?: string | null, owned?: boolean | null, state?: string | null, phone?: string | null, zip?: string | null, dynamicStatusesEnabled?: boolean | null, dynamicTagsEnabled?: boolean | null, userRoles?: Array<{ owner: boolean, user?: { id: string, lastName?: string | null, firstName?: string | null, email?: string | null } | null } | null> | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null }>, tags?: Array<{ id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } | null> | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  updateOrganizationId?: InputMaybe<Scalars['ID']>;
  organization?: InputMaybe<OrganizationInput>;
}>;


export type EditOrganizationMutation = { updateOrganization?: { id: string } | null };

export type OrganizationUserRolesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationUserRolesQuery = { organization?: { userRoles?: Array<{ owner: boolean, user?: { id: string, lastName?: string | null, firstName?: string | null, email?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type OrganizationBasicInfoQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationBasicInfoQuery = { organization?: { id: string, name?: string | null, imageUrl?: string | null, addressLine1?: string | null, country?: string | null, city?: string | null, owned?: boolean | null, state?: string | null, phone?: string | null, createdAt?: any | null, zip?: string | null, dynamicStatusesEnabled?: boolean | null, dynamicTagsEnabled?: boolean | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null }>, tags?: Array<{ id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } | null> | null } | null };

export type EditSystemOrganizationMutationVariables = Exact<{
  input?: InputMaybe<UpdateSystemOrganizationInput>;
}>;


export type EditSystemOrganizationMutation = { systemUpdateOrganization?: { id: string } | null };

export type CreateOrganizationStatusMutationVariables = Exact<{
  input: CreateOrganizationStatusInput;
}>;


export type CreateOrganizationStatusMutation = { createOrganizationStatus: { id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } };

export type UpdateOrganizationStatusMutationVariables = Exact<{
  input: UpdateOrganizationStatusInput;
}>;


export type UpdateOrganizationStatusMutation = { updateOrganizationStatus: { id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } };

export type CreateOrganizationTagMutationVariables = Exact<{
  input: CreateOrganizationTagInput;
}>;


export type CreateOrganizationTagMutation = { createOrganizationTag: { id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } };

export type UpdateOrganizationTagMutationVariables = Exact<{
  input: UpdateOrganizationTagInput;
}>;


export type UpdateOrganizationTagMutation = { updateOrganizationTag: { id?: string | null, name?: string | null, listingCounts: number, updatedAt?: any | null, updatedByUser?: { id: string, firstName?: string | null, lastName?: string | null, scopes?: Array<Scope | null> | null } | null } };

export type InvitesOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type InvitesOrganizationQuery = { organization?: { name?: string | null, id: string, pendingInvites?: Array<{ id: string, email: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type DeleteSentInviteMutationVariables = Exact<{
  deleteInviteId: Scalars['ID'];
}>;


export type DeleteSentInviteMutation = { deleteInvite?: { status: string } | null };

export type OrganizationListingStatusesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationListingStatusesQuery = { organizationListingStatuses: Array<{ id: string, name: string, isDefault: boolean, listingCounts: number, updatedAt: any }> };

export type UserRoleAttributesFragment = { id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null };

export type MembersOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type MembersOrganizationQuery = { organization?: { userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveMemberMutation = { removeMember?: boolean | null };

export type UpdateMemberRoleMutationVariables = Exact<{
  userId: Scalars['ID'];
  role: MemberRole;
  updateMemberRoleId: Scalars['ID'];
}>;


export type UpdateMemberRoleMutation = { updateMemberRole?: { id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null };

export type OrganizationNameImageQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationNameImageQuery = { organization?: { name?: string | null, imageUrl?: string | null } | null };

export type PurchaseSourcesQueryVariables = Exact<{
  listingId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
}>;


export type PurchaseSourcesQuery = { purchaseSources?: { nodes?: Array<{ id: string, name: string } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type UpsertPurchaseInformationMutationVariables = Exact<{
  input: UpsertPurchaseInformationInput;
}>;


export type UpsertPurchaseInformationMutation = { upsertPurchaseInformation?: { id: string, purchaseDate: any, purchasePrice: number, sourceType?: string | null, titleNumber?: string | null, titleReceiptDate?: any | null, titleReceived?: boolean | null, titleState?: string | null, purchaseSource?: { id: string, name: string, createdAt: any, updatedAt: any } | null } | null };

export type CreatePurchaseSourceMutationVariables = Exact<{
  input: CreatePurchaseSourceInput;
}>;


export type CreatePurchaseSourceMutation = { createPurchaseSource?: { id: string } | null };

export type BuyersQueryVariables = Exact<{
  listingId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
}>;


export type BuyersQuery = { buyers?: { nodes?: Array<{ id: string, name: string, address: string, phone: string } | null> | null } | null };

export type CreateBuyerMutationVariables = Exact<{
  input: CreateBuyerInput;
}>;


export type CreateBuyerMutation = { createBuyer?: { id: string } | null };

export type UpsertSaleInformationMutationVariables = Exact<{
  input: UpsertSaleInformationInput;
}>;


export type UpsertSaleInformationMutation = { upsertSaleInformation?: { id: string, soldDate: any, salePrice: number, saleType?: string | null, bosUrl?: string | null, generateBos?: boolean | null, address?: string | null, phone?: string | null, buyer?: { id: string, name: string, createdAt: any, updatedAt: any, address: string, phone: string } | null } | null };

export type TagsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type TagsQuery = { tags?: Array<{ id?: string | null, name?: string | null, listingCounts: number } | null> | null };

export type UpdateListingTagsMutationVariables = Exact<{
  input?: InputMaybe<UpdateListingTagsInput>;
}>;


export type UpdateListingTagsMutation = { updateListingTags?: { id: string, tags?: Array<{ id?: string | null, name?: string | null } | null> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null, scopes?: Array<Scope | null> | null, organizations?: Array<{ id: string, name?: string | null, addressLine1?: string | null, state?: string | null, city?: string | null, imageUrl?: string | null, phone?: string | null, owned?: boolean | null, isVendor?: boolean | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null> | null, invites?: Array<{ id: string, organization?: { id: string, name?: string | null, imageUrl?: string | null, statuses: Array<{ id: string, isDefault: boolean, listingCounts: number, name: string, updatedAt: any }> } | null, inviter?: { id: string, email?: string | null } | null } | null> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateMeMutation = { updateMe?: { firstName?: string | null, lastName?: string | null } | null };

export type AddDeviceTokenMutationVariables = Exact<{
  input?: InputMaybe<AddDeviceTokenInput>;
}>;


export type AddDeviceTokenMutation = { addDeviceToken?: { token: string } | null };

export type VehicleCoreFragment = { auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, createdAt?: any | null, displayName?: string | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, id: string, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, odometer?: number | null, odometerUnit?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, estimatedSellPrice?: number | null, hammerPrice?: number | null, purchasePrice?: number | null, preSaleNotes?: string | null, sellPrice?: number | null, vin?: string | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, currentReconStatus?: { createdAt?: any | null, name?: string | null } | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, reconStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null, reconData?: { estimatedReconPrice?: number | null, needsParts?: boolean | null, reconTrades?: Array<{ estimatedDays?: number | null, started?: boolean | null, startedAt?: any | null, trade?: Trades | null, tradeCount?: number | null, ownerCompleted?: boolean | null, ownerCompletedAt?: any | null, vendorCompleted?: boolean | null, vendorCompletedAt?: any | null, repairPrice?: number | null, vendor?: { id: string, imageUrl?: string | null, isVendor?: boolean | null, name?: string | null } | null } | null> | null } | null };

export type VehiclesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>> | InputMaybe<VehicleFilters>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type VehiclesQuery = { vehicles?: { totalCount: number, nodes?: Array<{ auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, createdAt?: any | null, displayName?: string | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, id: string, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, odometer?: number | null, odometerUnit?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, estimatedSellPrice?: number | null, hammerPrice?: number | null, purchasePrice?: number | null, preSaleNotes?: string | null, sellPrice?: number | null, vin?: string | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, currentReconStatus?: { createdAt?: any | null, name?: string | null } | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, reconStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null, reconData?: { estimatedReconPrice?: number | null, needsParts?: boolean | null, reconTrades?: Array<{ estimatedDays?: number | null, started?: boolean | null, startedAt?: any | null, trade?: Trades | null, tradeCount?: number | null, ownerCompleted?: boolean | null, ownerCompletedAt?: any | null, vendorCompleted?: boolean | null, vendorCompletedAt?: any | null, repairPrice?: number | null, vendor?: { id: string, imageUrl?: string | null, isVendor?: boolean | null, name?: string | null } | null } | null> | null } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type VehicleQueryVariables = Exact<{
  vehicleId: Scalars['ID'];
}>;


export type VehicleQuery = { vehicle?: { auctionLane?: string | null, auctionName?: string | null, auctionRunNumber?: string | null, auctionInspection?: boolean | null, createdAt?: any | null, displayName?: string | null, drivetrain?: string | null, endTime?: any | null, engine?: string | null, exteriorColor?: string | null, grade?: number | null, id: string, interiorColor?: string | null, make?: string | null, mmr?: number | null, model?: string | null, odometer?: number | null, odometerUnit?: string | null, startTime?: any | null, submissionId?: string | null, transmission?: string | null, trim?: string | null, updatedAt?: any | null, estimatedSellPrice?: number | null, hammerPrice?: number | null, purchasePrice?: number | null, preSaleNotes?: string | null, sellPrice?: number | null, vin?: string | null, year?: number | null, vehicleType?: string | null, providerInternalVehicleID?: string | null, currentReconStatus?: { createdAt?: any | null, name?: string | null } | null, currentVehicleStatus?: { createdAt?: any | null, name?: string | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, reconStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, vehicleStatuses?: Array<{ createdAt?: any | null, name?: string | null } | null> | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, submitter?: { firstName?: string | null, lastName?: string | null, id: string } | null, reconData?: { estimatedReconPrice?: number | null, needsParts?: boolean | null, reconTrades?: Array<{ estimatedDays?: number | null, started?: boolean | null, startedAt?: any | null, trade?: Trades | null, tradeCount?: number | null, ownerCompleted?: boolean | null, ownerCompletedAt?: any | null, vendorCompleted?: boolean | null, vendorCompletedAt?: any | null, repairPrice?: number | null, vendor?: { id: string, imageUrl?: string | null, isVendor?: boolean | null, name?: string | null } | null } | null> | null } | null } | null };

export type UpdateVehicleCurrentStatusMutationVariables = Exact<{
  input: UpdateVehicleCurrentStatusInput;
}>;


export type UpdateVehicleCurrentStatusMutation = { updateVehicleCurrentStatus?: string | null };

export type VendorVehiclesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<VehicleFilters>> | InputMaybe<VehicleFilters>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type VendorVehiclesQuery = { vendorVehicles?: { totalCount: number, nodes?: Array<{ id: string, make?: string | null, model?: string | null, year?: number | null, vin?: string | null, displayName?: string | null, odometer?: number | null, odometerUnit?: string | null, trim?: string | null, exteriorColor?: string | null, interiorColor?: string | null, reconData?: { needsParts?: boolean | null, estimatedReconPrice?: number | null, reconTrades?: Array<{ estimatedDays?: number | null, started?: boolean | null, startedAt?: any | null, trade?: Trades | null, tradeCount?: number | null, ownerCompleted?: boolean | null, ownerCompletedAt?: any | null, vendorCompleted?: boolean | null, vendorCompletedAt?: any | null, vendor?: { id: string, imageUrl?: string | null, isVendor?: boolean | null, name?: string | null } | null } | null> | null } | null, pictures?: Array<{ description?: string | null, url?: string | null } | null> | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, submitter?: { firstName?: string | null, lastName?: string | null } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type VehicleIdByVinQueryVariables = Exact<{
  vin: Scalars['String'];
}>;


export type VehicleIdByVinQuery = { vehicleIdByVin?: string | null };

export type ShareVehicleMutationVariables = Exact<{
  input: ShareVehicleInput;
}>;


export type ShareVehicleMutation = { shareVehicle?: { id: string } | null };

export type DrilldownMakeInformationQueryVariables = Exact<{
  input: VehicleDrilldownInput;
}>;


export type DrilldownMakeInformationQuery = { vehiclesDrilldownInformation: Array<{ makeValue: string }> };

export type DrilldownModelInformationQueryVariables = Exact<{
  input: VehicleDrilldownInput;
}>;


export type DrilldownModelInformationQuery = { vehiclesDrilldownInformation: Array<{ modelDrilldown: Array<{ modelValue: string }> }> };

export type DrilldownTrimInformationQueryVariables = Exact<{
  input: VehicleDrilldownInput;
}>;


export type DrilldownTrimInformationQuery = { vehiclesDrilldownInformation: Array<{ modelDrilldown: Array<{ trimDrilldown: Array<{ trimValue: string }> }> }> };

export type DrilldownStyleInformationQueryVariables = Exact<{
  input: VehicleDrilldownInput;
}>;


export type DrilldownStyleInformationQuery = { vehiclesDrilldownInformation: Array<{ modelDrilldown: Array<{ trimDrilldown: Array<{ styleDrilldown: Array<{ styleValue: string, uvc: string }> }> }> }> };

export type AutocompleteQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type AutocompleteQuery = { vehiclesAutocomplete: Array<{ make: string, model: string, style: string, trim: string, uvc: string, year: number }> };

export type LicensePlateQueryVariables = Exact<{
  input: LicensePlateInput;
}>;


export type LicensePlateQuery = { vehiclesByLicensePlate: Array<{ make: string, model: string, style: string, trim: string, uvc: string, year: number }> };

export type DecodeQueryVariables = Exact<{
  vin: Scalars['String'];
}>;


export type DecodeQuery = { decode?: { make?: string | null, model?: string | null, vin?: string | null, year?: number | null, styles?: Array<{ series?: string | null, provider?: string | null, styleId?: string | null, title?: string | null } | null> | null } | null };

export const PaginationCoreFragmentDoc = gql`
    fragment PaginationCore on PageInfo {
  hasNextPage
  startCursor
  hasPreviousPage
  endCursor
}
    `;
export const OrganizationListingStatusCoreFragmentDoc = gql`
    fragment OrganizationListingStatusCore on OrganizationListingStatus {
  id
  isDefault
  listingCounts
  name
  updatedAt
}
    `;
export const OrganizationCoreFragmentDoc = gql`
    fragment OrganizationCore on Organization {
  name
  id
  imageUrl
  statuses {
    ...OrganizationListingStatusCore
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}`;
export const UserCoreFragmentDoc = gql`
    fragment UserCore on User {
  firstName
  id
  lastName
  imageUrl
}
    `;
export const ConnectionsCoreFragmentDoc = gql`
    fragment ConnectionsCore on Connection {
  createdAt
  id
  inviteId
  originOrganization {
    ...OrganizationCore
  }
  originOrganizationId
  originUser {
    ...UserCore
    email
  }
  originUserId
  targetOrganization {
    ...OrganizationCore
  }
  targetOrganizationId
  targetUser {
    ...UserCore
    email
  }
  targetUserId
  updatedAt
}
    ${OrganizationCoreFragmentDoc}
${UserCoreFragmentDoc}`;
export const ConnectionsInviteCoreFragmentDoc = gql`
    fragment ConnectionsInviteCore on ConnectionInvite {
  createdAt
  id
  originOrganization {
    ...OrganizationCore
  }
  originOrganizationId
  originUser {
    ...UserCore
    email
  }
  originUserId
  resolvedAt
  status
  targetEmail
  targetOrganization {
    ...OrganizationCore
  }
  targetOrganizationId
  targetUser {
    ...UserCore
    email
  }
  updatedAt
}
    ${OrganizationCoreFragmentDoc}
${UserCoreFragmentDoc}`;
export const DocumentCoreFragmentDoc = gql`
    fragment DocumentCore on Document {
  id
  name
  type
  url
  uploadedAt
  createdAt
  updatedAt
}
    `;
export const ExpenseCoreFragmentDoc = gql`
    fragment ExpenseCore on Expense {
  id
  updatedAt
  createdAt
  expenseDate
  uploadedAt
  vendor {
    id
    name
    createdAt
    updatedAt
  }
  url
  type
  description
  amount
  documentName
}
    `;
export const FilterCountCoreFragmentDoc = gql`
    fragment FilterCountCore on FilterElement {
  key
  count
  __typename
}
    `;
export const ValuationFieldsFragmentDoc = gql`
    fragment ValuationFields on Valuation {
  adjusted
  adjusted_history
  base
  history
  mileage
  options
}
    `;
export const ValuationCategoryFieldsFragmentDoc = gql`
    fragment ValuationCategoryFields on ValuationCategory {
  avg {
    ...ValuationFields
  }
  cln {
    ...ValuationFields
  }
  rgh {
    ...ValuationFields
  }
  xcln {
    ...ValuationFields
  }
}
    ${ValuationFieldsFragmentDoc}`;
export const InviteAttributesFragmentDoc = gql`
    fragment InviteAttributes on Invite {
  id
  email
  owner
  organizationId
  createdByUserId
  status
  createdAt
  updatedAt
  acceptedAt
  declinedAt
  deletedAt
  inviter {
    firstName
    lastName
    email
  }
  user {
    firstName
    email
    lastName
  }
  organization {
    name
  }
}
    `;
export const ListingVehicleCoreFragmentDoc = gql`
    fragment ListingVehicleCore on Vehicle {
  createdAt
  displayName
  id
  odometer
  odometerUnit
  pictures {
    description
    url
  }
  vin
}
    `;
export const ListingCoreFragmentDoc = gql`
    fragment ListingCore on Listing {
  id
  receivingOrganization {
    id
    name
    imageUrl
    statuses {
      ...OrganizationListingStatusCore
    }
  }
  receivingUser {
    ...UserCore
  }
  sharingOrganization {
    id
    name
    imageUrl
    statuses {
      ...OrganizationListingStatusCore
    }
  }
  parentListing {
    id
  }
  saved
  shared
  statuses {
    createdAt
    name
  }
  currentStatus {
    createdAt
    name
  }
  tags {
    id
    name
  }
  vehicle {
    ...ListingVehicleCore
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}
${UserCoreFragmentDoc}
${ListingVehicleCoreFragmentDoc}`;
export const ListingActivityCoreFragmentDoc = gql`
    fragment ListingActivityCore on ListingActivity {
  organization {
    id
    name
    imageUrl
    userRoles {
      id
      owner
      user {
        id
        firstName
        lastName
      }
    }
    statuses {
      ...OrganizationListingStatusCore
    }
  }
  room {
    id
    name
    type
    unreadMessagesCount
    updatedAt
    listingId
    lastMessageText
    lastMessageAt
    createdAt
  }
  user {
    id
    lastName
    firstName
    imageUrl
    email
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}`;
export const ValuationsCoreFragmentDoc = gql`
    fragment ValuationsCore on ListingValuation {
  amount
  createdAt
  createdByUser {
    firstName
    lastName
    id
  }
  extra
  id
  listingId
  type
  updatedAt
}
    `;
export const ListingVehicleFullFragmentDoc = gql`
    fragment ListingVehicleFull on Vehicle {
  auctionLane
  auctionName
  auctionRunNumber
  auctionInspection
  createdAt
  csvUnmappedData
  currentVehicleStatus {
    createdAt
    name
  }
  displayName
  drivetrain
  endTime
  engine
  exteriorColor
  grade
  id
  interiorColor
  make
  mmr
  model
  odometer
  odometerUnit
  pictures {
    description
    url
  }
  startTime
  submissionId
  transmission
  trim
  updatedAt
  vehicleStatuses {
    createdAt
    name
  }
  submitter {
    firstName
    lastName
    id
  }
  vin
  year
  vehicleType
  providerInternalVehicleID
}
    `;
export const AppraisalFieldsFragmentDoc = gql`
    fragment AppraisalFields on Appraisal {
  amount
  crGrade
  createdAt
  createdByUser {
    ...UserCore
  }
  id
  listingId
  notes
  previousValue
  updatedAt
}
    ${UserCoreFragmentDoc}`;
export const OfferFieldsFragmentDoc = gql`
    fragment OfferFields on Offer {
  amount
  createdAt
  id
  notes
  updatedAt
  createdByUser {
    ...UserCore
  }
  createdByUserId
  listingId
}
    ${UserCoreFragmentDoc}`;
export const InternalValuationFieldsFragmentDoc = gql`
    fragment InternalValuationFields on InternalValuation {
  id
  amount
  crGrade
  createdByUser {
    id
    imageUrl
    firstName
    lastName
  }
  createdByUserId
  listingId
  notes
  createdAt
  updatedAt
}
    `;
export const PurchaseInformationCoreFragmentDoc = gql`
    fragment PurchaseInformationCore on PurchaseInformation {
  id
  purchaseDate
  purchasePrice
  purchaseSource {
    id
    name
    createdAt
    updatedAt
  }
  sourceType
  titleNumber
  titleReceiptDate
  titleReceived
  titleState
}
    `;
export const SaleInformationCoreFragmentDoc = gql`
    fragment SaleInformationCore on SaleInformation {
  id
  soldDate
  salePrice
  buyer {
    id
    name
    createdAt
    updatedAt
    address
    phone
  }
  saleType
  bosUrl
  generateBos
  address
  phone
}
    `;
export const ListingFullFragmentDoc = gql`
    fragment ListingFull on Listing {
  id
  activity {
    internal {
      ...ListingActivityCore
    }
    sharedBy {
      ...ListingActivityCore
      parentListingId
    }
    sharedWith {
      ...ListingActivityCore
      receivingUserEmail
    }
  }
  receivingOrganization {
    id
    name
    imageUrl
    statuses {
      ...OrganizationListingStatusCore
    }
  }
  receivingUser {
    ...UserCore
  }
  sharingOrganization {
    id
    name
    imageUrl
    statuses {
      ...OrganizationListingStatusCore
    }
  }
  sharingUser {
    ...UserCore
  }
  parentListing {
    id
  }
  shared
  totalCosts
  totalProfit
  valuations {
    ...ValuationsCore
  }
  statuses {
    createdAt
    name
  }
  currentStatus {
    createdAt
    name
  }
  tags {
    id
    name
  }
  vehicle {
    ...ListingVehicleFull
  }
  appraisals {
    ...AppraisalFields
  }
  currentOffer {
    ...OfferFields
  }
  currentInternalValuation {
    ...InternalValuationFields
  }
  internalValuationHistory {
    ...InternalValuationFields
  }
  offerHistory {
    ...OfferFields
  }
  purchaseInformation {
    ...PurchaseInformationCore
  }
  saleInformation {
    ...SaleInformationCore
  }
}
    ${ListingActivityCoreFragmentDoc}
${OrganizationListingStatusCoreFragmentDoc}
${UserCoreFragmentDoc}
${ValuationsCoreFragmentDoc}
${ListingVehicleFullFragmentDoc}
${AppraisalFieldsFragmentDoc}
${OfferFieldsFragmentDoc}
${InternalValuationFieldsFragmentDoc}
${PurchaseInformationCoreFragmentDoc}
${SaleInformationCoreFragmentDoc}`;
export const ListingLeadCoreFragmentDoc = gql`
    fragment ListingLeadCore on Listing {
  lead {
    leadConsumer {
      firstName
      lastName
      email
      phone
    }
    range {
      to
      from
    }
    valuationZip
  }
}
    `;
export const NoteCoreFragmentDoc = gql`
    fragment NoteCore on Note {
  userOnly
  updatedAt
  note
  tag
  listingId
  id
  createdAt
  submitter {
    id
    firstName
    lastName
    imageUrl
  }
  previousValue
}
    `;
export const UserWithScopesCoreFragmentDoc = gql`
    fragment UserWithScopesCore on User {
  id
  firstName
  lastName
  scopes
}
    `;
export const TagCoreFragmentDoc = gql`
    fragment TagCore on Tag {
  id
  name
  listingCounts
  updatedAt
}
    `;
export const OrganizationCoreAttributesFragmentDoc = gql`
    fragment OrganizationCoreAttributes on Organization {
  id
  name
  imageUrl
  addressLine1
  country
  city
  owned
  state
  phone
  createdAt
  zip
  dynamicStatusesEnabled
  dynamicTagsEnabled
  statuses {
    ...OrganizationListingStatusCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
  tags {
    ...TagCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}
${UserWithScopesCoreFragmentDoc}
${TagCoreFragmentDoc}`;
export const UserRoleAttributesFragmentDoc = gql`
    fragment UserRoleAttributes on UserRole {
  id
  owner
  user {
    id
    firstName
    lastName
    email
    phone
    imageUrl
  }
}
    `;
export const VehicleCoreFragmentDoc = gql`
    fragment VehicleCore on Vehicle {
  auctionLane
  auctionName
  auctionRunNumber
  auctionInspection
  createdAt
  currentReconStatus {
    createdAt
    name
  }
  currentVehicleStatus {
    createdAt
    name
  }
  displayName
  drivetrain
  endTime
  engine
  exteriorColor
  grade
  id
  interiorColor
  make
  mmr
  model
  odometer
  odometerUnit
  pictures {
    description
    url
  }
  reconStatuses {
    createdAt
    name
  }
  startTime
  submissionId
  transmission
  trim
  updatedAt
  vehicleStatuses {
    createdAt
    name
  }
  organization {
    id
    name
    imageUrl
  }
  submitter {
    firstName
    lastName
    id
  }
  reconData {
    estimatedReconPrice
    needsParts
    reconTrades {
      estimatedDays
      started
      startedAt
      trade
      tradeCount
      ownerCompleted
      ownerCompletedAt
      vendor {
        id
        imageUrl
        isVendor
        name
      }
      vendorCompleted
      vendorCompletedAt
      repairPrice
    }
  }
  estimatedSellPrice
  hammerPrice
  purchasePrice
  preSaleNotes
  sellPrice
  vin
  year
  vehicleType
  providerInternalVehicleID
}
    `;
export const BulkShareListingsDocument = gql`
    mutation BulkShareListings($input: BulkShareListingsInput!) {
  bulkShareListings(input: $input) {
    id
    status
    actionType
    createdAt
  }
}
    `;
export type BulkShareListingsMutationFn = Apollo.MutationFunction<BulkShareListingsMutation, BulkShareListingsMutationVariables>;

/**
 * __useBulkShareListingsMutation__
 *
 * To run a mutation, you first call `useBulkShareListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkShareListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkShareListingsMutation, { data, loading, error }] = useBulkShareListingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkShareListingsMutation(baseOptions?: Apollo.MutationHookOptions<BulkShareListingsMutation, BulkShareListingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkShareListingsMutation, BulkShareListingsMutationVariables>(BulkShareListingsDocument, options);
      }
export type BulkShareListingsMutationHookResult = ReturnType<typeof useBulkShareListingsMutation>;
export type BulkShareListingsMutationResult = Apollo.MutationResult<BulkShareListingsMutation>;
export type BulkShareListingsMutationOptions = Apollo.BaseMutationOptions<BulkShareListingsMutation, BulkShareListingsMutationVariables>;
export const BulkUpdateListingsTagsDocument = gql`
    mutation BulkUpdateListingsTags($input: BulkUpdateListingsTagsInput!) {
  bulkUpdateListingsTags(input: $input) {
    id
    actionType
    status
    createdAt
  }
}
    `;
export type BulkUpdateListingsTagsMutationFn = Apollo.MutationFunction<BulkUpdateListingsTagsMutation, BulkUpdateListingsTagsMutationVariables>;

/**
 * __useBulkUpdateListingsTagsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateListingsTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateListingsTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateListingsTagsMutation, { data, loading, error }] = useBulkUpdateListingsTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateListingsTagsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateListingsTagsMutation, BulkUpdateListingsTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateListingsTagsMutation, BulkUpdateListingsTagsMutationVariables>(BulkUpdateListingsTagsDocument, options);
      }
export type BulkUpdateListingsTagsMutationHookResult = ReturnType<typeof useBulkUpdateListingsTagsMutation>;
export type BulkUpdateListingsTagsMutationResult = Apollo.MutationResult<BulkUpdateListingsTagsMutation>;
export type BulkUpdateListingsTagsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateListingsTagsMutation, BulkUpdateListingsTagsMutationVariables>;
export const BulkToggleSaveListingsDocument = gql`
    mutation BulkToggleSaveListings($input: BulkToggleSaveListingsInput!) {
  bulkToggleSaveListings(input: $input) {
    id
    status
    actionType
  }
}
    `;
export type BulkToggleSaveListingsMutationFn = Apollo.MutationFunction<BulkToggleSaveListingsMutation, BulkToggleSaveListingsMutationVariables>;

/**
 * __useBulkToggleSaveListingsMutation__
 *
 * To run a mutation, you first call `useBulkToggleSaveListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkToggleSaveListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkToggleSaveListingsMutation, { data, loading, error }] = useBulkToggleSaveListingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkToggleSaveListingsMutation(baseOptions?: Apollo.MutationHookOptions<BulkToggleSaveListingsMutation, BulkToggleSaveListingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkToggleSaveListingsMutation, BulkToggleSaveListingsMutationVariables>(BulkToggleSaveListingsDocument, options);
      }
export type BulkToggleSaveListingsMutationHookResult = ReturnType<typeof useBulkToggleSaveListingsMutation>;
export type BulkToggleSaveListingsMutationResult = Apollo.MutationResult<BulkToggleSaveListingsMutation>;
export type BulkToggleSaveListingsMutationOptions = Apollo.BaseMutationOptions<BulkToggleSaveListingsMutation, BulkToggleSaveListingsMutationVariables>;
export const BulkUpdateListingsCurrentStatusDocument = gql`
    mutation BulkUpdateListingsCurrentStatus($input: BulkUpdateListingsCurrentStatusInput!) {
  bulkUpdateListingsCurrentStatus(input: $input) {
    id
    status
    actionType
    createdAt
  }
}
    `;
export type BulkUpdateListingsCurrentStatusMutationFn = Apollo.MutationFunction<BulkUpdateListingsCurrentStatusMutation, BulkUpdateListingsCurrentStatusMutationVariables>;

/**
 * __useBulkUpdateListingsCurrentStatusMutation__
 *
 * To run a mutation, you first call `useBulkUpdateListingsCurrentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateListingsCurrentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateListingsCurrentStatusMutation, { data, loading, error }] = useBulkUpdateListingsCurrentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateListingsCurrentStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateListingsCurrentStatusMutation, BulkUpdateListingsCurrentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateListingsCurrentStatusMutation, BulkUpdateListingsCurrentStatusMutationVariables>(BulkUpdateListingsCurrentStatusDocument, options);
      }
export type BulkUpdateListingsCurrentStatusMutationHookResult = ReturnType<typeof useBulkUpdateListingsCurrentStatusMutation>;
export type BulkUpdateListingsCurrentStatusMutationResult = Apollo.MutationResult<BulkUpdateListingsCurrentStatusMutation>;
export type BulkUpdateListingsCurrentStatusMutationOptions = Apollo.BaseMutationOptions<BulkUpdateListingsCurrentStatusMutation, BulkUpdateListingsCurrentStatusMutationVariables>;
export const ConnectionsDocument = gql`
    query Connections($after: String, $before: String, $first: Int, $last: Int, $organizationIds: [String]) {
  connections(
    after: $after
    before: $before
    first: $first
    last: $last
    organizationIds: $organizationIds
  ) {
    nodes {
      ...ConnectionsCore
    }
    pageInfo {
      ...PaginationCore
    }
    totalCount
  }
}
    ${ConnectionsCoreFragmentDoc}
${PaginationCoreFragmentDoc}`;

/**
 * __useConnectionsQuery__
 *
 * To run a query within a React component, call `useConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
      }
export function useConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export type ConnectionsQueryHookResult = ReturnType<typeof useConnectionsQuery>;
export type ConnectionsLazyQueryHookResult = ReturnType<typeof useConnectionsLazyQuery>;
export type ConnectionsQueryResult = Apollo.QueryResult<ConnectionsQuery, ConnectionsQueryVariables>;
export const ConnectionInvitesDocument = gql`
    query ConnectionInvites($after: String, $before: String, $first: Int, $last: Int, $organizationIds: [String], $statuses: [ConnectionInviteStatus]) {
  connectionInvites(
    after: $after
    before: $before
    first: $first
    last: $last
    organizationIds: $organizationIds
    statuses: $statuses
  ) {
    nodes {
      ...ConnectionsInviteCore
    }
    pageInfo {
      ...PaginationCore
    }
    totalCount
  }
}
    ${ConnectionsInviteCoreFragmentDoc}
${PaginationCoreFragmentDoc}`;

/**
 * __useConnectionInvitesQuery__
 *
 * To run a query within a React component, call `useConnectionInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionInvitesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      organizationIds: // value for 'organizationIds'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useConnectionInvitesQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionInvitesQuery, ConnectionInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionInvitesQuery, ConnectionInvitesQueryVariables>(ConnectionInvitesDocument, options);
      }
export function useConnectionInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionInvitesQuery, ConnectionInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionInvitesQuery, ConnectionInvitesQueryVariables>(ConnectionInvitesDocument, options);
        }
export type ConnectionInvitesQueryHookResult = ReturnType<typeof useConnectionInvitesQuery>;
export type ConnectionInvitesLazyQueryHookResult = ReturnType<typeof useConnectionInvitesLazyQuery>;
export type ConnectionInvitesQueryResult = Apollo.QueryResult<ConnectionInvitesQuery, ConnectionInvitesQueryVariables>;
export const AcceptConnectionInviteDocument = gql`
    mutation AcceptConnectionInvite($input: AcceptConnectionInviteInput!) {
  acceptConnectionInvite(input: $input) {
    ...ConnectionsInviteCore
  }
}
    ${ConnectionsInviteCoreFragmentDoc}`;
export type AcceptConnectionInviteMutationFn = Apollo.MutationFunction<AcceptConnectionInviteMutation, AcceptConnectionInviteMutationVariables>;

/**
 * __useAcceptConnectionInviteMutation__
 *
 * To run a mutation, you first call `useAcceptConnectionInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptConnectionInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptConnectionInviteMutation, { data, loading, error }] = useAcceptConnectionInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptConnectionInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptConnectionInviteMutation, AcceptConnectionInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptConnectionInviteMutation, AcceptConnectionInviteMutationVariables>(AcceptConnectionInviteDocument, options);
      }
export type AcceptConnectionInviteMutationHookResult = ReturnType<typeof useAcceptConnectionInviteMutation>;
export type AcceptConnectionInviteMutationResult = Apollo.MutationResult<AcceptConnectionInviteMutation>;
export type AcceptConnectionInviteMutationOptions = Apollo.BaseMutationOptions<AcceptConnectionInviteMutation, AcceptConnectionInviteMutationVariables>;
export const DeclineConnectionInviteDocument = gql`
    mutation DeclineConnectionInvite($declineConnectionInviteId: ID!) {
  declineConnectionInvite(id: $declineConnectionInviteId) {
    ...ConnectionsInviteCore
  }
}
    ${ConnectionsInviteCoreFragmentDoc}`;
export type DeclineConnectionInviteMutationFn = Apollo.MutationFunction<DeclineConnectionInviteMutation, DeclineConnectionInviteMutationVariables>;

/**
 * __useDeclineConnectionInviteMutation__
 *
 * To run a mutation, you first call `useDeclineConnectionInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineConnectionInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineConnectionInviteMutation, { data, loading, error }] = useDeclineConnectionInviteMutation({
 *   variables: {
 *      declineConnectionInviteId: // value for 'declineConnectionInviteId'
 *   },
 * });
 */
export function useDeclineConnectionInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineConnectionInviteMutation, DeclineConnectionInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineConnectionInviteMutation, DeclineConnectionInviteMutationVariables>(DeclineConnectionInviteDocument, options);
      }
export type DeclineConnectionInviteMutationHookResult = ReturnType<typeof useDeclineConnectionInviteMutation>;
export type DeclineConnectionInviteMutationResult = Apollo.MutationResult<DeclineConnectionInviteMutation>;
export type DeclineConnectionInviteMutationOptions = Apollo.BaseMutationOptions<DeclineConnectionInviteMutation, DeclineConnectionInviteMutationVariables>;
export const RemoveConnectionDocument = gql`
    mutation RemoveConnection($connectionId: ID!) {
  removeConnection(connectionId: $connectionId)
}
    `;
export type RemoveConnectionMutationFn = Apollo.MutationFunction<RemoveConnectionMutation, RemoveConnectionMutationVariables>;

/**
 * __useRemoveConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnectionMutation, { data, loading, error }] = useRemoveConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useRemoveConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConnectionMutation, RemoveConnectionMutationVariables>(RemoveConnectionDocument, options);
      }
export type RemoveConnectionMutationHookResult = ReturnType<typeof useRemoveConnectionMutation>;
export type RemoveConnectionMutationResult = Apollo.MutationResult<RemoveConnectionMutation>;
export type RemoveConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>;
export const ClaimWidgetValuationDocument = gql`
    mutation ClaimWidgetValuation($claimWidgetValuationId: ID!) {
  claimWidgetValuation(id: $claimWidgetValuationId)
}
    `;
export type ClaimWidgetValuationMutationFn = Apollo.MutationFunction<ClaimWidgetValuationMutation, ClaimWidgetValuationMutationVariables>;

/**
 * __useClaimWidgetValuationMutation__
 *
 * To run a mutation, you first call `useClaimWidgetValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimWidgetValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimWidgetValuationMutation, { data, loading, error }] = useClaimWidgetValuationMutation({
 *   variables: {
 *      claimWidgetValuationId: // value for 'claimWidgetValuationId'
 *   },
 * });
 */
export function useClaimWidgetValuationMutation(baseOptions?: Apollo.MutationHookOptions<ClaimWidgetValuationMutation, ClaimWidgetValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimWidgetValuationMutation, ClaimWidgetValuationMutationVariables>(ClaimWidgetValuationDocument, options);
      }
export type ClaimWidgetValuationMutationHookResult = ReturnType<typeof useClaimWidgetValuationMutation>;
export type ClaimWidgetValuationMutationResult = Apollo.MutationResult<ClaimWidgetValuationMutation>;
export type ClaimWidgetValuationMutationOptions = Apollo.BaseMutationOptions<ClaimWidgetValuationMutation, ClaimWidgetValuationMutationVariables>;
export const CreateListingImportDocument = gql`
    mutation CreateListingImport($input: CreateListingImportInput!) {
  createListingImport(input: $input) {
    processingResult
    id
    processingStatus
  }
}
    `;
export type CreateListingImportMutationFn = Apollo.MutationFunction<CreateListingImportMutation, CreateListingImportMutationVariables>;

/**
 * __useCreateListingImportMutation__
 *
 * To run a mutation, you first call `useCreateListingImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingImportMutation, { data, loading, error }] = useCreateListingImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingImportMutation, CreateListingImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingImportMutation, CreateListingImportMutationVariables>(CreateListingImportDocument, options);
      }
export type CreateListingImportMutationHookResult = ReturnType<typeof useCreateListingImportMutation>;
export type CreateListingImportMutationResult = Apollo.MutationResult<CreateListingImportMutation>;
export type CreateListingImportMutationOptions = Apollo.BaseMutationOptions<CreateListingImportMutation, CreateListingImportMutationVariables>;
export const CreateConnectionInviteDocument = gql`
    mutation CreateConnectionInvite($input: CreateConnectionInviteInput!) {
  createConnectionInvite(input: $input) {
    ...ConnectionsInviteCore
  }
}
    ${ConnectionsInviteCoreFragmentDoc}`;
export type CreateConnectionInviteMutationFn = Apollo.MutationFunction<CreateConnectionInviteMutation, CreateConnectionInviteMutationVariables>;

/**
 * __useCreateConnectionInviteMutation__
 *
 * To run a mutation, you first call `useCreateConnectionInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionInviteMutation, { data, loading, error }] = useCreateConnectionInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConnectionInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionInviteMutation, CreateConnectionInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionInviteMutation, CreateConnectionInviteMutationVariables>(CreateConnectionInviteDocument, options);
      }
export type CreateConnectionInviteMutationHookResult = ReturnType<typeof useCreateConnectionInviteMutation>;
export type CreateConnectionInviteMutationResult = Apollo.MutationResult<CreateConnectionInviteMutation>;
export type CreateConnectionInviteMutationOptions = Apollo.BaseMutationOptions<CreateConnectionInviteMutation, CreateConnectionInviteMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($organization: OrganizationInput) {
  createOrganization(organization: $organization) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($deleteDocumentId: ID!) {
  deleteDocument(id: $deleteDocumentId)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      deleteDocumentId: // value for 'deleteDocumentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    ...DocumentCore
  }
}
    ${DocumentCoreFragmentDoc}`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const ListingDocumentsDocument = gql`
    query ListingDocuments($listingId: ID!, $sort: DocumentSortFieldInput) {
  listing(id: $listingId) {
    documents(sort: $sort) {
      ...DocumentCore
    }
  }
}
    ${DocumentCoreFragmentDoc}`;

/**
 * __useListingDocumentsQuery__
 *
 * To run a query within a React component, call `useListingDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDocumentsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListingDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListingDocumentsQuery, ListingDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingDocumentsQuery, ListingDocumentsQueryVariables>(ListingDocumentsDocument, options);
      }
export function useListingDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingDocumentsQuery, ListingDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingDocumentsQuery, ListingDocumentsQueryVariables>(ListingDocumentsDocument, options);
        }
export type ListingDocumentsQueryHookResult = ReturnType<typeof useListingDocumentsQuery>;
export type ListingDocumentsLazyQueryHookResult = ReturnType<typeof useListingDocumentsLazyQuery>;
export type ListingDocumentsQueryResult = Apollo.QueryResult<ListingDocumentsQuery, ListingDocumentsQueryVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    ...DocumentCore
  }
}
    ${DocumentCoreFragmentDoc}`;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const ListingExpensesDocument = gql`
    query ListingExpenses($listingId: ID!, $sort: ExpenseSortFieldInput) {
  listing(id: $listingId) {
    expenses(sort: $sort) {
      ...ExpenseCore
    }
  }
}
    ${ExpenseCoreFragmentDoc}`;

/**
 * __useListingExpensesQuery__
 *
 * To run a query within a React component, call `useListingExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingExpensesQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListingExpensesQuery(baseOptions: Apollo.QueryHookOptions<ListingExpensesQuery, ListingExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingExpensesQuery, ListingExpensesQueryVariables>(ListingExpensesDocument, options);
      }
export function useListingExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingExpensesQuery, ListingExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingExpensesQuery, ListingExpensesQueryVariables>(ListingExpensesDocument, options);
        }
export type ListingExpensesQueryHookResult = ReturnType<typeof useListingExpensesQuery>;
export type ListingExpensesLazyQueryHookResult = ReturnType<typeof useListingExpensesLazyQuery>;
export type ListingExpensesQueryResult = Apollo.QueryResult<ListingExpensesQuery, ListingExpensesQueryVariables>;
export const CreateExpenseDocument = gql`
    mutation CreateExpense($input: CreateExpenseInput!) {
  createExpense(input: $input) {
    ...ExpenseCore
  }
}
    ${ExpenseCoreFragmentDoc}`;
export type CreateExpenseMutationFn = Apollo.MutationFunction<CreateExpenseMutation, CreateExpenseMutationVariables>;

/**
 * __useCreateExpenseMutation__
 *
 * To run a mutation, you first call `useCreateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseMutation, { data, loading, error }] = useCreateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseMutation, CreateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, options);
      }
export type CreateExpenseMutationHookResult = ReturnType<typeof useCreateExpenseMutation>;
export type CreateExpenseMutationResult = Apollo.MutationResult<CreateExpenseMutation>;
export type CreateExpenseMutationOptions = Apollo.BaseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const CreateVendorDocument = gql`
    mutation CreateVendor($input: CreateVendorInput!) {
  createVendor(input: $input) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const VendorsDocument = gql`
    query Vendors($listingId: String!, $first: Int, $searchName: String) {
  vendors(listingId: $listingId, first: $first, searchName: $searchName) {
    nodes {
      id
      name
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useVendorsQuery__
 *
 * To run a query within a React component, call `useVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      first: // value for 'first'
 *      searchName: // value for 'searchName'
 *   },
 * });
 */
export function useVendorsQuery(baseOptions: Apollo.QueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
      }
export function useVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
        }
export type VendorsQueryHookResult = ReturnType<typeof useVendorsQuery>;
export type VendorsLazyQueryHookResult = ReturnType<typeof useVendorsLazyQuery>;
export type VendorsQueryResult = Apollo.QueryResult<VendorsQuery, VendorsQueryVariables>;
export const DeleteExpenseDocument = gql`
    mutation DeleteExpense($deleteExpenseId: ID!) {
  deleteExpense(id: $deleteExpenseId)
}
    `;
export type DeleteExpenseMutationFn = Apollo.MutationFunction<DeleteExpenseMutation, DeleteExpenseMutationVariables>;

/**
 * __useDeleteExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpenseMutation, { data, loading, error }] = useDeleteExpenseMutation({
 *   variables: {
 *      deleteExpenseId: // value for 'deleteExpenseId'
 *   },
 * });
 */
export function useDeleteExpenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument, options);
      }
export type DeleteExpenseMutationHookResult = ReturnType<typeof useDeleteExpenseMutation>;
export type DeleteExpenseMutationResult = Apollo.MutationResult<DeleteExpenseMutation>;
export type DeleteExpenseMutationOptions = Apollo.BaseMutationOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>;
export const UpdateExpenseDocument = gql`
    mutation UpdateExpense($input: UpdateExpenseInput!) {
  updateExpense(input: $input) {
    ...ExpenseCore
  }
}
    ${ExpenseCoreFragmentDoc}`;
export type UpdateExpenseMutationFn = Apollo.MutationFunction<UpdateExpenseMutation, UpdateExpenseMutationVariables>;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseMutation, { data, loading, error }] = useUpdateExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument, options);
      }
export type UpdateExpenseMutationHookResult = ReturnType<typeof useUpdateExpenseMutation>;
export type UpdateExpenseMutationResult = Apollo.MutationResult<UpdateExpenseMutation>;
export type UpdateExpenseMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const FilterCountModelsDocument = gql`
    query FilterCountModels($filters: [VehicleFilters!], $makeName: String) {
  filterCountModels(filters: $filters, makeName: $makeName) {
    count
    key
  }
}
    `;

/**
 * __useFilterCountModelsQuery__
 *
 * To run a query within a React component, call `useFilterCountModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCountModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCountModelsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      makeName: // value for 'makeName'
 *   },
 * });
 */
export function useFilterCountModelsQuery(baseOptions?: Apollo.QueryHookOptions<FilterCountModelsQuery, FilterCountModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCountModelsQuery, FilterCountModelsQueryVariables>(FilterCountModelsDocument, options);
      }
export function useFilterCountModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCountModelsQuery, FilterCountModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCountModelsQuery, FilterCountModelsQueryVariables>(FilterCountModelsDocument, options);
        }
export type FilterCountModelsQueryHookResult = ReturnType<typeof useFilterCountModelsQuery>;
export type FilterCountModelsLazyQueryHookResult = ReturnType<typeof useFilterCountModelsLazyQuery>;
export type FilterCountModelsQueryResult = Apollo.QueryResult<FilterCountModelsQuery, FilterCountModelsQueryVariables>;
export const FilterCountsDocument = gql`
    query FilterCounts($filters: [VehicleFilters!]) {
  make: filterCounts(propertyName: "vehicle.make", filters: $filters) {
    ...FilterCountCore
    __typename
  }
  trim: filterCounts(propertyName: "vehicle.trim", filters: $filters) {
    ...FilterCountCore
    __typename
  }
  drivetrain: filterCounts(propertyName: "vehicle.drivetrain", filters: $filters) {
    ...FilterCountCore
    __typename
  }
  engine: filterCounts(propertyName: "vehicle.engine", filters: $filters) {
    ...FilterCountCore
    __typename
  }
  transmission: filterCounts(
    propertyName: "vehicle.transmission"
    filters: $filters
  ) {
    ...FilterCountCore
    __typename
  }
  receivingOrganization: filterCounts(
    propertyName: "receivingOrganization"
    filters: $filters
  ) {
    ...FilterCountCore
    __typename
  }
}
    ${FilterCountCoreFragmentDoc}`;

/**
 * __useFilterCountsQuery__
 *
 * To run a query within a React component, call `useFilterCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterCountsQuery(baseOptions?: Apollo.QueryHookOptions<FilterCountsQuery, FilterCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCountsQuery, FilterCountsQueryVariables>(FilterCountsDocument, options);
      }
export function useFilterCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCountsQuery, FilterCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCountsQuery, FilterCountsQueryVariables>(FilterCountsDocument, options);
        }
export type FilterCountsQueryHookResult = ReturnType<typeof useFilterCountsQuery>;
export type FilterCountsLazyQueryHookResult = ReturnType<typeof useFilterCountsLazyQuery>;
export type FilterCountsQueryResult = Apollo.QueryResult<FilterCountsQuery, FilterCountsQueryVariables>;
export const FilterCountStatusesDocument = gql`
    query FilterCountStatuses($filters: [VehicleFilters!]) {
  filterCountStatuses(filters: $filters) {
    count
    key
    value
  }
}
    `;

/**
 * __useFilterCountStatusesQuery__
 *
 * To run a query within a React component, call `useFilterCountStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCountStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCountStatusesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterCountStatusesQuery(baseOptions?: Apollo.QueryHookOptions<FilterCountStatusesQuery, FilterCountStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCountStatusesQuery, FilterCountStatusesQueryVariables>(FilterCountStatusesDocument, options);
      }
export function useFilterCountStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCountStatusesQuery, FilterCountStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCountStatusesQuery, FilterCountStatusesQueryVariables>(FilterCountStatusesDocument, options);
        }
export type FilterCountStatusesQueryHookResult = ReturnType<typeof useFilterCountStatusesQuery>;
export type FilterCountStatusesLazyQueryHookResult = ReturnType<typeof useFilterCountStatusesLazyQuery>;
export type FilterCountStatusesQueryResult = Apollo.QueryResult<FilterCountStatusesQuery, FilterCountStatusesQueryVariables>;
export const FilterCountOrganizationsDocument = gql`
    query FilterCountOrganizations($filters: [VehicleFilters!]) {
  filterCountOrganizations(filters: $filters) {
    count
    key
    value
  }
}
    `;

/**
 * __useFilterCountOrganizationsQuery__
 *
 * To run a query within a React component, call `useFilterCountOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCountOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCountOrganizationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterCountOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<FilterCountOrganizationsQuery, FilterCountOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCountOrganizationsQuery, FilterCountOrganizationsQueryVariables>(FilterCountOrganizationsDocument, options);
      }
export function useFilterCountOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCountOrganizationsQuery, FilterCountOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCountOrganizationsQuery, FilterCountOrganizationsQueryVariables>(FilterCountOrganizationsDocument, options);
        }
export type FilterCountOrganizationsQueryHookResult = ReturnType<typeof useFilterCountOrganizationsQuery>;
export type FilterCountOrganizationsLazyQueryHookResult = ReturnType<typeof useFilterCountOrganizationsLazyQuery>;
export type FilterCountOrganizationsQueryResult = Apollo.QueryResult<FilterCountOrganizationsQuery, FilterCountOrganizationsQueryVariables>;
export const FilterCountTagsDocument = gql`
    query FilterCountTags($filters: [VehicleFilters!]) {
  filterCountTags(filters: $filters) {
    count
    key
    value
  }
}
    `;

/**
 * __useFilterCountTagsQuery__
 *
 * To run a query within a React component, call `useFilterCountTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCountTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCountTagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterCountTagsQuery(baseOptions?: Apollo.QueryHookOptions<FilterCountTagsQuery, FilterCountTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCountTagsQuery, FilterCountTagsQueryVariables>(FilterCountTagsDocument, options);
      }
export function useFilterCountTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCountTagsQuery, FilterCountTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCountTagsQuery, FilterCountTagsQueryVariables>(FilterCountTagsDocument, options);
        }
export type FilterCountTagsQueryHookResult = ReturnType<typeof useFilterCountTagsQuery>;
export type FilterCountTagsLazyQueryHookResult = ReturnType<typeof useFilterCountTagsLazyQuery>;
export type FilterCountTagsQueryResult = Apollo.QueryResult<FilterCountTagsQuery, FilterCountTagsQueryVariables>;
export const IntegrationsDocument = gql`
    query Integrations($input: IntegrationsInput) {
  integrations(input: $input) {
    nodes {
      attributes {
        id
        name
        type
      }
      configuration {
        enabled
        id
        organizationId
      }
      configurationUser {
        attributes {
          attribute {
            id
            name
            type
          }
          id
          value
        }
        id
        integrationId
        organizationId
        userId
      }
      id
      link
      name
      provider {
        id
        name
      }
      type {
        id
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const VehicleValuationDocument = gql`
    query VehicleValuation($input: VehicleValuationInput!) {
  vehicleValuation(input: $input) {
    valuations {
      retail {
        ...ValuationCategoryFields
      }
      tradeIn {
        ...ValuationCategoryFields
      }
      wholesale {
        ...ValuationCategoryFields
      }
    }
    addDeductOptions {
      id
      name
    }
  }
}
    ${ValuationCategoryFieldsFragmentDoc}`;

/**
 * __useVehicleValuationQuery__
 *
 * To run a query within a React component, call `useVehicleValuationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleValuationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleValuationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVehicleValuationQuery(baseOptions: Apollo.QueryHookOptions<VehicleValuationQuery, VehicleValuationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleValuationQuery, VehicleValuationQueryVariables>(VehicleValuationDocument, options);
      }
export function useVehicleValuationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleValuationQuery, VehicleValuationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleValuationQuery, VehicleValuationQueryVariables>(VehicleValuationDocument, options);
        }
export type VehicleValuationQueryHookResult = ReturnType<typeof useVehicleValuationQuery>;
export type VehicleValuationLazyQueryHookResult = ReturnType<typeof useVehicleValuationLazyQuery>;
export type VehicleValuationQueryResult = Apollo.QueryResult<VehicleValuationQuery, VehicleValuationQueryVariables>;
export const ConfigureIntegrationDocument = gql`
    mutation ConfigureIntegration($input: ConfigureIntegrationInput) {
  configureIntegration(input: $input)
}
    `;
export type ConfigureIntegrationMutationFn = Apollo.MutationFunction<ConfigureIntegrationMutation, ConfigureIntegrationMutationVariables>;

/**
 * __useConfigureIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureIntegrationMutation, { data, loading, error }] = useConfigureIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureIntegrationMutation, ConfigureIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureIntegrationMutation, ConfigureIntegrationMutationVariables>(ConfigureIntegrationDocument, options);
      }
export type ConfigureIntegrationMutationHookResult = ReturnType<typeof useConfigureIntegrationMutation>;
export type ConfigureIntegrationMutationResult = Apollo.MutationResult<ConfigureIntegrationMutation>;
export type ConfigureIntegrationMutationOptions = Apollo.BaseMutationOptions<ConfigureIntegrationMutation, ConfigureIntegrationMutationVariables>;
export const CreateAppraisalDocument = gql`
    mutation CreateAppraisal($input: CreateAppraisalInput!) {
  createAppraisal(input: $input) {
    ...AppraisalFields
  }
}
    ${AppraisalFieldsFragmentDoc}`;
export type CreateAppraisalMutationFn = Apollo.MutationFunction<CreateAppraisalMutation, CreateAppraisalMutationVariables>;

/**
 * __useCreateAppraisalMutation__
 *
 * To run a mutation, you first call `useCreateAppraisalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppraisalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppraisalMutation, { data, loading, error }] = useCreateAppraisalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppraisalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppraisalMutation, CreateAppraisalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppraisalMutation, CreateAppraisalMutationVariables>(CreateAppraisalDocument, options);
      }
export type CreateAppraisalMutationHookResult = ReturnType<typeof useCreateAppraisalMutation>;
export type CreateAppraisalMutationResult = Apollo.MutationResult<CreateAppraisalMutation>;
export type CreateAppraisalMutationOptions = Apollo.BaseMutationOptions<CreateAppraisalMutation, CreateAppraisalMutationVariables>;
export const UpdateAppraisalDocument = gql`
    mutation UpdateAppraisal($input: UpdateAppraisalInput!) {
  updateAppraisal(input: $input) {
    ...AppraisalFields
  }
}
    ${AppraisalFieldsFragmentDoc}`;
export type UpdateAppraisalMutationFn = Apollo.MutationFunction<UpdateAppraisalMutation, UpdateAppraisalMutationVariables>;

/**
 * __useUpdateAppraisalMutation__
 *
 * To run a mutation, you first call `useUpdateAppraisalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppraisalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppraisalMutation, { data, loading, error }] = useUpdateAppraisalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppraisalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppraisalMutation, UpdateAppraisalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppraisalMutation, UpdateAppraisalMutationVariables>(UpdateAppraisalDocument, options);
      }
export type UpdateAppraisalMutationHookResult = ReturnType<typeof useUpdateAppraisalMutation>;
export type UpdateAppraisalMutationResult = Apollo.MutationResult<UpdateAppraisalMutation>;
export type UpdateAppraisalMutationOptions = Apollo.BaseMutationOptions<UpdateAppraisalMutation, UpdateAppraisalMutationVariables>;
export const CreateListingInternalValuationDocument = gql`
    mutation CreateListingInternalValuation($input: CreateListingInternalValuationInput!, $isOffer: Boolean) {
  createListingInternalValuation(input: $input, isOffer: $isOffer) {
    ...InternalValuationFields
  }
}
    ${InternalValuationFieldsFragmentDoc}`;
export type CreateListingInternalValuationMutationFn = Apollo.MutationFunction<CreateListingInternalValuationMutation, CreateListingInternalValuationMutationVariables>;

/**
 * __useCreateListingInternalValuationMutation__
 *
 * To run a mutation, you first call `useCreateListingInternalValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingInternalValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingInternalValuationMutation, { data, loading, error }] = useCreateListingInternalValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isOffer: // value for 'isOffer'
 *   },
 * });
 */
export function useCreateListingInternalValuationMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingInternalValuationMutation, CreateListingInternalValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingInternalValuationMutation, CreateListingInternalValuationMutationVariables>(CreateListingInternalValuationDocument, options);
      }
export type CreateListingInternalValuationMutationHookResult = ReturnType<typeof useCreateListingInternalValuationMutation>;
export type CreateListingInternalValuationMutationResult = Apollo.MutationResult<CreateListingInternalValuationMutation>;
export type CreateListingInternalValuationMutationOptions = Apollo.BaseMutationOptions<CreateListingInternalValuationMutation, CreateListingInternalValuationMutationVariables>;
export const CreateListingOfferDocument = gql`
    mutation CreateListingOffer($input: CreateListingOfferInput!) {
  createListingOffer(input: $input) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type CreateListingOfferMutationFn = Apollo.MutationFunction<CreateListingOfferMutation, CreateListingOfferMutationVariables>;

/**
 * __useCreateListingOfferMutation__
 *
 * To run a mutation, you first call `useCreateListingOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingOfferMutation, { data, loading, error }] = useCreateListingOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingOfferMutation, CreateListingOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingOfferMutation, CreateListingOfferMutationVariables>(CreateListingOfferDocument, options);
      }
export type CreateListingOfferMutationHookResult = ReturnType<typeof useCreateListingOfferMutation>;
export type CreateListingOfferMutationResult = Apollo.MutationResult<CreateListingOfferMutation>;
export type CreateListingOfferMutationOptions = Apollo.BaseMutationOptions<CreateListingOfferMutation, CreateListingOfferMutationVariables>;
export const SendInviteDocument = gql`
    mutation SendInvite($inviteParams: InviteInput) {
  createInvite(inviteParams: $inviteParams) {
    ...InviteAttributes
  }
}
    ${InviteAttributesFragmentDoc}`;
export type SendInviteMutationFn = Apollo.MutationFunction<SendInviteMutation, SendInviteMutationVariables>;

/**
 * __useSendInviteMutation__
 *
 * To run a mutation, you first call `useSendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteMutation, { data, loading, error }] = useSendInviteMutation({
 *   variables: {
 *      inviteParams: // value for 'inviteParams'
 *   },
 * });
 */
export function useSendInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options);
      }
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>;
export type SendInviteMutationResult = Apollo.MutationResult<SendInviteMutation>;
export type SendInviteMutationOptions = Apollo.BaseMutationOptions<SendInviteMutation, SendInviteMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($resendInviteId: ID!) {
  resendInvite(id: $resendInviteId) {
    ...InviteAttributes
  }
}
    ${InviteAttributesFragmentDoc}`;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      resendInviteId: // value for 'resendInviteId'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($declineInviteId: ID!) {
  declineInvite(id: $declineInviteId) {
    status
    organizationId
  }
}
    `;
export type DeclineInviteMutationFn = Apollo.MutationFunction<DeclineInviteMutation, DeclineInviteMutationVariables>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      declineInviteId: // value for 'declineInviteId'
 *   },
 * });
 */
export function useDeclineInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
      }
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = Apollo.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.BaseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($acceptInviteId: ID!) {
  acceptInvite(id: $acceptInviteId) {
    organizationId
    status
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteId: // value for 'acceptInviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const ListingHistoryDocument = gql`
    query ListingHistory($listingId: String!, $last: Int, $first: Int, $after: String, $before: String) {
  listingHistory(
    listingId: $listingId
    last: $last
    first: $first
    after: $after
    before: $before
  ) {
    nodes {
      createdByUser {
        firstName
        lastName
        imageUrl
      }
      createdAt
      messageHtml
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useListingHistoryQuery__
 *
 * To run a query within a React component, call `useListingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingHistoryQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListingHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListingHistoryQuery, ListingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingHistoryQuery, ListingHistoryQueryVariables>(ListingHistoryDocument, options);
      }
export function useListingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingHistoryQuery, ListingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingHistoryQuery, ListingHistoryQueryVariables>(ListingHistoryDocument, options);
        }
export type ListingHistoryQueryHookResult = ReturnType<typeof useListingHistoryQuery>;
export type ListingHistoryLazyQueryHookResult = ReturnType<typeof useListingHistoryLazyQuery>;
export type ListingHistoryQueryResult = Apollo.QueryResult<ListingHistoryQuery, ListingHistoryQueryVariables>;
export const ListingsDocument = gql`
    query Listings($after: String, $filters: [VehicleFilters], $first: Int, $query: String, $sort: [String]) {
  listings(
    after: $after
    filters: $filters
    first: $first
    query: $query
    sort: $sort
  ) {
    nodes {
      ...ListingCore
      ...ListingLeadCore
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${ListingCoreFragmentDoc}
${ListingLeadCoreFragmentDoc}`;

/**
 * __useListingsQuery__
 *
 * To run a query within a React component, call `useListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListingsQuery(baseOptions?: Apollo.QueryHookOptions<ListingsQuery, ListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsQuery, ListingsQueryVariables>(ListingsDocument, options);
      }
export function useListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsQuery, ListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsQuery, ListingsQueryVariables>(ListingsDocument, options);
        }
export type ListingsQueryHookResult = ReturnType<typeof useListingsQuery>;
export type ListingsLazyQueryHookResult = ReturnType<typeof useListingsLazyQuery>;
export type ListingsQueryResult = Apollo.QueryResult<ListingsQuery, ListingsQueryVariables>;
export const ListingDocument = gql`
    query Listing($listingId: ID!) {
  listing(id: $listingId) {
    ...ListingCore
    ...ListingFull
    ...ListingLeadCore
  }
}
    ${ListingCoreFragmentDoc}
${ListingFullFragmentDoc}
${ListingLeadCoreFragmentDoc}`;

/**
 * __useListingQuery__
 *
 * To run a query within a React component, call `useListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingQuery(baseOptions: Apollo.QueryHookOptions<ListingQuery, ListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
      }
export function useListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingQuery, ListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
        }
export type ListingQueryHookResult = ReturnType<typeof useListingQuery>;
export type ListingLazyQueryHookResult = ReturnType<typeof useListingLazyQuery>;
export type ListingQueryResult = Apollo.QueryResult<ListingQuery, ListingQueryVariables>;
export const InceptionListingByVehicleIdDocument = gql`
    query InceptionListingByVehicleId($id: ID!) {
  inceptionListingByVehicleId(id: $id) {
    id
  }
}
    `;

/**
 * __useInceptionListingByVehicleIdQuery__
 *
 * To run a query within a React component, call `useInceptionListingByVehicleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInceptionListingByVehicleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInceptionListingByVehicleIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInceptionListingByVehicleIdQuery(baseOptions: Apollo.QueryHookOptions<InceptionListingByVehicleIdQuery, InceptionListingByVehicleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InceptionListingByVehicleIdQuery, InceptionListingByVehicleIdQueryVariables>(InceptionListingByVehicleIdDocument, options);
      }
export function useInceptionListingByVehicleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InceptionListingByVehicleIdQuery, InceptionListingByVehicleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InceptionListingByVehicleIdQuery, InceptionListingByVehicleIdQueryVariables>(InceptionListingByVehicleIdDocument, options);
        }
export type InceptionListingByVehicleIdQueryHookResult = ReturnType<typeof useInceptionListingByVehicleIdQuery>;
export type InceptionListingByVehicleIdLazyQueryHookResult = ReturnType<typeof useInceptionListingByVehicleIdLazyQuery>;
export type InceptionListingByVehicleIdQueryResult = Apollo.QueryResult<InceptionListingByVehicleIdQuery, InceptionListingByVehicleIdQueryVariables>;
export const InceptionListingsByVinDocument = gql`
    query InceptionListingsByVin($vin: String) {
  inceptionListingsByVin(vin: $vin) {
    id
    sharingOrganization {
      id
      name
      imageUrl
      statuses {
        ...OrganizationListingStatusCore
      }
    }
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}`;

/**
 * __useInceptionListingsByVinQuery__
 *
 * To run a query within a React component, call `useInceptionListingsByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useInceptionListingsByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInceptionListingsByVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useInceptionListingsByVinQuery(baseOptions?: Apollo.QueryHookOptions<InceptionListingsByVinQuery, InceptionListingsByVinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InceptionListingsByVinQuery, InceptionListingsByVinQueryVariables>(InceptionListingsByVinDocument, options);
      }
export function useInceptionListingsByVinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InceptionListingsByVinQuery, InceptionListingsByVinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InceptionListingsByVinQuery, InceptionListingsByVinQueryVariables>(InceptionListingsByVinDocument, options);
        }
export type InceptionListingsByVinQueryHookResult = ReturnType<typeof useInceptionListingsByVinQuery>;
export type InceptionListingsByVinLazyQueryHookResult = ReturnType<typeof useInceptionListingsByVinLazyQuery>;
export type InceptionListingsByVinQueryResult = Apollo.QueryResult<InceptionListingsByVinQuery, InceptionListingsByVinQueryVariables>;
export const CreateListingValuationDocument = gql`
    mutation CreateListingValuation($input: CreateListingValuationInput!) {
  createListingValuation(input: $input) {
    ...ValuationsCore
  }
}
    ${ValuationsCoreFragmentDoc}`;
export type CreateListingValuationMutationFn = Apollo.MutationFunction<CreateListingValuationMutation, CreateListingValuationMutationVariables>;

/**
 * __useCreateListingValuationMutation__
 *
 * To run a mutation, you first call `useCreateListingValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingValuationMutation, { data, loading, error }] = useCreateListingValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingValuationMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingValuationMutation, CreateListingValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingValuationMutation, CreateListingValuationMutationVariables>(CreateListingValuationDocument, options);
      }
export type CreateListingValuationMutationHookResult = ReturnType<typeof useCreateListingValuationMutation>;
export type CreateListingValuationMutationResult = Apollo.MutationResult<CreateListingValuationMutation>;
export type CreateListingValuationMutationOptions = Apollo.BaseMutationOptions<CreateListingValuationMutation, CreateListingValuationMutationVariables>;
export const UpdateListingValuationDocument = gql`
    mutation UpdateListingValuation($input: UpdateListingValuationInput!) {
  updateListingValuation(input: $input) {
    ...ValuationsCore
  }
}
    ${ValuationsCoreFragmentDoc}`;
export type UpdateListingValuationMutationFn = Apollo.MutationFunction<UpdateListingValuationMutation, UpdateListingValuationMutationVariables>;

/**
 * __useUpdateListingValuationMutation__
 *
 * To run a mutation, you first call `useUpdateListingValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingValuationMutation, { data, loading, error }] = useUpdateListingValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingValuationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingValuationMutation, UpdateListingValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingValuationMutation, UpdateListingValuationMutationVariables>(UpdateListingValuationDocument, options);
      }
export type UpdateListingValuationMutationHookResult = ReturnType<typeof useUpdateListingValuationMutation>;
export type UpdateListingValuationMutationResult = Apollo.MutationResult<UpdateListingValuationMutation>;
export type UpdateListingValuationMutationOptions = Apollo.BaseMutationOptions<UpdateListingValuationMutation, UpdateListingValuationMutationVariables>;
export const UpdateListingCurrentStatusDocument = gql`
    mutation UpdateListingCurrentStatus($input: UpdateListingCurrentStatusInput!) {
  updateListingCurrentStatus(input: $input)
}
    `;
export type UpdateListingCurrentStatusMutationFn = Apollo.MutationFunction<UpdateListingCurrentStatusMutation, UpdateListingCurrentStatusMutationVariables>;

/**
 * __useUpdateListingCurrentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateListingCurrentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingCurrentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingCurrentStatusMutation, { data, loading, error }] = useUpdateListingCurrentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingCurrentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingCurrentStatusMutation, UpdateListingCurrentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingCurrentStatusMutation, UpdateListingCurrentStatusMutationVariables>(UpdateListingCurrentStatusDocument, options);
      }
export type UpdateListingCurrentStatusMutationHookResult = ReturnType<typeof useUpdateListingCurrentStatusMutation>;
export type UpdateListingCurrentStatusMutationResult = Apollo.MutationResult<UpdateListingCurrentStatusMutation>;
export type UpdateListingCurrentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateListingCurrentStatusMutation, UpdateListingCurrentStatusMutationVariables>;
export const ShareListingDocument = gql`
    mutation ShareListing($input: ShareListingInput!) {
  shareListing(input: $input) {
    id
    sharingOrganization {
      id
      name
      imageUrl
      statuses {
        ...OrganizationListingStatusCore
      }
    }
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}`;
export type ShareListingMutationFn = Apollo.MutationFunction<ShareListingMutation, ShareListingMutationVariables>;

/**
 * __useShareListingMutation__
 *
 * To run a mutation, you first call `useShareListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareListingMutation, { data, loading, error }] = useShareListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareListingMutation(baseOptions?: Apollo.MutationHookOptions<ShareListingMutation, ShareListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareListingMutation, ShareListingMutationVariables>(ShareListingDocument, options);
      }
export type ShareListingMutationHookResult = ReturnType<typeof useShareListingMutation>;
export type ShareListingMutationResult = Apollo.MutationResult<ShareListingMutation>;
export type ShareListingMutationOptions = Apollo.BaseMutationOptions<ShareListingMutation, ShareListingMutationVariables>;
export const SaveListingDocument = gql`
    mutation SaveListing($listingId: String!) {
  saveListing(listingId: $listingId)
}
    `;
export type SaveListingMutationFn = Apollo.MutationFunction<SaveListingMutation, SaveListingMutationVariables>;

/**
 * __useSaveListingMutation__
 *
 * To run a mutation, you first call `useSaveListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveListingMutation, { data, loading, error }] = useSaveListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useSaveListingMutation(baseOptions?: Apollo.MutationHookOptions<SaveListingMutation, SaveListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveListingMutation, SaveListingMutationVariables>(SaveListingDocument, options);
      }
export type SaveListingMutationHookResult = ReturnType<typeof useSaveListingMutation>;
export type SaveListingMutationResult = Apollo.MutationResult<SaveListingMutation>;
export type SaveListingMutationOptions = Apollo.BaseMutationOptions<SaveListingMutation, SaveListingMutationVariables>;
export const UnsaveListingDocument = gql`
    mutation UnsaveListing($listingId: String!) {
  unsaveListing(listingId: $listingId)
}
    `;
export type UnsaveListingMutationFn = Apollo.MutationFunction<UnsaveListingMutation, UnsaveListingMutationVariables>;

/**
 * __useUnsaveListingMutation__
 *
 * To run a mutation, you first call `useUnsaveListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveListingMutation, { data, loading, error }] = useUnsaveListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useUnsaveListingMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveListingMutation, UnsaveListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveListingMutation, UnsaveListingMutationVariables>(UnsaveListingDocument, options);
      }
export type UnsaveListingMutationHookResult = ReturnType<typeof useUnsaveListingMutation>;
export type UnsaveListingMutationResult = Apollo.MutationResult<UnsaveListingMutation>;
export type UnsaveListingMutationOptions = Apollo.BaseMutationOptions<UnsaveListingMutation, UnsaveListingMutationVariables>;
export const MessagesDocument = gql`
    query Messages($after: String, $first: Int, $roomId: ID!) {
  messages(after: $after, first: $first, roomId: $roomId) {
    nodes {
      createdAt
      id
      receiverId
      receiverType
      room {
        id
        listingId
        type
      }
      sender {
        id
        firstName
        email
        lastName
        imageUrl
      }
      sentAt
      text
      senderOrganizationId
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($input: CreateRoomMessageInput) {
  createMessage(input: $input) {
    createdAt
    id
    receiverId
    receiverType
    room {
      id
      listingId
      type
    }
    sender {
      email
      firstName
      id
      lastName
      imageUrl
      organizations {
        id
        name
      }
    }
    sentAt
    text
    senderOrganizationId
  }
}
    `;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const RoomsDocument = gql`
    query Rooms($after: String, $first: Int) {
  rooms(after: $after, first: $first) {
    nodes {
      id
      imageUrl
      lastMessageText
      name
      unreadMessagesCount
      ownerOrganization {
        id
        name
      }
      type
      updatedAt
      users {
        id
        firstName
        lastName
        imageUrl
      }
      vehicle {
        id
        displayName
        pictures {
          url
        }
        currentVehicleStatus {
          name
        }
      }
    }
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useRoomsQuery__
 *
 * To run a query within a React component, call `useRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRoomsQuery(baseOptions?: Apollo.QueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
      }
export function useRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
        }
export type RoomsQueryHookResult = ReturnType<typeof useRoomsQuery>;
export type RoomsLazyQueryHookResult = ReturnType<typeof useRoomsLazyQuery>;
export type RoomsQueryResult = Apollo.QueryResult<RoomsQuery, RoomsQueryVariables>;
export const VehicleRoomsDocument = gql`
    query VehicleRooms($after: String, $first: Int) {
  vehicleRooms(after: $after, first: $first) {
    nodes {
      rooms {
        vehicle {
          id
          reconData {
            reconTrades {
              vendor {
                id
                name
                imageUrl
              }
            }
          }
        }
        updatedAt
        type
        name
        lastMessageText
        lastMessageAt
        imageUrl
        id
        unreadMessagesCount
        ownerOrganization {
          id
          userRoles {
            user {
              lastName
              firstName
              imageUrl
              id
            }
          }
        }
        invitedOrganization {
          id
          isVendor
        }
        users {
          imageUrl
          id
          firstName
          lastName
        }
      }
      vehicle {
        id
        make
        model
        displayName
        year
        currentVehicleStatus {
          name
        }
        pictures {
          url
        }
        organization {
          id
          name
          imageUrl
        }
        reconData {
          reconTrades {
            vendor {
              id
              name
              imageUrl
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useVehicleRoomsQuery__
 *
 * To run a query within a React component, call `useVehicleRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleRoomsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useVehicleRoomsQuery(baseOptions?: Apollo.QueryHookOptions<VehicleRoomsQuery, VehicleRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleRoomsQuery, VehicleRoomsQueryVariables>(VehicleRoomsDocument, options);
      }
export function useVehicleRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleRoomsQuery, VehicleRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleRoomsQuery, VehicleRoomsQueryVariables>(VehicleRoomsDocument, options);
        }
export type VehicleRoomsQueryHookResult = ReturnType<typeof useVehicleRoomsQuery>;
export type VehicleRoomsLazyQueryHookResult = ReturnType<typeof useVehicleRoomsLazyQuery>;
export type VehicleRoomsQueryResult = Apollo.QueryResult<VehicleRoomsQuery, VehicleRoomsQueryVariables>;
export const MarkRoomAsReadDocument = gql`
    mutation MarkRoomAsRead($input: MarkRoomAsReadInput) {
  markRoomAsRead(input: $input)
}
    `;
export type MarkRoomAsReadMutationFn = Apollo.MutationFunction<MarkRoomAsReadMutation, MarkRoomAsReadMutationVariables>;

/**
 * __useMarkRoomAsReadMutation__
 *
 * To run a mutation, you first call `useMarkRoomAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRoomAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRoomAsReadMutation, { data, loading, error }] = useMarkRoomAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkRoomAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkRoomAsReadMutation, MarkRoomAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRoomAsReadMutation, MarkRoomAsReadMutationVariables>(MarkRoomAsReadDocument, options);
      }
export type MarkRoomAsReadMutationHookResult = ReturnType<typeof useMarkRoomAsReadMutation>;
export type MarkRoomAsReadMutationResult = Apollo.MutationResult<MarkRoomAsReadMutation>;
export type MarkRoomAsReadMutationOptions = Apollo.BaseMutationOptions<MarkRoomAsReadMutation, MarkRoomAsReadMutationVariables>;
export const RoomsForVehicleDocument = gql`
    query RoomsForVehicle($vehicleId: ID!) {
  roomsForVehicle(vehicleId: $vehicleId) {
    rooms {
      createdAt
      id
      imageUrl
      lastMessageAt
      lastMessageText
      name
      unreadMessagesCount
      ownerOrganization {
        id
        name
        userRoles {
          user {
            imageUrl
            lastName
            firstName
            id
          }
        }
      }
      type
      updatedAt
      users {
        id
        firstName
        lastName
        imageUrl
      }
      vehicle {
        id
        displayName
        pictures {
          url
        }
        currentVehicleStatus {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useRoomsForVehicleQuery__
 *
 * To run a query within a React component, call `useRoomsForVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomsForVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomsForVehicleQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useRoomsForVehicleQuery(baseOptions: Apollo.QueryHookOptions<RoomsForVehicleQuery, RoomsForVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomsForVehicleQuery, RoomsForVehicleQueryVariables>(RoomsForVehicleDocument, options);
      }
export function useRoomsForVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomsForVehicleQuery, RoomsForVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomsForVehicleQuery, RoomsForVehicleQueryVariables>(RoomsForVehicleDocument, options);
        }
export type RoomsForVehicleQueryHookResult = ReturnType<typeof useRoomsForVehicleQuery>;
export type RoomsForVehicleLazyQueryHookResult = ReturnType<typeof useRoomsForVehicleLazyQuery>;
export type RoomsForVehicleQueryResult = Apollo.QueryResult<RoomsForVehicleQuery, RoomsForVehicleQueryVariables>;
export const MentionableUsersDocument = gql`
    query MentionableUsers($roomType: RoomType!, $listingId: String!) {
  mentionableUsers(roomType: $roomType, listingId: $listingId) {
    id
    firstName
    lastName
    email
    imageUrl
  }
}
    `;

/**
 * __useMentionableUsersQuery__
 *
 * To run a query within a React component, call `useMentionableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionableUsersQuery({
 *   variables: {
 *      roomType: // value for 'roomType'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useMentionableUsersQuery(baseOptions: Apollo.QueryHookOptions<MentionableUsersQuery, MentionableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MentionableUsersQuery, MentionableUsersQueryVariables>(MentionableUsersDocument, options);
      }
export function useMentionableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MentionableUsersQuery, MentionableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MentionableUsersQuery, MentionableUsersQueryVariables>(MentionableUsersDocument, options);
        }
export type MentionableUsersQueryHookResult = ReturnType<typeof useMentionableUsersQuery>;
export type MentionableUsersLazyQueryHookResult = ReturnType<typeof useMentionableUsersLazyQuery>;
export type MentionableUsersQueryResult = Apollo.QueryResult<MentionableUsersQuery, MentionableUsersQueryVariables>;
export const NotesDocument = gql`
    query Notes($listingId: String, $last: Int, $first: Int, $after: String, $before: String, $tag: NoteTag) {
  notes(
    listingId: $listingId
    last: $last
    first: $first
    after: $after
    before: $before
    tag: $tag
  ) {
    nodes {
      ...NoteCore
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${NoteCoreFragmentDoc}`;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useNotesQuery(baseOptions?: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    ...NoteCore
  }
}
    ${NoteCoreFragmentDoc}`;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    ...NoteCore
  }
}
    ${NoteCoreFragmentDoc}`;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const NotificationsDocument = gql`
    query notifications($after: String, $first: Int) {
  notifications(after: $after, first: $first) {
    nodes {
      read
      messageHtml
      imageUrl
      id
      createdAt
      action
      entityId
      clicked
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    unreadNotifications
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const ClickNotificationDocument = gql`
    mutation ClickNotification($clickNotificationId: ID!) {
  clickNotification(id: $clickNotificationId)
}
    `;
export type ClickNotificationMutationFn = Apollo.MutationFunction<ClickNotificationMutation, ClickNotificationMutationVariables>;

/**
 * __useClickNotificationMutation__
 *
 * To run a mutation, you first call `useClickNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickNotificationMutation, { data, loading, error }] = useClickNotificationMutation({
 *   variables: {
 *      clickNotificationId: // value for 'clickNotificationId'
 *   },
 * });
 */
export function useClickNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ClickNotificationMutation, ClickNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickNotificationMutation, ClickNotificationMutationVariables>(ClickNotificationDocument, options);
      }
export type ClickNotificationMutationHookResult = ReturnType<typeof useClickNotificationMutation>;
export type ClickNotificationMutationResult = Apollo.MutationResult<ClickNotificationMutation>;
export type ClickNotificationMutationOptions = Apollo.BaseMutationOptions<ClickNotificationMutation, ClickNotificationMutationVariables>;
export const ReadNotificationsDocument = gql`
    mutation ReadNotifications {
  readNotifications
}
    `;
export type ReadNotificationsMutationFn = Apollo.MutationFunction<ReadNotificationsMutation, ReadNotificationsMutationVariables>;

/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationsMutation, { data, loading, error }] = useReadNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationsMutation, ReadNotificationsMutationVariables>(ReadNotificationsDocument, options);
      }
export type ReadNotificationsMutationHookResult = ReturnType<typeof useReadNotificationsMutation>;
export type ReadNotificationsMutationResult = Apollo.MutationResult<ReadNotificationsMutation>;
export type ReadNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const OrganizationsDocument = gql`
    query Organizations($after: String, $before: String, $first: Int, $last: Int) {
  organizations(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      ...OrganizationCoreAttributes
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${OrganizationCoreAttributesFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
      }
export function useOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>;
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>;
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    ...OrganizationCoreAttributes
    userRoles {
      user {
        id
        lastName
        firstName
        email
      }
      owner
    }
    imageUrl
    createdAt
  }
}
    ${OrganizationCoreAttributesFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($updateOrganizationId: ID, $organization: OrganizationInput) {
  updateOrganization(id: $updateOrganizationId, organization: $organization) {
    id
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      updateOrganizationId: // value for 'updateOrganizationId'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const OrganizationUserRolesDocument = gql`
    query OrganizationUserRoles($organizationId: ID!) {
  organization(id: $organizationId) {
    userRoles {
      user {
        id
        lastName
        firstName
        email
        imageUrl
      }
      owner
    }
  }
}
    `;

/**
 * __useOrganizationUserRolesQuery__
 *
 * To run a query within a React component, call `useOrganizationUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUserRolesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationUserRolesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationUserRolesQuery, OrganizationUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationUserRolesQuery, OrganizationUserRolesQueryVariables>(OrganizationUserRolesDocument, options);
      }
export function useOrganizationUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUserRolesQuery, OrganizationUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationUserRolesQuery, OrganizationUserRolesQueryVariables>(OrganizationUserRolesDocument, options);
        }
export type OrganizationUserRolesQueryHookResult = ReturnType<typeof useOrganizationUserRolesQuery>;
export type OrganizationUserRolesLazyQueryHookResult = ReturnType<typeof useOrganizationUserRolesLazyQuery>;
export type OrganizationUserRolesQueryResult = Apollo.QueryResult<OrganizationUserRolesQuery, OrganizationUserRolesQueryVariables>;
export const OrganizationBasicInfoDocument = gql`
    query OrganizationBasicInfo($organizationId: ID!) {
  organization(id: $organizationId) {
    ...OrganizationCoreAttributes
  }
}
    ${OrganizationCoreAttributesFragmentDoc}`;

/**
 * __useOrganizationBasicInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBasicInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<OrganizationBasicInfoQuery, OrganizationBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBasicInfoQuery, OrganizationBasicInfoQueryVariables>(OrganizationBasicInfoDocument, options);
      }
export function useOrganizationBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBasicInfoQuery, OrganizationBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBasicInfoQuery, OrganizationBasicInfoQueryVariables>(OrganizationBasicInfoDocument, options);
        }
export type OrganizationBasicInfoQueryHookResult = ReturnType<typeof useOrganizationBasicInfoQuery>;
export type OrganizationBasicInfoLazyQueryHookResult = ReturnType<typeof useOrganizationBasicInfoLazyQuery>;
export type OrganizationBasicInfoQueryResult = Apollo.QueryResult<OrganizationBasicInfoQuery, OrganizationBasicInfoQueryVariables>;
export const EditSystemOrganizationDocument = gql`
    mutation EditSystemOrganization($input: UpdateSystemOrganizationInput) {
  systemUpdateOrganization(input: $input) {
    id
  }
}
    `;
export type EditSystemOrganizationMutationFn = Apollo.MutationFunction<EditSystemOrganizationMutation, EditSystemOrganizationMutationVariables>;

/**
 * __useEditSystemOrganizationMutation__
 *
 * To run a mutation, you first call `useEditSystemOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSystemOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSystemOrganizationMutation, { data, loading, error }] = useEditSystemOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSystemOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditSystemOrganizationMutation, EditSystemOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSystemOrganizationMutation, EditSystemOrganizationMutationVariables>(EditSystemOrganizationDocument, options);
      }
export type EditSystemOrganizationMutationHookResult = ReturnType<typeof useEditSystemOrganizationMutation>;
export type EditSystemOrganizationMutationResult = Apollo.MutationResult<EditSystemOrganizationMutation>;
export type EditSystemOrganizationMutationOptions = Apollo.BaseMutationOptions<EditSystemOrganizationMutation, EditSystemOrganizationMutationVariables>;
export const CreateOrganizationStatusDocument = gql`
    mutation CreateOrganizationStatus($input: CreateOrganizationStatusInput!) {
  createOrganizationStatus(input: $input) {
    ...OrganizationListingStatusCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}
${UserWithScopesCoreFragmentDoc}`;
export type CreateOrganizationStatusMutationFn = Apollo.MutationFunction<CreateOrganizationStatusMutation, CreateOrganizationStatusMutationVariables>;

/**
 * __useCreateOrganizationStatusMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationStatusMutation, { data, loading, error }] = useCreateOrganizationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationStatusMutation, CreateOrganizationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationStatusMutation, CreateOrganizationStatusMutationVariables>(CreateOrganizationStatusDocument, options);
      }
export type CreateOrganizationStatusMutationHookResult = ReturnType<typeof useCreateOrganizationStatusMutation>;
export type CreateOrganizationStatusMutationResult = Apollo.MutationResult<CreateOrganizationStatusMutation>;
export type CreateOrganizationStatusMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationStatusMutation, CreateOrganizationStatusMutationVariables>;
export const UpdateOrganizationStatusDocument = gql`
    mutation UpdateOrganizationStatus($input: UpdateOrganizationStatusInput!) {
  updateOrganizationStatus(input: $input) {
    ...OrganizationListingStatusCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}
${UserWithScopesCoreFragmentDoc}`;
export type UpdateOrganizationStatusMutationFn = Apollo.MutationFunction<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>;

/**
 * __useUpdateOrganizationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationStatusMutation, { data, loading, error }] = useUpdateOrganizationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>(UpdateOrganizationStatusDocument, options);
      }
export type UpdateOrganizationStatusMutationHookResult = ReturnType<typeof useUpdateOrganizationStatusMutation>;
export type UpdateOrganizationStatusMutationResult = Apollo.MutationResult<UpdateOrganizationStatusMutation>;
export type UpdateOrganizationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationStatusMutation, UpdateOrganizationStatusMutationVariables>;
export const CreateOrganizationTagDocument = gql`
    mutation CreateOrganizationTag($input: CreateOrganizationTagInput!) {
  createOrganizationTag(input: $input) {
    ...TagCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
}
    ${TagCoreFragmentDoc}
${UserWithScopesCoreFragmentDoc}`;
export type CreateOrganizationTagMutationFn = Apollo.MutationFunction<CreateOrganizationTagMutation, CreateOrganizationTagMutationVariables>;

/**
 * __useCreateOrganizationTagMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationTagMutation, { data, loading, error }] = useCreateOrganizationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationTagMutation, CreateOrganizationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationTagMutation, CreateOrganizationTagMutationVariables>(CreateOrganizationTagDocument, options);
      }
export type CreateOrganizationTagMutationHookResult = ReturnType<typeof useCreateOrganizationTagMutation>;
export type CreateOrganizationTagMutationResult = Apollo.MutationResult<CreateOrganizationTagMutation>;
export type CreateOrganizationTagMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationTagMutation, CreateOrganizationTagMutationVariables>;
export const UpdateOrganizationTagDocument = gql`
    mutation UpdateOrganizationTag($input: UpdateOrganizationTagInput!) {
  updateOrganizationTag(input: $input) {
    ...TagCore
    updatedByUser {
      ...UserWithScopesCore
    }
  }
}
    ${TagCoreFragmentDoc}
${UserWithScopesCoreFragmentDoc}`;
export type UpdateOrganizationTagMutationFn = Apollo.MutationFunction<UpdateOrganizationTagMutation, UpdateOrganizationTagMutationVariables>;

/**
 * __useUpdateOrganizationTagMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationTagMutation, { data, loading, error }] = useUpdateOrganizationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationTagMutation, UpdateOrganizationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationTagMutation, UpdateOrganizationTagMutationVariables>(UpdateOrganizationTagDocument, options);
      }
export type UpdateOrganizationTagMutationHookResult = ReturnType<typeof useUpdateOrganizationTagMutation>;
export type UpdateOrganizationTagMutationResult = Apollo.MutationResult<UpdateOrganizationTagMutation>;
export type UpdateOrganizationTagMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationTagMutation, UpdateOrganizationTagMutationVariables>;
export const InvitesOrganizationDocument = gql`
    query InvitesOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    name
    id
    pendingInvites {
      id
      email
      owner
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useInvitesOrganizationQuery__
 *
 * To run a query within a React component, call `useInvitesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvitesOrganizationQuery(baseOptions: Apollo.QueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
      }
export function useInvitesOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
        }
export type InvitesOrganizationQueryHookResult = ReturnType<typeof useInvitesOrganizationQuery>;
export type InvitesOrganizationLazyQueryHookResult = ReturnType<typeof useInvitesOrganizationLazyQuery>;
export type InvitesOrganizationQueryResult = Apollo.QueryResult<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>;
export const DeleteSentInviteDocument = gql`
    mutation DeleteSentInvite($deleteInviteId: ID!) {
  deleteInvite(id: $deleteInviteId) {
    status
  }
}
    `;
export type DeleteSentInviteMutationFn = Apollo.MutationFunction<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;

/**
 * __useDeleteSentInviteMutation__
 *
 * To run a mutation, you first call `useDeleteSentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSentInviteMutation, { data, loading, error }] = useDeleteSentInviteMutation({
 *   variables: {
 *      deleteInviteId: // value for 'deleteInviteId'
 *   },
 * });
 */
export function useDeleteSentInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>(DeleteSentInviteDocument, options);
      }
export type DeleteSentInviteMutationHookResult = ReturnType<typeof useDeleteSentInviteMutation>;
export type DeleteSentInviteMutationResult = Apollo.MutationResult<DeleteSentInviteMutation>;
export type DeleteSentInviteMutationOptions = Apollo.BaseMutationOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;
export const OrganizationListingStatusesDocument = gql`
    query organizationListingStatuses($organizationId: ID!) {
  organizationListingStatuses(organizationId: $organizationId) {
    id
    name
    isDefault
    listingCounts
    updatedAt
  }
}
    `;

/**
 * __useOrganizationListingStatusesQuery__
 *
 * To run a query within a React component, call `useOrganizationListingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationListingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationListingStatusesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationListingStatusesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationListingStatusesQuery, OrganizationListingStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationListingStatusesQuery, OrganizationListingStatusesQueryVariables>(OrganizationListingStatusesDocument, options);
      }
export function useOrganizationListingStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationListingStatusesQuery, OrganizationListingStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationListingStatusesQuery, OrganizationListingStatusesQueryVariables>(OrganizationListingStatusesDocument, options);
        }
export type OrganizationListingStatusesQueryHookResult = ReturnType<typeof useOrganizationListingStatusesQuery>;
export type OrganizationListingStatusesLazyQueryHookResult = ReturnType<typeof useOrganizationListingStatusesLazyQuery>;
export type OrganizationListingStatusesQueryResult = Apollo.QueryResult<OrganizationListingStatusesQuery, OrganizationListingStatusesQueryVariables>;
export const MembersOrganizationDocument = gql`
    query MembersOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    userRoles {
      ...UserRoleAttributes
    }
  }
}
    ${UserRoleAttributesFragmentDoc}`;

/**
 * __useMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembersOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
      }
export function useMembersOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
export type MembersOrganizationQueryHookResult = ReturnType<typeof useMembersOrganizationQuery>;
export type MembersOrganizationLazyQueryHookResult = ReturnType<typeof useMembersOrganizationLazyQuery>;
export type MembersOrganizationQueryResult = Apollo.QueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: ID!) {
  removeMember(id: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($userId: ID!, $role: MemberRole!, $updateMemberRoleId: ID!) {
  updateMemberRole(userId: $userId, role: $role, id: $updateMemberRoleId) {
    ...UserRoleAttributes
  }
}
    ${UserRoleAttributesFragmentDoc}`;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      updateMemberRoleId: // value for 'updateMemberRoleId'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const OrganizationNameImageDocument = gql`
    query OrganizationNameImage($organizationId: ID!) {
  organization(id: $organizationId) {
    name
    imageUrl
  }
}
    `;

/**
 * __useOrganizationNameImageQuery__
 *
 * To run a query within a React component, call `useOrganizationNameImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameImageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationNameImageQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
      }
export function useOrganizationNameImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
        }
export type OrganizationNameImageQueryHookResult = ReturnType<typeof useOrganizationNameImageQuery>;
export type OrganizationNameImageLazyQueryHookResult = ReturnType<typeof useOrganizationNameImageLazyQuery>;
export type OrganizationNameImageQueryResult = Apollo.QueryResult<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>;
export const PurchaseSourcesDocument = gql`
    query PurchaseSources($listingId: String!, $first: Int, $after: String, $searchName: String) {
  purchaseSources(
    listingId: $listingId
    first: $first
    after: $after
    searchName: $searchName
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __usePurchaseSourcesQuery__
 *
 * To run a query within a React component, call `usePurchaseSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseSourcesQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchName: // value for 'searchName'
 *   },
 * });
 */
export function usePurchaseSourcesQuery(baseOptions: Apollo.QueryHookOptions<PurchaseSourcesQuery, PurchaseSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseSourcesQuery, PurchaseSourcesQueryVariables>(PurchaseSourcesDocument, options);
      }
export function usePurchaseSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseSourcesQuery, PurchaseSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseSourcesQuery, PurchaseSourcesQueryVariables>(PurchaseSourcesDocument, options);
        }
export type PurchaseSourcesQueryHookResult = ReturnType<typeof usePurchaseSourcesQuery>;
export type PurchaseSourcesLazyQueryHookResult = ReturnType<typeof usePurchaseSourcesLazyQuery>;
export type PurchaseSourcesQueryResult = Apollo.QueryResult<PurchaseSourcesQuery, PurchaseSourcesQueryVariables>;
export const UpsertPurchaseInformationDocument = gql`
    mutation UpsertPurchaseInformation($input: UpsertPurchaseInformationInput!) {
  upsertPurchaseInformation(input: $input) {
    ...PurchaseInformationCore
  }
}
    ${PurchaseInformationCoreFragmentDoc}`;
export type UpsertPurchaseInformationMutationFn = Apollo.MutationFunction<UpsertPurchaseInformationMutation, UpsertPurchaseInformationMutationVariables>;

/**
 * __useUpsertPurchaseInformationMutation__
 *
 * To run a mutation, you first call `useUpsertPurchaseInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPurchaseInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPurchaseInformationMutation, { data, loading, error }] = useUpsertPurchaseInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPurchaseInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPurchaseInformationMutation, UpsertPurchaseInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPurchaseInformationMutation, UpsertPurchaseInformationMutationVariables>(UpsertPurchaseInformationDocument, options);
      }
export type UpsertPurchaseInformationMutationHookResult = ReturnType<typeof useUpsertPurchaseInformationMutation>;
export type UpsertPurchaseInformationMutationResult = Apollo.MutationResult<UpsertPurchaseInformationMutation>;
export type UpsertPurchaseInformationMutationOptions = Apollo.BaseMutationOptions<UpsertPurchaseInformationMutation, UpsertPurchaseInformationMutationVariables>;
export const CreatePurchaseSourceDocument = gql`
    mutation CreatePurchaseSource($input: CreatePurchaseSourceInput!) {
  createPurchaseSource(input: $input) {
    id
  }
}
    `;
export type CreatePurchaseSourceMutationFn = Apollo.MutationFunction<CreatePurchaseSourceMutation, CreatePurchaseSourceMutationVariables>;

/**
 * __useCreatePurchaseSourceMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseSourceMutation, { data, loading, error }] = useCreatePurchaseSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePurchaseSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseSourceMutation, CreatePurchaseSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseSourceMutation, CreatePurchaseSourceMutationVariables>(CreatePurchaseSourceDocument, options);
      }
export type CreatePurchaseSourceMutationHookResult = ReturnType<typeof useCreatePurchaseSourceMutation>;
export type CreatePurchaseSourceMutationResult = Apollo.MutationResult<CreatePurchaseSourceMutation>;
export type CreatePurchaseSourceMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseSourceMutation, CreatePurchaseSourceMutationVariables>;
export const BuyersDocument = gql`
    query Buyers($listingId: String!, $first: Int, $after: String, $searchName: String) {
  buyers(
    listingId: $listingId
    first: $first
    searchName: $searchName
    after: $after
  ) {
    nodes {
      id
      name
      address
      phone
    }
  }
}
    `;

/**
 * __useBuyersQuery__
 *
 * To run a query within a React component, call `useBuyersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchName: // value for 'searchName'
 *   },
 * });
 */
export function useBuyersQuery(baseOptions: Apollo.QueryHookOptions<BuyersQuery, BuyersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyersQuery, BuyersQueryVariables>(BuyersDocument, options);
      }
export function useBuyersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyersQuery, BuyersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyersQuery, BuyersQueryVariables>(BuyersDocument, options);
        }
export type BuyersQueryHookResult = ReturnType<typeof useBuyersQuery>;
export type BuyersLazyQueryHookResult = ReturnType<typeof useBuyersLazyQuery>;
export type BuyersQueryResult = Apollo.QueryResult<BuyersQuery, BuyersQueryVariables>;
export const CreateBuyerDocument = gql`
    mutation CreateBuyer($input: CreateBuyerInput!) {
  createBuyer(input: $input) {
    id
  }
}
    `;
export type CreateBuyerMutationFn = Apollo.MutationFunction<CreateBuyerMutation, CreateBuyerMutationVariables>;

/**
 * __useCreateBuyerMutation__
 *
 * To run a mutation, you first call `useCreateBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerMutation, { data, loading, error }] = useCreateBuyerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuyerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuyerMutation, CreateBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuyerMutation, CreateBuyerMutationVariables>(CreateBuyerDocument, options);
      }
export type CreateBuyerMutationHookResult = ReturnType<typeof useCreateBuyerMutation>;
export type CreateBuyerMutationResult = Apollo.MutationResult<CreateBuyerMutation>;
export type CreateBuyerMutationOptions = Apollo.BaseMutationOptions<CreateBuyerMutation, CreateBuyerMutationVariables>;
export const UpsertSaleInformationDocument = gql`
    mutation UpsertSaleInformation($input: UpsertSaleInformationInput!) {
  upsertSaleInformation(input: $input) {
    ...SaleInformationCore
  }
}
    ${SaleInformationCoreFragmentDoc}`;
export type UpsertSaleInformationMutationFn = Apollo.MutationFunction<UpsertSaleInformationMutation, UpsertSaleInformationMutationVariables>;

/**
 * __useUpsertSaleInformationMutation__
 *
 * To run a mutation, you first call `useUpsertSaleInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSaleInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSaleInformationMutation, { data, loading, error }] = useUpsertSaleInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSaleInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSaleInformationMutation, UpsertSaleInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSaleInformationMutation, UpsertSaleInformationMutationVariables>(UpsertSaleInformationDocument, options);
      }
export type UpsertSaleInformationMutationHookResult = ReturnType<typeof useUpsertSaleInformationMutation>;
export type UpsertSaleInformationMutationResult = Apollo.MutationResult<UpsertSaleInformationMutation>;
export type UpsertSaleInformationMutationOptions = Apollo.BaseMutationOptions<UpsertSaleInformationMutation, UpsertSaleInformationMutationVariables>;
export const TagsDocument = gql`
    query Tags($organizationId: ID!) {
  tags(organizationId: $organizationId) {
    id
    name
    listingCounts
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const UpdateListingTagsDocument = gql`
    mutation UpdateListingTags($input: UpdateListingTagsInput) {
  updateListingTags(input: $input) {
    id
    tags {
      id
      name
    }
  }
}
    `;
export type UpdateListingTagsMutationFn = Apollo.MutationFunction<UpdateListingTagsMutation, UpdateListingTagsMutationVariables>;

/**
 * __useUpdateListingTagsMutation__
 *
 * To run a mutation, you first call `useUpdateListingTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingTagsMutation, { data, loading, error }] = useUpdateListingTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingTagsMutation, UpdateListingTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingTagsMutation, UpdateListingTagsMutationVariables>(UpdateListingTagsDocument, options);
      }
export type UpdateListingTagsMutationHookResult = ReturnType<typeof useUpdateListingTagsMutation>;
export type UpdateListingTagsMutationResult = Apollo.MutationResult<UpdateListingTagsMutation>;
export type UpdateListingTagsMutationOptions = Apollo.BaseMutationOptions<UpdateListingTagsMutation, UpdateListingTagsMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    disableOrgs
    organizations {
      id
      name
      addressLine1
      state
      city
      imageUrl
      phone
      owned
      isVendor
      statuses {
        ...OrganizationListingStatusCore
      }
    }
    invites {
      id
      organization {
        id
        name
        imageUrl
        statuses {
          ...OrganizationListingStatusCore
        }
      }
      inviter {
        id
        email
      }
    }
    scopes
  }
}
    ${OrganizationListingStatusCoreFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($user: UpdateUserInput) {
  updateMe(user: $user) {
    firstName
    lastName
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const AddDeviceTokenDocument = gql`
    mutation AddDeviceToken($input: AddDeviceTokenInput) {
  addDeviceToken(input: $input) {
    token
  }
}
    `;
export type AddDeviceTokenMutationFn = Apollo.MutationFunction<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>;

/**
 * __useAddDeviceTokenMutation__
 *
 * To run a mutation, you first call `useAddDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceTokenMutation, { data, loading, error }] = useAddDeviceTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>(AddDeviceTokenDocument, options);
      }
export type AddDeviceTokenMutationHookResult = ReturnType<typeof useAddDeviceTokenMutation>;
export type AddDeviceTokenMutationResult = Apollo.MutationResult<AddDeviceTokenMutation>;
export type AddDeviceTokenMutationOptions = Apollo.BaseMutationOptions<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>;
export const VehiclesDocument = gql`
    query Vehicles($after: String, $filters: [VehicleFilters], $first: Int, $query: String, $sort: [String]) {
  vehicles(
    after: $after
    filters: $filters
    first: $first
    query: $query
    sort: $sort
  ) {
    nodes {
      ...VehicleCore
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${VehicleCoreFragmentDoc}`;

/**
 * __useVehiclesQuery__
 *
 * To run a query within a React component, call `useVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<VehiclesQuery, VehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, options);
      }
export function useVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehiclesQuery, VehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, options);
        }
export type VehiclesQueryHookResult = ReturnType<typeof useVehiclesQuery>;
export type VehiclesLazyQueryHookResult = ReturnType<typeof useVehiclesLazyQuery>;
export type VehiclesQueryResult = Apollo.QueryResult<VehiclesQuery, VehiclesQueryVariables>;
export const VehicleDocument = gql`
    query Vehicle($vehicleId: ID!) {
  vehicle(id: $vehicleId) {
    ...VehicleCore
  }
}
    ${VehicleCoreFragmentDoc}`;

/**
 * __useVehicleQuery__
 *
 * To run a query within a React component, call `useVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useVehicleQuery(baseOptions: Apollo.QueryHookOptions<VehicleQuery, VehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, options);
      }
export function useVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleQuery, VehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, options);
        }
export type VehicleQueryHookResult = ReturnType<typeof useVehicleQuery>;
export type VehicleLazyQueryHookResult = ReturnType<typeof useVehicleLazyQuery>;
export type VehicleQueryResult = Apollo.QueryResult<VehicleQuery, VehicleQueryVariables>;
export const UpdateVehicleCurrentStatusDocument = gql`
    mutation UpdateVehicleCurrentStatus($input: UpdateVehicleCurrentStatusInput!) {
  updateVehicleCurrentStatus(input: $input)
}
    `;
export type UpdateVehicleCurrentStatusMutationFn = Apollo.MutationFunction<UpdateVehicleCurrentStatusMutation, UpdateVehicleCurrentStatusMutationVariables>;

/**
 * __useUpdateVehicleCurrentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleCurrentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleCurrentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleCurrentStatusMutation, { data, loading, error }] = useUpdateVehicleCurrentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleCurrentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleCurrentStatusMutation, UpdateVehicleCurrentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleCurrentStatusMutation, UpdateVehicleCurrentStatusMutationVariables>(UpdateVehicleCurrentStatusDocument, options);
      }
export type UpdateVehicleCurrentStatusMutationHookResult = ReturnType<typeof useUpdateVehicleCurrentStatusMutation>;
export type UpdateVehicleCurrentStatusMutationResult = Apollo.MutationResult<UpdateVehicleCurrentStatusMutation>;
export type UpdateVehicleCurrentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleCurrentStatusMutation, UpdateVehicleCurrentStatusMutationVariables>;
export const VendorVehiclesDocument = gql`
    query VendorVehicles($after: String, $filters: [VehicleFilters], $first: Int, $query: String, $sort: [String]) {
  vendorVehicles(
    after: $after
    filters: $filters
    first: $first
    query: $query
    sort: $sort
  ) {
    nodes {
      id
      reconData {
        needsParts
        estimatedReconPrice
        reconTrades {
          estimatedDays
          started
          startedAt
          trade
          tradeCount
          ownerCompleted
          ownerCompletedAt
          vendor {
            id
            imageUrl
            isVendor
            name
          }
          vendorCompleted
          vendorCompletedAt
        }
      }
      make
      model
      year
      vin
      pictures {
        description
        url
      }
      displayName
      odometer
      odometerUnit
      vin
      trim
      exteriorColor
      interiorColor
      organization {
        id
        name
        imageUrl
      }
      submitter {
        firstName
        lastName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useVendorVehiclesQuery__
 *
 * To run a query within a React component, call `useVendorVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorVehiclesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useVendorVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<VendorVehiclesQuery, VendorVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorVehiclesQuery, VendorVehiclesQueryVariables>(VendorVehiclesDocument, options);
      }
export function useVendorVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorVehiclesQuery, VendorVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorVehiclesQuery, VendorVehiclesQueryVariables>(VendorVehiclesDocument, options);
        }
export type VendorVehiclesQueryHookResult = ReturnType<typeof useVendorVehiclesQuery>;
export type VendorVehiclesLazyQueryHookResult = ReturnType<typeof useVendorVehiclesLazyQuery>;
export type VendorVehiclesQueryResult = Apollo.QueryResult<VendorVehiclesQuery, VendorVehiclesQueryVariables>;
export const VehicleIdByVinDocument = gql`
    query VehicleIdByVin($vin: String!) {
  vehicleIdByVin(vin: $vin)
}
    `;

/**
 * __useVehicleIdByVinQuery__
 *
 * To run a query within a React component, call `useVehicleIdByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleIdByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleIdByVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useVehicleIdByVinQuery(baseOptions: Apollo.QueryHookOptions<VehicleIdByVinQuery, VehicleIdByVinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleIdByVinQuery, VehicleIdByVinQueryVariables>(VehicleIdByVinDocument, options);
      }
export function useVehicleIdByVinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleIdByVinQuery, VehicleIdByVinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleIdByVinQuery, VehicleIdByVinQueryVariables>(VehicleIdByVinDocument, options);
        }
export type VehicleIdByVinQueryHookResult = ReturnType<typeof useVehicleIdByVinQuery>;
export type VehicleIdByVinLazyQueryHookResult = ReturnType<typeof useVehicleIdByVinLazyQuery>;
export type VehicleIdByVinQueryResult = Apollo.QueryResult<VehicleIdByVinQuery, VehicleIdByVinQueryVariables>;
export const ShareVehicleDocument = gql`
    mutation ShareVehicle($input: ShareVehicleInput!) {
  shareVehicle(input: $input) {
    id
  }
}
    `;
export type ShareVehicleMutationFn = Apollo.MutationFunction<ShareVehicleMutation, ShareVehicleMutationVariables>;

/**
 * __useShareVehicleMutation__
 *
 * To run a mutation, you first call `useShareVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareVehicleMutation, { data, loading, error }] = useShareVehicleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareVehicleMutation(baseOptions?: Apollo.MutationHookOptions<ShareVehicleMutation, ShareVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareVehicleMutation, ShareVehicleMutationVariables>(ShareVehicleDocument, options);
      }
export type ShareVehicleMutationHookResult = ReturnType<typeof useShareVehicleMutation>;
export type ShareVehicleMutationResult = Apollo.MutationResult<ShareVehicleMutation>;
export type ShareVehicleMutationOptions = Apollo.BaseMutationOptions<ShareVehicleMutation, ShareVehicleMutationVariables>;
export const DrilldownMakeInformationDocument = gql`
    query DrilldownMakeInformation($input: VehicleDrilldownInput!) {
  vehiclesDrilldownInformation(input: $input) {
    makeValue
  }
}
    `;

/**
 * __useDrilldownMakeInformationQuery__
 *
 * To run a query within a React component, call `useDrilldownMakeInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrilldownMakeInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrilldownMakeInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDrilldownMakeInformationQuery(baseOptions: Apollo.QueryHookOptions<DrilldownMakeInformationQuery, DrilldownMakeInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrilldownMakeInformationQuery, DrilldownMakeInformationQueryVariables>(DrilldownMakeInformationDocument, options);
      }
export function useDrilldownMakeInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrilldownMakeInformationQuery, DrilldownMakeInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrilldownMakeInformationQuery, DrilldownMakeInformationQueryVariables>(DrilldownMakeInformationDocument, options);
        }
export type DrilldownMakeInformationQueryHookResult = ReturnType<typeof useDrilldownMakeInformationQuery>;
export type DrilldownMakeInformationLazyQueryHookResult = ReturnType<typeof useDrilldownMakeInformationLazyQuery>;
export type DrilldownMakeInformationQueryResult = Apollo.QueryResult<DrilldownMakeInformationQuery, DrilldownMakeInformationQueryVariables>;
export const DrilldownModelInformationDocument = gql`
    query DrilldownModelInformation($input: VehicleDrilldownInput!) {
  vehiclesDrilldownInformation(input: $input) {
    modelDrilldown {
      modelValue
    }
  }
}
    `;

/**
 * __useDrilldownModelInformationQuery__
 *
 * To run a query within a React component, call `useDrilldownModelInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrilldownModelInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrilldownModelInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDrilldownModelInformationQuery(baseOptions: Apollo.QueryHookOptions<DrilldownModelInformationQuery, DrilldownModelInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrilldownModelInformationQuery, DrilldownModelInformationQueryVariables>(DrilldownModelInformationDocument, options);
      }
export function useDrilldownModelInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrilldownModelInformationQuery, DrilldownModelInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrilldownModelInformationQuery, DrilldownModelInformationQueryVariables>(DrilldownModelInformationDocument, options);
        }
export type DrilldownModelInformationQueryHookResult = ReturnType<typeof useDrilldownModelInformationQuery>;
export type DrilldownModelInformationLazyQueryHookResult = ReturnType<typeof useDrilldownModelInformationLazyQuery>;
export type DrilldownModelInformationQueryResult = Apollo.QueryResult<DrilldownModelInformationQuery, DrilldownModelInformationQueryVariables>;
export const DrilldownTrimInformationDocument = gql`
    query DrilldownTrimInformation($input: VehicleDrilldownInput!) {
  vehiclesDrilldownInformation(input: $input) {
    modelDrilldown {
      trimDrilldown {
        trimValue
      }
    }
  }
}
    `;

/**
 * __useDrilldownTrimInformationQuery__
 *
 * To run a query within a React component, call `useDrilldownTrimInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrilldownTrimInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrilldownTrimInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDrilldownTrimInformationQuery(baseOptions: Apollo.QueryHookOptions<DrilldownTrimInformationQuery, DrilldownTrimInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrilldownTrimInformationQuery, DrilldownTrimInformationQueryVariables>(DrilldownTrimInformationDocument, options);
      }
export function useDrilldownTrimInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrilldownTrimInformationQuery, DrilldownTrimInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrilldownTrimInformationQuery, DrilldownTrimInformationQueryVariables>(DrilldownTrimInformationDocument, options);
        }
export type DrilldownTrimInformationQueryHookResult = ReturnType<typeof useDrilldownTrimInformationQuery>;
export type DrilldownTrimInformationLazyQueryHookResult = ReturnType<typeof useDrilldownTrimInformationLazyQuery>;
export type DrilldownTrimInformationQueryResult = Apollo.QueryResult<DrilldownTrimInformationQuery, DrilldownTrimInformationQueryVariables>;
export const DrilldownStyleInformationDocument = gql`
    query DrilldownStyleInformation($input: VehicleDrilldownInput!) {
  vehiclesDrilldownInformation(input: $input) {
    modelDrilldown {
      trimDrilldown {
        styleDrilldown {
          styleValue
          uvc
        }
      }
    }
  }
}
    `;

/**
 * __useDrilldownStyleInformationQuery__
 *
 * To run a query within a React component, call `useDrilldownStyleInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrilldownStyleInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrilldownStyleInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDrilldownStyleInformationQuery(baseOptions: Apollo.QueryHookOptions<DrilldownStyleInformationQuery, DrilldownStyleInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrilldownStyleInformationQuery, DrilldownStyleInformationQueryVariables>(DrilldownStyleInformationDocument, options);
      }
export function useDrilldownStyleInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrilldownStyleInformationQuery, DrilldownStyleInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrilldownStyleInformationQuery, DrilldownStyleInformationQueryVariables>(DrilldownStyleInformationDocument, options);
        }
export type DrilldownStyleInformationQueryHookResult = ReturnType<typeof useDrilldownStyleInformationQuery>;
export type DrilldownStyleInformationLazyQueryHookResult = ReturnType<typeof useDrilldownStyleInformationLazyQuery>;
export type DrilldownStyleInformationQueryResult = Apollo.QueryResult<DrilldownStyleInformationQuery, DrilldownStyleInformationQueryVariables>;
export const AutocompleteDocument = gql`
    query Autocomplete($searchText: String!) {
  vehiclesAutocomplete(searchText: $searchText) {
    make
    model
    style
    trim
    uvc
    year
  }
}
    `;

/**
 * __useAutocompleteQuery__
 *
 * To run a query within a React component, call `useAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
      }
export function useAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
        }
export type AutocompleteQueryHookResult = ReturnType<typeof useAutocompleteQuery>;
export type AutocompleteLazyQueryHookResult = ReturnType<typeof useAutocompleteLazyQuery>;
export type AutocompleteQueryResult = Apollo.QueryResult<AutocompleteQuery, AutocompleteQueryVariables>;
export const LicensePlateDocument = gql`
    query LicensePlate($input: LicensePlateInput!) {
  vehiclesByLicensePlate(input: $input) {
    make
    model
    style
    trim
    uvc
    year
  }
}
    `;

/**
 * __useLicensePlateQuery__
 *
 * To run a query within a React component, call `useLicensePlateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensePlateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicensePlateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLicensePlateQuery(baseOptions: Apollo.QueryHookOptions<LicensePlateQuery, LicensePlateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicensePlateQuery, LicensePlateQueryVariables>(LicensePlateDocument, options);
      }
export function useLicensePlateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicensePlateQuery, LicensePlateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicensePlateQuery, LicensePlateQueryVariables>(LicensePlateDocument, options);
        }
export type LicensePlateQueryHookResult = ReturnType<typeof useLicensePlateQuery>;
export type LicensePlateLazyQueryHookResult = ReturnType<typeof useLicensePlateLazyQuery>;
export type LicensePlateQueryResult = Apollo.QueryResult<LicensePlateQuery, LicensePlateQueryVariables>;
export const DecodeDocument = gql`
    query Decode($vin: String!) {
  decode(vin: $vin) {
    make
    model
    vin
    styles {
      series
      provider
      styleId
      title
    }
    year
  }
}
    `;

/**
 * __useDecodeQuery__
 *
 * To run a query within a React component, call `useDecodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useDecodeQuery(baseOptions: Apollo.QueryHookOptions<DecodeQuery, DecodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodeQuery, DecodeQueryVariables>(DecodeDocument, options);
      }
export function useDecodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodeQuery, DecodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodeQuery, DecodeQueryVariables>(DecodeDocument, options);
        }
export type DecodeQueryHookResult = ReturnType<typeof useDecodeQuery>;
export type DecodeLazyQueryHookResult = ReturnType<typeof useDecodeLazyQuery>;
export type DecodeQueryResult = Apollo.QueryResult<DecodeQuery, DecodeQueryVariables>;